import { AddmemPage } from './../addmem/addmem.page';
import { DatePipe, formatDate } from '@angular/common';
import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  ViewChildren,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';
import { Router } from '@angular/router';
import {
  AlertController,
  LoadingController,
  ToastController,
  IonInfiniteScroll,
  ModalController,
  PopoverController,
  IonVirtualScroll,
  IonContent,
  Platform,
} from '@ionic/angular';
import { CalendarModalOptions, CalendarComponentOptions, CalendarComponent } from 'ion2-calendar';
import { ServicesProvider } from 'src/providers/services';
import { FileUploadService } from 'src/providers/upload';
import { DatePikerPage } from '../date-piker/date-piker.page';
import { CancelbookingPage } from '../cancelbooking/cancelbooking.page';
import { InViewportMetadata } from 'ng-in-viewport';
import { PopupalertPage } from '../popupalert/popupalert.page';
import { CommonService } from 'src/providers/common';
import { VideoCallService } from 'src/providers/videocall';
import { ReviewPage } from '../review/review.page';
import { TrainerPackageDetPage } from './trainer-package-det/trainer-package-det.page';
import { MediapopupPage } from '../mediapopup/mediapopup.page';
import { ModpricetagPage } from '../modpricetag/modpricetag.page';
import { ViewmodelPage } from '../viewmodel/viewmodel.page';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { Payment } from 'src/providers/payment';
import * as $ from 'jquery';
import { AddCall } from 'src/providers/addvCall';
import { AdvertisementPage } from '../advertisement/advertisement.page';
import { TrainerPopupPage } from './trainer-popup/trainer-popup.page';
import { SuccessPage } from 'src/app/success/success.page';
import { knetPaymentDetailsPage } from '../success/knetPaymentDetails/knetPaymentDetails.page';
import { MediaElementPlayer } from 'mediaelement';
import { PrescriptionpopupPage } from '../prescriptionpopup/prescriptionpopup.page';
import { HttpClient, HttpParams } from '@angular/common/http';
import * as CryptoJS from 'crypto-js';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import * as htmlToPdfmake from 'html-to-pdfmake';
import { File } from '@ionic-native/file/ngx';
import { FileOpener } from '@ionic-native/file-opener/ngx';
// pdfMake.vfs = pdfFonts.pdfMake.vfs;

interface DecryptedMemberContentResponse {
  data: { Terms_and_conditions: string }[];
}
declare var google;
@Component({
  selector: 'app-trainer',
  templateUrl: './trainer.page.html',
  styleUrls: ['./trainer.page.scss'],
})
export class TrainerPage implements OnInit {
  // @ViewChildren('newVdo') vdoPlayer: QueryList<ElementRef>;
  @ViewChild('map', { static: false }) mapElement: ElementRef;
  @ViewChildren('newVdo') vdoPlayer: MediaElementPlayer;

  currentPlaying = null;
  @ViewChild(IonVirtualScroll) virtualScroll: IonVirtualScroll;
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @Output() ChangeEventTrainer = new EventEmitter<string>();
  @Output() ChangeEvent = new EventEmitter<string>();


  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  private fkey = CryptoJS.enc.Hex.parse(
    '00112233445566778899aabbccddeeff00112233445566778899aabbccddeeff'
  );
  private fiv = CryptoJS.enc.Hex.parse('00112233445566778899aabbccddeeff');
  weightCalc: any;
  presentView: string;
  shoAddFilterPopUp: boolean;
  HOC: string;
  CPD: any = [];
  viewOffersSlidsCrds: boolean;
  viewOfferInfo: any;
  selectDate: boolean;
  showWeightCalc: boolean;
  height: string;
  weight: string;
  heiweiType: string;
  thanksPopUp: boolean;
  backValue: string;
  headerValue: string;
  avilblTime: any[];
  showRefundPopUp: boolean;
  playVid: any;
  slctdMemVal: any;
  slctdMemVala: any;
  dateInfo: any;
  date: string;
  year: string;
  month: string;
  day: string;
  profileMediaDetails = [];
  sld = [];
  curntDate: any;
  endtime: string;
  dateRange: {
    from: Date;
    to: Date;
  };
  currentDate;
  length;
  EmptyData: number = 0;
  showoffercard: boolean = false;
  Age: any;
  reviewcomment: any = [];
  isShow: any;
  //-------------API RELATED VARIABLE--------
  storeTrainerList: any = [];
  searchStatus: boolean = false;
  searchContent: any = null;
  filterStatus: boolean = false;
  filterContent: any = null;
  skeletonLoad: any = [];
  storePatclrTnrSomeInfo: any;
  storeTrainerIndex: any;
  particularTrainerDetails: any;
  storeOfferCards: any;
  particulrOfferDetails: any;
  storeOfferCardIndex: any;
  calenderMode: string = null;
  storeToDate: any;
  disableDay: number[];
  storeFromDate: any;
  storeTimeSlots: any;
  SlotId: any;
  storeSelectedSlot: any;
  patientBasicDetails: any;
  BkgConPatientName: any;
  Height: string;
  Weight: string;
  getHeight: any = null;
  getWeight: any = null;
  BMIvalue: any = null;
  heightUnit: string;
  weightUnit: string;
  getGoalWeight: any = null;
  inTakeClsPerDay: any = null;
  durationDays: number;
  cur_date: any;
  BMICategory: string;
  toastMessage: string;
  storeBookingList: any = [];
  particularBkgDetails: any;
  bookingListIndex: any;
  storeBookingId: any;
  historyList: any = [];
  historyDetails: any;
  ReSchBtnValue: any;
  selectDatePageFlow: string;
  repeatBkgData: any;
  trainerName: any;
  trainerAddress: any;
  trainerGender: any;
  packageName: any;
  packageAmnt: any;
  trainerImage: any;
  packageSession: any;
  pageNo: any = 1;
  StoreWayBookingPageFlow: any;
  showVideoOptins: boolean;
  days: any = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  storeWrkDays: any = [];
  getAnyDisease: any = null;
  getAnyMadication: any = null;
  getAnySurgery: any = null;
  getAnyHabits: any = null;
  TrainerRqst: any;
  trMediaReq :any;
  getMemName: any;
  getMemGender: any;
  membDOB: any;
  getMemReletion: any;
  getMemHeight: any;
  getMemWeight: any;
  getMemMobileNo: any;
  getMemDob: any;
  storeFlowValue: any;
  selectedDate: any;
  Date;
  reletionList: any;
  emptyList;
  patientmemberDetails;
  nextcount: any;
  nextcount1: any;
  storeBookingAmnt: any;
  nextcount2: any;
  tr_session: any;
  ScheduleId: any;
  setCalnCurDate: any = new Date();
  getBtwDayslist: { totalDays: any; reminingDays: any; completeddate: any };
  scrollToDate = new Date('2023-01-01');
  myDatePickerOptions = {
    inline: true,
    firstDayOfWeek: 'su',
    sunHighlight: false,
    showTodayBtn: false,
    disableUntil: {
      year: this.setCalnCurDate.getFullYear(),
      month: this.setCalnCurDate.getMonth() + 1,
      day: this.setCalnCurDate.getDate(),
    },
    highlightDates: [{ year: 2021, month: 9, day: 2, },],
  };
  storedPath: null;
  dateRanges: string;

  optionsMultil: CalendarComponentOptions = {
    pickMode: 'multi',
  };

  dateMultil: string[];
  currentMemberId: any;
  remaingDates: string;
  compdates: any;
  myFromDate: Date;
  myToDate: Date;
  chkCrnDate: Date;
  crnDate: number;
  crnYear: number;
  crnMonth: number;
  displayMonth: Date;
  storeDates: any;
  diffDays: number;
  storeRescheduleDate: { fullDate: any; formatedDate: any };
  storeRescheduleAltDate: { fullDate: any; formatedDate: any };
  experience: any;
  vendor_address: any;
  bookSlotBtn: any;
  ViewDataMore: any;
  latitude: any;
  longitude: any;
  tymVal: any;
  addImg: any;
  dynClass: string;
  headerValueCopy: string;
  viewBookingLatLan: string;
  addressValueCopy: string;
  loadershow: boolean = false;
  count: number = 0;
  dblClikedIndex: any; // likedPopUpStatus: boolean;
  likedPopUpStatus: any;
  pack_id: any;
  packdet: any;
  packName: any;
  pack_det: boolean = false;
  tr_pack_det: any;
  mediaReq: any;
  trainerli_ld: string;
  packNameCopy: any;
  cho: any;
  chon: any;
  idexid: any;
  trainerids: any;
  repid: any;
  rep_trainerId: any;
  trainr_id: any;
  traing_id: any;
  reppack: boolean;
  like_status: boolean;
  avail_book: boolean;
  storesltdate: any = [];
  shwsltdates: any = [];
  Email: any;
  Phoneno: any;
  showformated_date: any;
  showsheduledate: any;
  showpro: boolean = false;
  AlertInfoDate: any;
  time: any;
  @Input() typeid;
  @Input() showTypeofBooking;
  trainerbookingId: any;

  activeMonday: any;
  activeTuesday: any;
  activeWednesday: any;
  activeThursday: any;
  activeFriday: any;
  activeSaturday: any;
  activeSunday: any;

  mondayInputArray: any = [];
  tuesdayInputArray: any = [];
  wednesdayInputArray: any = [];
  thursdayInputArray: any = [];
  fridayInputArray: any = [];
  saturdayInputArray: any = [];
  sundayInputArray: any = [];

  reactiveMonday: any;
  reactiveTuesday: any;
  reactiveWednesday: any;
  reactiveThursday: any;
  reactiveFriday: any;
  reactiveSaturday: any;
  reactiveSunday: any;

  remondayInputArray: any = [];
  retuesdayInputArray: any = [];
  rewednesdayInputArray: any = [];
  rethursdayInputArray: any = [];
  refridayInputArray: any = [];
  resaturdayInputArray: any = [];
  resundayInputArray: any = [];
  Addcheckvarible: boolean = true; retotaldaysWeek: any = []; renowWeek: any = []; recheckpresentWeek: any = [];
  isWednesday: any; data: any; indexofWeek: any; forArray: any = [];  presentWeek: any;
  //@Input() typeid; @Input() showTypeofBooking;  payType: any;
  gopayment: boolean = false; payType: any; isRepeatOf: any;  memberAddress: string = '';   isConfirmed : boolean

  medaiDetails: any = []; scrollEvent: any; isSaveChecked: any; trLatitude: any; trLongtitude: any; map: any;
  mycompletedDates: any = []; myRemainDates: any = []; mytobeReschedule: any = []; myRescheduled: any = [];
  mycompletedDatesfor: any = []; myRemainDatesfor: any = []; mytobeReschedulefor: any = []; myRescheduledfor: any = [];
  finalmycompletedDates: any = []; finalmyRemainDatesfor: any = []; finalmytobeReschedulefor: any = []; finalmyRescheduledfor: any = [];
  totalremain: any = []; totalcomplete: any = []; totalTobe: any = []; totalRescheduled: any = [];saveDatesArray: any = [];
  isSave_slect: any; trainerSubscribe : any; LocationIcon:any;
  @ViewChild('myCalendar') myCalendar: CalendarComponent;
  terms_and_condition_file: string; public commonAnd = CommonService;
  latitude_v: any; rescheduleHeaderValue: boolean; disbaleCheck:any;  myScheduleDates: any = [];
  remainSaveSessions: any; saveAvailable: any; isAvailableDatefor: any;
  rescheduledatefrm: any; rescheduledateto: any; storereschtodate: any = []; storereschfromdate: any = []; viewMonth :any;
  totaldaysWeek: any = []; nowWeek: any = []; checkpresentWeek: any = []; changeMonthof: any = []; myScheduleAllDates :any = [];
  AscDscOrder : any;
  constructor(
    public router: Router,
    public alertCtrl: AlertController,
    private services: ServicesProvider,
    public loadingController: LoadingController,
    public toastController: ToastController,
    private datePipe: DatePipe,
    public fileupload: FileUploadService,
    public modalCtrl: ModalController,
    public PopupalertPage: PopupalertPage,
    public videocall: VideoCallService,
    public popoverCtrl: PopoverController,
    private payment: Payment,
    public geolocation: Geolocation,
    public addCall: AddCall,
    private platform: Platform,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private httpClient: HttpClient,
    private file: File,
    private fileOpener: FileOpener
  ) { }
  public common = CommonService;
  option = {
    percent: 75,
    maxPercent: 100,
    startFromZero: false,
    radius: 20,
    outerStrokeWidth: 3,
    outerStrokeColor: 'var(--app-theme)',
    animation: true,
    animationDuration: 500,
    showInnerStroke: false,
    space: -13,
    backgroundStrokeWidth: 3,
    backgroundStroke: '#e8e8e8',
    backgroundPadding: -2,
    showSubtitle: false,
    showUnits: false,
    showTitle: false,
  };
  option1 = {
    percent: 75,
    maxPercent: 100,
    startFromZero: false,
    radius: 20,
    outerStrokeWidth: 3,
    outerStrokeColor: 'var(--app-theme)',
    animation: true,
    animationDuration: 500,
    showInnerStroke: false,
    space: -13,
    backgroundStrokeWidth: 3,
    backgroundStroke: '#e8e8e8',
    backgroundPadding: -2,
    showSubtitle: false,
    showUnits: false,
    showTitle: false,
    clockwise: false,
  };

  //----calender typescript------//
  onDateChanged($event) {
    this.dateInfo = $event;
    let item = this.dateInfo.jsdate;
    let dateArray = String(item).split(' ');
    this.year = dateArray[3];
    this.month = dateArray[1];
    this.day = item.toLocaleString('en-us', { weekday: 'long' });
  }

  scroll() {
    this.content.scrollToTop(500);
  }
  onChange($event) {
    console.log($event);
  }

  dateMulti: string[];
  type: 'string'; // 'string' | 'js-date' | 'moment' | 'time' | 'object'
  optionsMulti: CalendarModalOptions;

  //---------------------------//
  commonheadervalue: string = 'trainerheader';
  ngOnChanges() {
    this.commonheadervalue = 'commonbooking';
    // create header using child_id
    if (this.showTypeofBooking == 'booking' || this.showTypeofBooking == '') {
      this.showBookinkList();
    } else if (this.showTypeofBooking == 'booking hitory') {
      this.showBookingHisList();
    }
  }

  ngOnInit() {
    this.searchContent = '';
    this.bookSlotBtn = false;
    for (let i = 1; i <= 5; i++) {
      this.skeletonLoad.push(i);
    }
    //current date only//
    let date = new Date();
    let day = date.toLocaleString('en-us', { weekday: 'long' });
    this.curntDate = new Date();
    this.curntDate = String(this.curntDate).split(' ');
    this.year = this.curntDate[3];
    this.month = this.curntDate[1];
    this.day = day;
    //--------------------//

    // let options = {
    //   enableHighAccuracy: true,
    //   timeout: 35000
    // };
    // this.geolocation.getCurrentPosition(options).then((resp) => {
    //   // this.LocationIcon = true;
    //   this.latitude = resp.coords.latitude;
    //   this.longitude = resp.coords.longitude;
    //   // this.getDocDetails(1);
    // }, err => {
    //   // this.LocationIcon = false;
    //   this.latitude = 29.62107798734671;
    //   this.longitude = 47.587719496877924;
    //   // this.getDocDetails(1);
    // });
  }

  dob(date) {
    if (date) {
      let d = new Date(date);
      let current = new Date();
      let age = current.getFullYear() - d.getFullYear();
      this.Age = age;
      return age;
    } else {
      return '';
    }
  }

  showHide() {
    if (this.reviewcomment.length > 1) {
      this.isShow = !this.isShow;
    }
  }

  //-----------\/--------PRE DEFINE FUNCTION'S----------\/------------//

  doRefresh(event, page) {
    this.pageNo = 1;
    if (page == 'listTrainer') {
      this.searchContent = null;
      this.resetListTnrVarls();
      this.showListTrainerPage('');
    } else if (page == 'listBookings') {
      this.wayOfBookingListpages(this.StoreWayBookingPageFlow);
    }
    setTimeout(() => {
      event.target.complete();
    }, 2000);
  }
  async presentLoading() {
    const loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: 'Please wait...',
      duration: 1000,
    });
    await loading.present();
  }
  async trainerbookingexplainervideo(vendor_id,menu_id) {
    debugger
    const dietvideo = await this.modalCtrl.create({
      component: ViewmodelPage,
      cssClass: 'trainerhowtobookvideo',
      backdropDismiss: false,
      componentProps: {
        trainerHowToBook : 'TrainerBook',
        vendorid: vendor_id,
        menuid: menu_id,
      },
    });
    await dietvideo.present();
  }
  async trainerreschduelexplainervideo(vendor_id,menu_id) {
    debugger
    const dietvideo = await this.modalCtrl.create({
      component: ViewmodelPage,
      cssClass: 'trainerhowtobookvideo',
      backdropDismiss: false,
      componentProps: {
        vendorid: vendor_id,
        menuid: menu_id,
        rescheduleHeaderName :"RescheduleBooking"
      },
    });
    await dietvideo.present();
  }
  async presentToast() {
    const toast = await this.toastController.create({
      message: this.toastMessage,
      duration: 2000,
      cssClass: 'toastStyle',
    });
    toast.present();
  }

  async AlertInfo(msg, status) {
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert',
      backdropDismiss: false,
      componentProps: {
        msg: msg,
        sts: status,
        dts: this.AlertInfoDate,
      },
    });
    await alert.present();
  }
  async AlertInfoData(msg, status) {
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert_data',
      backdropDismiss: false,
      componentProps: {
        msg: msg,
        sts: status,
      },
    });
    alert.onDidDismiss().then((data) => {
      this.checkData();
    });
    return await alert.present();
  }

  loadData(event, page) {
    this.scrollEvent = event;
    this.pageNo += 1;
    if (page == 'listTrainer') {
      this.showListTrainerPage('');
      if (this.searchContent) {
        this.searchStatus = true;
      }
    } else if (page == 'listBookings') {
      this.showBookinkList();
    } else if (page == 'listBookingHis') {
      this.showBookingHisList();
    }
  }

  //-----------/\--------PRE DEFINE FUNCTION'S----------/\------------//

  //-------------------><-------------><------------------------><--------------------><-----------------------------//

  //-----------------\/-----------SOME SPECIAL FUNCTION'S----------------\/---------------//

  resetListTnrVarls() {
    this.storeTrainerList = [];
    this.pageNo = 1;
  }

  ratingBasedSorting: any;
  ratingBasedSortingOrder: any = 'ASC';

  filterTrainer(filterValue) {
    this.filterStatus = true;
    this.filterContent = filterValue;
  }

  ratingSortOrder: any;
  sortingtrainer(frm, sortorder: any) {
    debugger;
    if(sortorder == 'ASC'){
      this.AscDscOrder = 'ASC'
    }else{
       this.AscDscOrder = 'DESC'
    }
    if (frm == 0) {
      this.ratingBasedSortingOrder = sortorder;
    }
  }

  storecurrentbook: any;
  showcal: boolean = false;

  chooseAvlblSlot(slotId, index) {
    setTimeout(() => {
      this.content.scrollToBottom();
    }, 500);

    this.SlotId = slotId;
    this.storeSelectedSlot = this.storeTimeSlots[index];
    this.showcal = true;

    this.optionsMulti = {
      pickMode: 'single',
      // weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      weekdays: [
        this.addCall.title411,
        this.addCall.title412,
        this.addCall.title413,
        this.addCall.title414,
        this.addCall.title415,
        this.addCall.title416,
        this.addCall.title417,
      ],
      disableWeeks: this.disableDay,
    };
    this.dateRange = null;
  }

  goalCalcToggel() {
    this.showWeightCalc = !this.showWeightCalc;
  }
  selectType(value) {
    this.heiweiType = value;
    this.calculateBMI();
    if (this.heiweiType == 'cmsKgs') {
      this.height = 'Cms';
      this.weight = 'kgs';
    } else {
      this.height = 'Fts';
      this.weight = 'Lbs';
    }
  }
  showTkPopUp() {
    this.thanksPopUp = !this.thanksPopUp;
  }
  showFilterPop() {
    this.shoAddFilterPopUp = !this.shoAddFilterPopUp;
  }

  onIntersection($event, id, index, Sindex) {
    const {
      [InViewportMetadata]: { entry },
      target,
    } = $event;
    const ratio = entry.intersectionRatio;
    const vid = target;
    if (ratio == 1) {
      vid.play();
      this.checkVideo(id, index, Sindex);
      this.storeTrainerList[index].mediaDetails[Sindex].playMode = true;
    } else {
      if ((this.storeTrainerList[index].mediaDetails[Sindex].playMode = true)) {
        vid.pause();
        this.storeTrainerList[index].mediaDetails[Sindex].playMode = false;
      }
    }
  }
  checkVideo(id, index, Sindex) {
    let video = document.getElementById(id);
    let d = this;
    video.onended = function () {
      d.storeTrainerList[index].mediaDetails[Sindex].playMode = false;
    };
  }

  playVideo(index, SIndex, id, value) {
    this.playVid = document.getElementById(id);
    switch (value) {
      case 'play': {
        this.playVid.play();
        this.storeTrainerList[index].mediaDetails[SIndex].playMode = true;
        break;
      }
      case 'pause': {
        this.playVid.pause();
        this.storeTrainerList[index].mediaDetails[SIndex].playMode = false;
        break;
      }
    }
  }
  // showPlyOptn() {
  //   this.showVideoOptins = true;
  //   setTimeout(() => {
  //     this.showVideoOptins = false;
  //   }, 35000);
  // }

  // selectMember(value, membId,item) {

  //   this.getHeight = item.height;
  //   this.getWeight = item.weight;
  //   this.slctdMemVal = value;
  //   this.BkgConPatientName = value;
  //   this.currentMemberId = membId;
  //   this.Age = Number() item.age.split(" ")[0]
  // }

  slctmemname: any;
  patientAddress: any;
  selectMember(data, frm, p_id) {
    this.slctmemname = data.name;

    this.slctdMemVal = frm == 1 ? data.patientId : data.PatientMemberId;
    this.currentMemberId = frm == 1 ? data.patientId : data.PatientMemberId;
    this.getHeight = data.height;
    this.getWeight = data.weight;
    this.Age = Number(frm == 1 ? data.age : data.age.split(' ')[0]);
    this.Phoneno = data.phone_no;
    // email is not sent to the payment so commend the validfation
    // if (frm == 1) {
    //   this.Email = data.email
    // }
    // this.Email = data.email;
    this.calculateBMI();
    this.genderValue = data.gender;
    this.fristinlist_page();
  }

  BMIstatus: any;
  calculateBMI() {
    if (this.heiweiType == 'cmsKgs') {
      this.BMIvalue =
        (Number(this.getWeight) /
          Number(this.getHeight) /
          Number(this.getHeight)) *
        10000;
      this.heightUnit = this.addCall.title195;
      this.weightUnit = this.addCall.title73;
    }
    if (this.heiweiType == 'feetLbs') {
      let lbstokg = this.getWeight * 0.45;
      this.BMIvalue = (lbstokg / this.getHeight) * 2;
      this.heightUnit = this.addCall.title196;
      this.weightUnit = this.addCall.title197;
    }
    this.BMIvalue = this.BMIvalue?.toFixed(2);

    if (this.BMIvalue <= 15) {
      this.BMICategory = 'Very severely underweight';
      this.weightCalc = (18.5 - this.BMIvalue).toFixed(2);
      this.BMIstatus = ' below the BMI';
    } else if (this.BMIvalue >= 15 && this.BMIvalue <= 16) {
      this.BMICategory = 'Severely underweight';
      this.weightCalc = (18.5 - this.BMIvalue).toFixed(2);
      this.BMIstatus = ' below the BMI';
    } else if (this.BMIvalue >= 16 && this.BMIvalue <= 18.5) {
      this.BMICategory = 'Underweight';
      this.weightCalc = (18.5 - this.BMIvalue).toFixed(2);
      this.BMIstatus = ' below the BMI';
    } else if (this.BMIvalue >= 18.5 && this.BMIvalue <= 25) {
      this.BMICategory = 'Normal (healthy weight)';
      this.weightCalc = '';
    } else if (this.BMIvalue >= 25 && this.BMIvalue <= 30) {
      this.BMICategory = 'Overweight';
      this.weightCalc = (this.BMIvalue - 25).toFixed(2);
      this.BMIstatus = this.addCall.title652;
    } else if (this.BMIvalue >= 30 && this.BMIvalue <= 35) {
      this.BMICategory = 'Moderately obese';
      this.weightCalc = (this.BMIvalue - 25).toFixed(2);
      this.BMIstatus = this.addCall.title652;
    } else if (this.BMIvalue >= 35 && this.BMIvalue <= 40) {
      this.BMICategory = 'Severely obese';
      this.weightCalc = (this.BMIvalue - 25).toFixed(2);
      this.BMIstatus = this.addCall.title652;
    } else {
      this.BMICategory = 'Very severely obese';
      this.weightCalc = (this.BMIvalue - 25).toFixed(2);
      this.BMIstatus = this.addCall.title652;
    }
    this.validation();
  }

  goalWei() {
    if (String(this.getGoalWeight).length > 1) {
      if (
        (this.getGoalWeight >= this.getWeight + 4 ||
          this.getGoalWeight <= this.getWeight - 4) &&
        this.heiweiType == 'cmsKgs'
      ) {
        if (this.getGoalWeight >= this.getWeight + 4) {
          this.toastMessage = 'Cannot gain more than 4 kg';
          this.presentToast();
        }
        if (this.getGoalWeight <= this.getWeight - 4) {
          this.toastMessage = 'Cannot loose more  4 kg';
          this.presentToast();
        }
      }
      if (
        (this.getGoalWeight >= this.getWeight + 8.82 ||
          this.getGoalWeight <= this.getWeight - 8.82) &&
        this.heiweiType == 'feetLbs'
      ) {
        if (this.getGoalWeight >= this.getWeight + 8.82) {
          this.toastMessage = 'Cannot gain more than 8.82 Pounds';
          this.presentToast();
        }
        if (this.getGoalWeight <= this.getWeight - 8.82) {
          this.toastMessage = 'Cannot loose more than 8.82 Pounds';
          this.presentToast();
        }
      }
      this.durationDays = 30;
      this.validation();
    }
  }

  changeDays() {
    //((10*70) + (6.25*170) - (5*24) + 5) * 1.2
    this.validation();
  }

  validation() {
    let goalWt = 0;

    if (this.getGoalWeight != null) {
      if (Number(this.getGoalWeight) > Number(this.getWeight)) {
        goalWt = Number(this.getGoalWeight) - Number(this.getWeight);
        let totalCal = 7700 * Number(goalWt);
        let calPerDay = Math.ceil(Number(totalCal) / Number(this.durationDays));
        let calc =
          (10 * Number(this.getWeight) +
            6.25 * Number(this.getHeight) -
            5 * Number(this.Age) +
            5) *
          1.2;
        let maintainCal = Math.ceil(calc);
        this.inTakeClsPerDay = Number(maintainCal) + Number(calPerDay);
      } else if (Number(this.getGoalWeight) < Number(this.getWeight)) {
        goalWt = Number(this.getWeight) - Number(this.getGoalWeight);
        let totalCal = 7700 * Number(goalWt);
        let calPerDay = Math.ceil(Number(totalCal) / Number(this.durationDays));
        let maintainCal = Math.ceil(
          (10 * Number(this.getWeight) +
            6.25 * Number(this.getHeight) -
            5 * Number(this.Age) +
            5) *
          1.2
        );
        if (Number(maintainCal) - Number(calPerDay) < 0) {
          this.inTakeClsPerDay = 0;
        } else {
          this.inTakeClsPerDay = Number(maintainCal) - Number(calPerDay);
        }
      } else {
        this.inTakeClsPerDay = 0;
      }
    } else {
      this.inTakeClsPerDay = 0;
      this.durationDays = 0;
    }
  }

  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return '';
    }

    let Value;
    switch (callFor) {
      case 'Time':
        if (dateTime.indexOf('T') > -1) {
          Value = dateTime.split('T')[1];
        } else if (dateTime.indexOf(' ') > -1) {
          Value = dateTime.split(' ')[1];
        } else {
          Value = dateTime;
        }
        let hourEnd = Value.indexOf(':');
        let H = +String(Value).substr(0, hourEnd);
        let h = H % 12 || 12;
        let ampm = H < 12 || H === 24 ? 'am' : 'pm';
        let timeString = h + String(Value).substr(hourEnd, 3) + ' ' + ampm;
        if (h < 10) {
          timeString = '0' + timeString;
        }

        return timeString;
      case 'Date':
        if (this.addCall.selectedLanguage == 'en') {
          const formattedDate = this.datepipeTransform(
            new Date(dateTime),
            'dd MMM yyyy'
          );
          const formattedDateLowercase = formattedDate
            .replace(/PM/g, 'pm')
            .replace(/AM/g, 'am');
          return formattedDateLowercase;
        } else {
          let dateCall = new Date(dateTime);
          let months = [
            'يناير',
            'فبراير',
            'مارس',
            'إبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
          ];
          let arDate =
            dateCall.getDate() +
            '-' +
            months[dateCall.getMonth()] +
            '-' +
            dateCall.getFullYear();
          return arDate;
        }
      case 'DateTime':
        const formattedDate1 = this.datepipeTransform(
          new Date(dateTime),
          'dd MMM yyyy h:mm a'
        );
        const formattedDateLowercase1 = formattedDate1
          .replace(/PM/g, 'pm')
          .replace(/AM/g, 'am');
        return formattedDateLowercase1;
      case 'Date1':
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), 'dd-MMM-yy');
        } else {
          let dateCall = new Date(dateTime);
          let months = [
            'يناير',
            'فبراير',
            'مارس',
            'إبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
          ];
          let day = String(dateCall.getDate()).padStart(2, '0');
          let arDate = day + '-' + months[dateCall.getMonth()] + '-' + dateCall.getFullYear().toString().substr(-2);
          return arDate;
        }
    }
  }

  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }
  //-----------/\--------------SOME SPECIAL FUNCTION'S------------/\---------//
  isAndroid: any = null;
  isIos: any = null;
  ionViewWillEnter() {
    this.AscDscOrder = "";
    this.storeTrainerList = [];
    this.scrollEvent = null;
    this.isAndroid = null;
    this.isIos = null;
    if (this.platform.is('ios')) {
      this.isIos = 1;
    } else if (this.platform.is('android')) {
      this.isAndroid = 1;
    }
    this.common.videoSound = true;
    console.log(this.common.videoSound, 'VideoSound');

    if (this.platform.is("android")) {
      try {
        let options = {
          enableHighAccuracy: true,
          timeout: 5000
        };
        this.geolocation.getCurrentPosition(options).then((resp) => {
          this.commonAnd.setAndLat(resp.coords.latitude ?? 29.62107798734671);
          this.commonAnd.setAndLong(resp.coords.longitude ?? 47.587719496877924);
        }, err => {
          this.commonAnd.setAndLat(29.62107798734671);
          this.commonAnd.setAndLong(47.587719496877924);
          console.log('Error getting location', err);
        });
      } catch (e) {
        console.log('Speciality page geolocation', e);
      }
    }

    this.tymVal = localStorage.getItem('trainer');
    this.commonheadervalue = 'trainerheader';
    this.presentView = 'listTrainerPage';
    let CD =
      new Date().toISOString().split('T')[0] +
      'T' +
      new Date().toTimeString().split(' ')[0];
    console.log('tymVal -> ', this.tymVal, '\nCD     -> ', CD);
    this.getAdd();
    this.dateMultil = [];
    this.showformated_date =
      new Date().toString().split(' ')[0] +
      ', ' +
      new Date().toString().split(' ')[1] +
      ' ' +
      new Date().toString().split(' ')[2];
    this.deal_serviceid = null;
    this.searchContent = '';
    this.Male = true;
    this.genderValue = 'Male';
    this.storesltdate = [];
    this.pageNo = 1;
    let getDate = new Date();
    this.currentDate =
      getDate.getFullYear() +
      '-' +
      ('0' + (getDate.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + getDate.getDate()).slice(-2);
    this.resetListTnrVarls();
    this.particularTrainerDetails = [];
    switch (localStorage.getItem('NopayGoBack')) {
      case 'newEnter': {
        this.showListTrainerPage('');
        break;
      }
      case 'BookingConPage': {
        this.showBookgConfrPage();
        break;
      }
      default: {
        this.showListTrainerPage('');
      }
    }
    this.getPatientBasicDetails(0);
    this.trainerbookingId = '';

    this.activeMonday = null;
    this.activeTuesday = null;
    this.activeWednesday = null;
    this.activeThursday = null;
    this.activeFriday = null;
    this.activeSaturday = null;
    this.activeSunday = null;

    this.mondayInputArray = [];
    this.tuesdayInputArray = [];
    this.wednesdayInputArray = [];
    this.thursdayInputArray = [];
    this.fridayInputArray = [];
    this.saturdayInputArray = [];
    this.sundayInputArray = [];

    this.forArray = [];
    this.selectedPackageArray = [];
    this.indexofWeek = '';
    this.totaldaysWeek = [];
    this.storeNrOfWeek = [];
    this.medaiDetails = [];
    // Get the current month
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    this.presentMonth = currentMonth;
    this.presentYear = currentDate.getFullYear();
    this.calendarPresentMonth = currentMonth;
    this.representMonth = currentMonth;
    this.representYear = currentDate.getFullYear();
    this.presentWeek = '';
    this.representWeek = '';
    this.theMonthChanged = '';
    this.isRepeatOf = '';
    // if (this.platform.is("android")) {
    //   try {
    //     let options = {
    //       enableHighAccuracy: true,
    //       timeout: 35000
    //     };
    //     this.geolocation.getCurrentPosition(options).then((resp) => {
    //       this.commonAnd.setAndLat(resp.coords.latitude ?? 29.62107798734671);
    //       this.commonAnd.setAndLong(resp.coords.longitude ?? 47.587719496877924);
    //     }, err => {
    //       this.commonAnd.setAndLat(29.62107798734671);
    //       this.commonAnd.setAndLong(47.587719496877924);
    //     });
    //   } catch (e) {
    //   }
    // }

      // let options = {
      //   enableHighAccuracy: true,
      //   timeout: 35000
      // };
      // this.geolocation.getCurrentPosition(options).then((resp) => {
      //   // this.LocationIcon = true;
      //   this.latitude = resp.coords.latitude;
      //   this.longitude = resp.coords.longitude;
      //   // this.getDocDetails(1);
      // }, err => {
      //   // this.LocationIcon = false;
      //   this.latitude = 29.62107798734671;
      //   this.longitude = 47.587719496877924;
      //   // this.getDocDetails(1);
      // });

    this.isSaveChecked = true;
    this.remainSaveSessions = null;
    this.saveAvailable = null;
    this.memberLatLan = "";
    this.patientAddress = "";
    this.memberAddress = ""
    this.isUpdateButton = 0;
  }





  getAdd() {
    try {
      let min = new Date(new Date().setTime(new Date().getTime() + 3600000));
      let CT =
        min.toISOString().split('T')[0] +
        'T' +
        min.toTimeString().split(' ')[0];
      this.tymVal = CT;
      localStorage.setItem('trainer', CT);

      let today = new Date().toISOString().split('T')[0];
      let data = JSON.stringify({
        vendor_type_id: 6,
        current_date: today,
      });
      this.services
        .postRequestGndrl('admin/get_current_advertisement', data)
        .subscribe(
          (res) => {
            if (res.data.length > 0) {
              this.Addcheckvarible = true;
              this.addImg = res.data[0].ad_path_name;
              if (res.data[0].ad_size == '2') {
                this.dynClass = 'advertisement1';
              } else if (res.data[0].ad_size == '1') {
                this.dynClass = 'advertisement2';
              }
              this.openAdvr();
            } else {
              this.Addcheckvarible = false;
              setTimeout(() => {
                this.didScrollEvent(event);
              }, 1000);
            }
            //  else {
            //   this.addImg = '/assets/img/defAdd.png';
            //   this.dynClass = "advertisement1";
            //   this.openAdvr();
            // }
          },
          (err) => {
            console.log(err);
          }
        );
    } catch (err) {
      console.log(err);
    }
  }
  async openAdvr() {
    window.localStorage['addType'] = 2;
    let popover = await this.modalCtrl.create({
      component: AdvertisementPage,
      componentProps: {
        addImg: this.addImg,
      },
      cssClass: this.dynClass,
    });
    popover.onDidDismiss().then((data) => {
      this.Addcheckvarible = false;
      if (!this.Addcheckvarible) {
        this.didScrollEvent(event);
      }
    });
    return await popover.present();
  }
  selectmemberpage() {
    this.heiweiType = 'cmsKgs';
    this.height = 'Cms';
    this.weight = 'kgs';
    this.presentView = 'selectmember';
    this.headerValue = this.addCall.title175;
    this.getPatientBasicDetails(0);
  }

  fristinlist_page() {
    switch (localStorage.getItem('NopayGoBack')) {
      case 'newEnter': {
        this.showListTrainerPage('');
        setTimeout(() => {
          this.content.scrollToTop();
        }, 500);
        break;
      }
      case 'BookingConPage': {
        this.showBookgConfrPage();
        break;
      }
      default: {
        this.showListTrainerPage('');
      }
    }
  }
  Videobruff(el) {
    return true;
  }

  ionViewDidLeave() {
    const inViewPort = this.vdoPlayer.find((player) =>
      this.Videobruff(player.nativeElement)
    );
    if (inViewPort) {
      inViewPort.nativeElement.pause();
    }
    this.didScrollEvent('leave');
    this.common.videoSound = false;
    if (this.currentPlaying) {
      this.currentPlaying.muted = true;
      this.currentPlaying?.pause();
      this.currentPlaying = null;
    }
    this.pageNo = 1;
    this.dateMultil = [];
    this.storeNrOfWeek = [];
    setTimeout(() => {
      this.didScrollEvent('leave');
      this.common.videoSound = false;
      if (this.currentPlaying) {
        this.currentPlaying.muted = true;
        this.currentPlaying?.pause();
        this.currentPlaying = null;
      }
    }, 500);
  }
  // ionViewWillLeave() {
  //   this.pageNo = 1;
  //   this.common.videoSound = false;
  //   this.currentPlaying.muted = true;
  //   this.storeTrainerList = [];
  //   this.currentPlaying?.pause();
  //   this.currentPlaying = null;
  //   this.dateMultil = [];
  //   this.storeNrOfWeek = [];
  // }

  getTrainerMediaDetails() {
    let apiData = JSON.stringify({
      patientId: localStorage.getItem('patient_id'),
    });
    this.services.postRequest1('getTrainerMedia', apiData).subscribe((res) => {
      this.medaiDetails = [];
      for (let item of res.data) {
        if(item != undefined){
          item.playMode = false;
          this.medaiDetails.push(item);
        }
      }
    });
  }

  apiDataof: any;
  memberLatLan: any;

  async showListTrainerPage(page) {
    this.isAndroid = null;
    this.isIos = null;
    if (this.platform.is('ios')) {
      this.isIos = 1;
    } else if (this.platform.is('android')) {
      this.isAndroid = 1;
    }
  this.loadershow = true;
   let apiData = JSON.stringify({
    patientId: localStorage.getItem('patient_id'),
  });

  if (this.trMediaReq) {
    this.trMediaReq.unsubscribe();
  }
  this.trMediaReq = this.services.postRequest1('getTrainerMedia', apiData).subscribe(async (res) => {
    this.medaiDetails = [];
    if(res.status == 1 || res.status == 0){
      for (let item of res.data) {
        item.playMode = false;
        this.medaiDetails.push(item);
      }


    if (page != 'repeat') {
      this.presentView = 'listTrainerPage';
    }
    if (page == 'advfiliter') {
      this.searchContent = '';
    }

    this.shoAddFilterPopUp = false;
    this.showWeightCalc = false;
    this.isRepeatOf = '';
    this.heiweiType = 'cmsKgs';
    this.height = 'Cms';
    this.weight = 'kgs';
    this.thanksPopUp = false;
    this.backValue = 'goHome';
    this.headerValue = 'Trainer';

    this.nextcount = 0;
    if (this.pageNo == 1) {
      this.emptyList = null;
      this.storeTrainerList = [];
    }

    // this.geolocation.getCurrentPosition({
    //   enableHighAccuracy: true,
    //   timeout: 35000,
    // }).then((resp) => {
      // if (this.TrainerRqst) {
      //   this.TrainerRqst.unsubscribe();
      // }
      // this.latitude = resp.coords.latitude;
      // this.longitude = resp.coords.longitude;
      // this.latitude = 29.62107798734671;
      // this.longitude = 47.587719496877924;


      let options = {
        enableHighAccuracy: true,
        timeout: 35000
      };
      await this.geolocation.getCurrentPosition(options).then((resp) => {
        this.LocationIcon = true;
        this.latitude = resp.coords.latitude;
        this.longitude = resp.coords.longitude;
      }, err => {
        this.LocationIcon = false;
        this.latitude = 29.62107798734671;
        this.longitude = 47.587719496877924;
        console.log('Error getting location', err);
      });
      if( this.latitude == undefined || this.longitude == undefined){
        this.latitude = 29.62107798734671;
        this.longitude = 47.587719496877924;
      }

      this.apiDataof = "";

      if (this.isIos == 1) {
        this.memberLatLan = this.latitude + "," + this.longitude;
        this.apiDataof = JSON.stringify({
          pageno: this.pageNo,
          limit: 40,
          filter: this.filterStatus,
          modeId: this.filterContent,
          typeSearch: this.searchContent == null ? (this.searchStatus = false) : this.searchStatus,
          searchContent: this.searchContent,
          currentDate: this.currentDate,
          patientId: localStorage.getItem('patient_id'),
          // "Trainergender": localStorage.getItem('Gender'),//this.genderValue,
          Trainergender: localStorage.getItem('Gender').toUpperCase(), //this.genderValue,
          ratingBasedSortingOrder: this.ratingBasedSortingOrder,
          // "lat": 29.62107798734671,//this.latitude,
          // "long": 47.587719496877924,//this.longitude,
          lat: this.latitude,
          long: this.longitude,
        });
      } else if (this.isAndroid == 1) {
        // const lat = this.commonAnd.androidLatitude ?? 29.62107798734671;
        // const long = this.commonAnd.androidLongitude ?? 47.587719496877924;
        const lat = this.latitude;
        const long = this.longitude;
        this.memberLatLan = lat + "," + long;

        this.apiDataof = JSON.stringify({
          pageno: this.pageNo,
          limit: 40,
          filter: this.filterStatus,
          modeId: this.filterContent,
          typeSearch: this.searchContent == null ? (this.searchStatus = false) : this.searchStatus,
          searchContent: this.searchContent,
          currentDate: this.currentDate,
          patientId: localStorage.getItem('patient_id'),
          Trainergender: localStorage.getItem('Gender').toUpperCase(), //this.genderValue,
          ratingBasedSortingOrder: this.ratingBasedSortingOrder,
          lat:this.latitude,
          long: this.longitude,
          //lat: this.commonAnd.androidLatitude ?? 29.62107798734671,
          //long: this.commonAnd.androidLongitude ?? 47.587719496877924,
        });
      } else {
        this.apiDataof = JSON.stringify({
          pageno: this.pageNo,
          limit: 40,
          filter: this.filterStatus,
          modeId: this.filterContent,
          typeSearch: this.searchContent == null ? (this.searchStatus = false) : this.searchStatus,
          searchContent: this.searchContent,
          currentDate: this.currentDate,
          patientId: localStorage.getItem('patient_id'),
          Trainergender: localStorage.getItem('Gender').toUpperCase(), //this.genderValue,
          ratingBasedSortingOrder: this.ratingBasedSortingOrder,
          lat: this.latitude,
          long:this.longitude,
          // lat: this.commonAnd.androidLatitude ?? 29.62107798734671,
          // long: this.commonAnd.androidLongitude ?? 47.587719496877924,
        });
      }
      if (this.TrainerRqst) {
        this.TrainerRqst.unsubscribe();
      }
      this.TrainerRqst = this.services.postRequest1('patientTrainerSearch', this.apiDataof).subscribe(async (res) => {

        this.repid = res.data[0]?.details[0]?.tr_training_category_id;
        this.nextcount = res?.data.length > 0 ? res?.data[0]?.nextCount : 0;
        if (this.pageNo == 1) {
          this.emptyList = res.data[0]?.details.length;
        }
        if (this.TrainerRqst) {
          this.TrainerRqst.unsubscribe();
        }
        let time = 0;
        if (res.status == 1 && res.data[0]?.details.length > 0) {
        // if (res.status == 1 && res.data[0].details.length > 0) {
          for (let i = 0; i < res.data[0].details.length; i++) {
            if(res.data[0].details[i] != undefined){
              let data = {
                "trainerId":res.data[0].details[i].trainerId,
                "patientId":localStorage.getItem('patient_id')
              }
              await this.services.postRequest1('getPatientTrainerDeal',data).subscribe(async(response)=>{
               console.log("car",this.medaiDetails.filter((element) => element.media_vendor_id == 982
             ))
                res.data[0].details[i].dealsDetails = response.data.dealsDetails;
                time ++;
                if (res.data[0].details.length == time) {
                  if (res.status == 1) {
                    if (this.pageNo != 1) {
                      for (let item of res.data[0].details) {
                        if(item != undefined){
                          item.mediaDetails = this.medaiDetails.filter((element) => element.media_vendor_id == item.trainerId &&
                          element.media_sortorder == 1
                        );
                        this.storeTrainerList.push(item);
                        }
                      }

                      for (let j = 0; j < this.storeTrainerList.length; j++) {
                        if (this.storeTrainerList[j].dealsDetails.length == 0) {
                          this.storeTrainerList[j].dealsData = [];
                        } else {
                          let trlist = this.storeTrainerList[j].dealsDetails.filter(
                            (element) => element.deal == 'nodeal'
                          );
                          if (trlist.length == this.storeTrainerList[j].dealsDetails.length) {
                            this.storeTrainerList[j].dealsData = [];
                          } else {
                            for (let i = 0; i < this.storeTrainerList[j].dealsDetails.length; i++) {
                              if (this.storeTrainerList[j].dealsDetails[i].isBooked == 0 || this.storeTrainerList[j].dealsDetails[i].isBooked == 1) {
                                if (this.storeTrainerList[j].dealsData == undefined) {
                                  this.storeTrainerList[j].dealsData = [this.storeTrainerList[j].dealsDetails[i],];
                                } else {
                                  this.storeTrainerList[j].dealsData.push(this.storeTrainerList[j].dealsDetails[i]);
                                }
                              }
                            }
                          }
                        }
                      }
                    } else {
                      if (this.pageNo == 1) {
                        this.storeTrainerList = [];
                      }
                      for (let item of res.data[0].details) {
                        if(item != undefined){
                          item.mediaDetails = this.medaiDetails.filter((element) => element.media_vendor_id == item.trainerId &&
                          element.media_sortorder == 1
                        );
                        this.storeTrainerList.push(item);
                        }
                      }
                      for (let j = 0; j < this.storeTrainerList.length; j++) {
                        if (this.storeTrainerList[j].dealsDetails.length == 0) {
                          this.storeTrainerList[j].dealsData = [];
                        } else {
                          let trlist = this.storeTrainerList[j].dealsDetails.filter((element) => element.deal == 'nodeal');
                          if (trlist.length == this.storeTrainerList[j].dealsDetails.length) {
                            this.storeTrainerList[j].dealsData = [];
                          } else {
                            for (let i = 0; i < this.storeTrainerList[j].dealsDetails.length; i++) {
                              if (this.storeTrainerList[j].dealsDetails[i].isBooked == 0 ||
                                this.storeTrainerList[j].dealsDetails[i].isBooked == 1) {
                                if (this.storeTrainerList[j].dealsData == undefined) {
                                  this.storeTrainerList[j].dealsData = [
                                    this.storeTrainerList[j].dealsDetails[i],
                                  ];
                                } else {
                                  this.storeTrainerList[j].dealsData.push(
                                    this.storeTrainerList[j].dealsDetails[i]
                                  );
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                    this.loadershow = false;
                  } else if (res.status == 0) {
                    this.loadershow = false;
                  }
                }
              })
            }
          }
          if (this.common.videoSound) {
            let _obj = this;
            const interval = setInterval(() => {
              _obj.currentPlaying = null;
              if (_obj.vdoPlayer) {
                this.didScrollEvent(event);
                clearInterval(interval);
              }
            }, 0);
          }
        }else {
          this.loadershow = false;
        }
        // if (this.common.videoSound) {
        //   let _obj = this;
        //   const interval = setInterval(() => {
        //     _obj.currentPlaying = null;
        //     if (_obj.vdoPlayer) {
        //       this.didScrollEvent(event);
        //       clearInterval(interval);
        //     }
        //   }, 0);
        // }
      });
    this.searchStatus = true;
    this.filterStatus = false;

    }

  });
  }

  searchTrainer() {
    debugger
    this.pageNo = 1;
    this.searchStatus = true;
    if (this.searchContent.length > 0) {
      this.showListTrainerPage('');
    }
  }

  distance: any;
  showTrainerProfile(index, tr_trainer_id) {
    this.AscDscOrder = "";
    this.showpro = false;
    this.EmptyData = 0;
    this.reppack = false;
    this.avail_book = false;
    this.idexid = index;
    this.getMedia(tr_trainer_id);
    this.presentView = 'trainerdetailpart';
    this.pack_det = false;
    this.storeTrainerIndex = index;
    this.viewOffersSlidsCrds = true;
    this.viewOfferInfo = false;
    this.selectDate = false;
    this.backValue = 'goTrainersPage';
    this.storePatclrTnrSomeInfo = this.storeTrainerList[index];

    this.trainerids = this.storePatclrTnrSomeInfo.trainerId;
    this.trainerAddress = this.storePatclrTnrSomeInfo.vendor_location;
    this.trainerGender = this.storePatclrTnrSomeInfo.vendor_contact_gender;
    this.trainerName = this.storePatclrTnrSomeInfo.vendor_name;
    this.headerValue = this.storePatclrTnrSomeInfo.vendor_name;
    this.trainr_id = this.storePatclrTnrSomeInfo.trainerId;
    this.traing_id = this.storePatclrTnrSomeInfo.tr_training_category_id; //tr_training_id;
    this.distance = this.storePatclrTnrSomeInfo.Distance;

    this.getoff('');
  }
  homeArray: any = [];
  onlineArray: any = [];
  centerArray: any = [];

  isHomeTr_mode: any;
  isOnlineTr_mode: any;
  isCenterTr_mode: any;

  getoff(page) {
    this.particularTrainerDetails = [];

    this.isHomeTr_mode = null;
    this.isOnlineTr_mode = null;
    this.isCenterTr_mode = null;

    this.homeArray = [];
    this.onlineArray = [];
    this.centerArray = [];

    let apiData = JSON.stringify({
      trainerId: this.trainr_id,
      trainingId: this.traing_id,
      currentDate: this.currentDate,
      patientId: localStorage.getItem('patient_id'),
    });

    this.services
      .postRequest1('getParticularTrainerDetailsNew', apiData)
      .subscribe(async (res) => {
        if (res.status == 1) {
          let newData = {
            TrainerId: this.trainr_id,
            patientId: localStorage.getItem('patient_id'),
          };
          this.services
            .postRequest1('getTraining_mode_check', newData)
            .subscribe((response) => {
              //home
              if (response.data1.length == 0) {
                this.isHomeTr_mode = 0;
              } else {
                let homeData = [];
                homeData = response.data1.filter((item) => item.pack_Avaliable != 0 && item.sessions_Available != 0 &&
                  item.home_Available != 0);
                if (homeData.length != 0) {
                  this.isHomeTr_mode = 1;
                } else {
                  this.isHomeTr_mode = 0;
                }
              }
              //online
              if (response.data2.length == 0) {
                this.isOnlineTr_mode = 0;
              } else {
                let onlineData = [];
                onlineData = response.data2.filter(
                  (item) => item.isBooked != 0 && item.pack_Avaliable != 0 && item.sessions_Available != 0);
                if (onlineData.length != 0) {
                  this.isOnlineTr_mode = 1;
                } else {
                  this.isOnlineTr_mode = 0;
                }
              }
              //center
              if (response.data3.length == 0) {
                this.isCenterTr_mode = 0;
              } else {
                let centerData = [];
                centerData = response.data3.filter(
                  (item) => item.isBooked != 0 && item.pack_Avaliable != 0 && item.sessions_Available != 0);
                if (centerData.length != 0) {
                  this.isCenterTr_mode = 1;
                } else {
                  this.isCenterTr_mode = 0;
                }
              }
            });
        }
        this.isShowHeaderValue = true;
        this.commonheadervalue = 'listTrainerPage';
        this.showpro = true;
        this.EmptyData = res.status;
        this.particularTrainerDetails = res.data[0];
        const currentDate = new Date();

        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0'); // Month is zero-based, so add 1 and format with leading zero
        const day = String(currentDate.getDate()).padStart(2, '0'); // Format with leading zero

        const formattedDate = `${year}-${month}-${day}`;
        this.trainerImage = this.particularTrainerDetails.vendor_profile_path;
        this.HOC = 'homeList';
        this.experience = this.particularTrainerDetails.experience;
        this.vendor_address = this.particularTrainerDetails.vendor_address;
        if (this.vendor_address.length > 10) {
          this.vendor_address = this.vendor_address.substring(0, 10) + ' ...';
        }
        this.reviewcomment = JSON.parse(
          this.particularTrainerDetails.review_comment,
        );

        this.isShow = true;
        this.showoffercard = false;

        if (this.deal_serviceid) {
          let programs = this.particularTrainerDetails.programList[0];
          let proarray = [];
          Object.values(programs).forEach((val) =>
            Object.values(val).forEach((prodetails) => {
              proarray.push(prodetails);
              let f_pro = proarray.find(
                (item) => item.dealserviceid == this.deal_serviceid
              );
              this.package_detail(f_pro, 'homeList', '');
            })
          );
        }
        if (this.particularTrainerDetails.programList) {
          this.storeOfferCards =
            this.particularTrainerDetails.programList[0]?.homeList;
        }

        if (page == 'repeat') {
          if (this.repeatBkgData.training_mode == '1') {
            this.chon = 'homeList';
          }
          if (this.repeatBkgData.training_mode == '2') {
            this.chon = 'onlineList';
          }
          if (this.repeatBkgData.training_mode == '3') {
            this.chon = 'centerList';
          }
          this.reppack = true;

          let obj1 = this.particularTrainerDetails.programList[0][
            this.chon
          ].filter(
            (item) => item.tr_package_id == this.repeatBkgData.tr_package_id
          );

          this.package_detail(obj1[0], this.chon, '');
        }
      });
  }
  openOffInfo(index) {
    this.storeOfferCardIndex = index;
    this.presentView = 'trainerProPage';
    this.viewOffersSlidsCrds = false;
    this.viewOfferInfo = true;
    this.selectDate = false;
    this.backValue = 'goOffers';
    this.headerValue = this.storePatclrTnrSomeInfo.vendor_name;
    this.particulrOfferDetails = this.storeOfferCards[index];
    this.packageName = this.particulrOfferDetails.tr_package_name;
    this.packageAmnt = this.particulrOfferDetails.tr_cost;
    this.packageSession = this.particulrOfferDetails.tr_session;

    this.showoffercard = false;
  }
  showSelectDate1(data: any, PageFlow, packd) {
    this.selectDatePageFlow = PageFlow;

    this.dateRange = null;
    this.storeFromDate = null;
    this.storeToDate = null;
    this.SlotId = null;
    this.storeSelectedSlot = null;
    this.viewOffersSlidsCrds = false;
    this.viewOfferInfo = false;
    this.selectDate = true;
    this.clupWorkingHr(data);
    this.optionsMulti = {
      pickMode: 'single',
      // weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      weekdays: [
        this.addCall.title411,
        this.addCall.title412,
        this.addCall.title413,
        this.addCall.title414,
        this.addCall.title415,
        this.addCall.title416,
        this.addCall.title417,
      ],
      disableWeeks: this.disableDay,
    };
    if (this.selectDatePageFlow != 'repeat') {
      this.tr_session = packd.tr_session;
      this.ScheduleId = packd.appointmentScheduleId;
    } else if (this.selectDatePageFlow == 'repeat') {
      this.presentView = 'trainerdetailpart';
      this.tr_session = packd.tr_session;
      this.ScheduleId = packd.appointment_id;
    }
  }
  showSelectDate(PageFlow) {
    this.selectDatePageFlow = PageFlow;
    this.presentView = 'trainerProPage';
    this.dateRange = null;
    this.storeFromDate = null;
    this.storeToDate = null;
    this.SlotId = null;
    this.storeTimeSlots = null;
    this.storeSelectedSlot = null;
    this.viewOffersSlidsCrds = false;
    this.viewOfferInfo = false;
    this.selectDate = true;
    this.clupWorkingHr(this.particulrOfferDetails.programDays);
    this.optionsMulti = {
      pickMode: 'single',
      // weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      weekdays: [
        this.addCall.title411,
        this.addCall.title412,
        this.addCall.title413,
        this.addCall.title414,
        this.addCall.title415,
        this.addCall.title416,
        this.addCall.title417,
      ],
      disableWeeks: this.disableDay,
    };
    if (this.selectDatePageFlow != 'repeat') {
      this.headerValue = this.particulrOfferDetails.tr_package_name;
      this.tr_session = this.particulrOfferDetails.tr_session;
      this.ScheduleId = this.particulrOfferDetails.appointmentScheduleId;
      this.backValue = 'goOfferInfo';
    } else if (this.selectDatePageFlow == 'repeat') {
      this.headerValue = this.repeatBkgData.tr_package_name;
      this.tr_session = this.repeatBkgData.tr_session;
      this.ScheduleId = this.repeatBkgData.appointment_id;
      this.backValue = 'goBkgHisList';
    }
  }
  selecteddates: any;
  autoSetToDate(days, fromDate) {
    let date = null;
    this.storeToDate = null;
    let fillDate = [];
    date = new Date(fromDate);
    if (days != 0) {
      this.storeToDate = new Date(
        new Date(fromDate).setDate(new Date(fromDate).getDate())
      );
      date.setDate(date.getDate() - 1);
      for (let i = 1; i <= 1000; i++) {
        date.setDate(date.getDate() + 1);

        if (!this.disableDay.includes(date.getDay())) {
          fillDate.push(new Date(date));
          let rangday = [];
          rangday = fillDate;
          let d = [];
          rangday.forEach((date) => {
            let d1 = new Date(date);
            d.push(d1.setDate(d1.getDate() + 1));
          });
          let d2 = [];
          let changeformat = [];
          d.forEach((date) => {
            d2.push(new Date(date).toISOString().split('T')[0]);
          });

          this.selecteddates = d2;
        }
        if (fillDate.length == days) {
          this.storeToDate = fillDate[fillDate.length - 1];

          break;
        }
      }
    } else {
      this.storeToDate = fillDate[fillDate.length - 1];
      this.storeFromDate = new Date(fromDate);
      this.storeToDate = new Date(fromDate);
    }
    this.getavalslots();
  }

  showsltdate: any = [];
  getavalslots() {
    this.presentLoading();
    this.shwsltdates = [];
    const format = 'yyyy-MM-dd';
    const myDate = new Date();
    const locale = 'en-US';
    const formattedDate = formatDate(myDate, format, locale);
    if (this.selecteddates[0] == formattedDate) {
      if (
        this.storeSelectedSlot.fromTime >=
        new Date().toTimeString().split(' ')[0]
      ) {
        this.bookSlotBtn = false;
        let apidata = JSON.stringify({
          trainerId: this.tr_pack_det.tr_vendor_id,
          slot_time: this.storeSelectedSlot.fromTime,
          selected_days: this.selecteddates,
          packageId: this.tr_pack_det.tr_package_id,
          patient_id: localStorage.getItem('patient_id'),
        });
        this.services
          .postRequest1('getTrainerSlotStatus', apidata)
          .subscribe(async (res) => {
            setTimeout(() => {
              this.loadingController.dismiss();
            }, 500);
            this.selecteddates = [];
            let avalslot = [];
            this.showsltdate = [];

            res.data.slotStatus.forEach((a) => {
              if (a.bookedStatus == 'false') {
                avalslot.push(a.date);
              }
            });

            res.data.nextAvailableSlots.forEach((element) => {
              avalslot.push(element);
            });

            let ordersletdates = avalslot.sort(
              (a, b) => Date.parse(a) - Date.parse(b)
            );

            if (res.data.nextAvailableSlots.length > 0) {
              this.AlertInfoDate = this.getFormattedDateTime(
                ordersletdates[0],
                'Date1'
              );
              this.AlertInfoData(this.addCall.title445, 2);
            }

            this.selecteddates = ordersletdates;
            this.selecteddates.forEach((item) => {
              this.showsltdate.push(this.getFormattedDateTime(item, 'Date1'));
            });
            this.shwsltdates = this.showsltdate.slice(0, 3).join(', ');
            if (this.shwsltdates.length > 21) {
              this.shwsltdates = this.shwsltdates.substring(0, 21) + ', ...';
            }
            getMonthDifference(
              new Date(this.showsltdate[0]),
              new Date(this.showsltdate[this.showsltdate.length - 1])
            );
            this.dateRange = this.selecteddates;

            function getMonthDifference(startDate, endDate) {
              let monthdiff =
                endDate.getMonth() -
                startDate.getMonth() +
                12 * (endDate.getFullYear() - startDate.getFullYear());

              for (let i = 1; i <= monthdiff; i++) {
                setTimeout(() => {
                  $('.forward').trigger('click');
                }, 1000);
              }
            }

            this.optionsMulti = {
              pickMode: 'multi',
              // weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
              weekdays: [
                this.addCall.title411,
                this.addCall.title412,
                this.addCall.title413,
                this.addCall.title414,
                this.addCall.title415,
                this.addCall.title416,
                this.addCall.title417,
              ],
              disableWeeks: this.disableDay,
            };
          });
      } else {
        setTimeout(() => {
          this.loadingController.dismiss();
        }, 100);
        this.bookSlotBtn = true;
        this.AlertInfoData(
          'Session not available for current date. Please select the next available date.',
          2
        );
      }
    } else {
      this.bookSlotBtn = false;
      let apidata = JSON.stringify({
        trainerId: this.tr_pack_det.tr_vendor_id,
        slot_time: this.storeSelectedSlot.fromTime,
        selected_days: this.selecteddates,
        packageId: this.tr_pack_det.tr_package_id,
        patient_id: localStorage.getItem('patient_id'),
      });
      this.services
        .postRequest1('getTrainerSlotStatus', apidata)
        .subscribe(async (res) => {
          setTimeout(() => {
            this.loadingController.dismiss();
          }, 500);
          this.selecteddates = [];
          let avalslot = [];
          this.showsltdate = [];

          res.data.slotStatus.forEach((a) => {
            if (a.bookedStatus == 'false') {
              avalslot.push(a.date);
            }
          });

          res.data.nextAvailableSlots.forEach((element) => {
            avalslot.push(element);
          });

          let ordersletdates = avalslot.sort(
            (a, b) => Date.parse(a) - Date.parse(b)
          );

          if (res.data.nextAvailableSlots.length > 0) {
            this.AlertInfoDate = this.getFormattedDateTime(
              ordersletdates[0],
              'Date1'
            );
            this.AlertInfoData(this.addCall.title445, 2);
          }

          this.selecteddates = ordersletdates;
          this.selecteddates.forEach((item) => {
            this.showsltdate.push(this.getFormattedDateTime(item, 'Date1'));
          });
          this.shwsltdates = this.showsltdate.slice(0, 3).join(', ');
          if (this.shwsltdates.length > 21) {
            this.shwsltdates = this.shwsltdates.substring(0, 21) + ', ...';
          }
          getMonthDifference(
            new Date(this.showsltdate[0]),
            new Date(this.showsltdate[this.showsltdate.length - 1])
          );
          this.dateRange = this.selecteddates;

          function getMonthDifference(startDate, endDate) {
            let monthdiff =
              endDate.getMonth() -
              startDate.getMonth() +
              12 * (endDate.getFullYear() - startDate.getFullYear());

            for (let i = 1; i <= monthdiff; i++) {
              setTimeout(() => {
                $('.forward').trigger('click');
              }, 1000);
            }
          }

          this.optionsMulti = {
            pickMode: 'multi',
            // weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
            weekdays: [
              this.addCall.title411,
              this.addCall.title412,
              this.addCall.title413,
              this.addCall.title414,
              this.addCall.title415,
              this.addCall.title416,
              this.addCall.title417,
            ],
            disableWeeks: this.disableDay,
          };
        });
      // }
    }
  }
  checkData() {
    this.dateRange = null;
  }
  async presentToasting(res: any) {
    const toast = await this.toastController.create({
      message: res,
      duration: 1000,
    });
    toast.present();
  }
  autoSetToDate1(days, fromDate) {
    this.storeToDate = null;
    let fillDate = [];
    if (days != 1) {
      let daysCount = Number(days) + this.disableDay.length - 1;
      console.log(
        new Date(
          new Date(fromDate).setDate(new Date(fromDate).getDate() + daysCount)
        )
      );
      this.storeToDate = new Date(
        new Date(fromDate).setDate(new Date(fromDate).getDate())
      );
    } else {
      this.storeToDate = fillDate[fillDate.length - 1];
      this.storeFromDate = new Date(fromDate);
      this.storeToDate = new Date(fromDate);
    }
  }


  async changecalmode1(event) {
    this.optionsMulti = {
      pickMode: 'multi',
    };
    setTimeout(() => {
      this.optionsMulti = {
        pickMode: 'range',
      };
      this.storeToDate = new Date(
        new Date(event.time).setDate(
          new Date(event.time).getDate() + (this.tr_session - 1)
        )
      );
      this.dateRange = {
        from: new Date(event.time),
        to: this.storeToDate,
      };

      this.dateInfo = event;
      let item = this.dateInfo.time;

      let convertstr = new Date(item).toDateString();
      let dateArray = convertstr.split(' ');
      const options: Intl.DateTimeFormatOptions = {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      };
      this.year = dateArray[3];
      this.month = dateArray[1];
      this.day = new Intl.DateTimeFormat('en-GB', options)
        .format(item)
        .split(',')[0];
      this.storeFromDate = this.dateRange.from;
      this.storeToDate = this.dateRange.to;
    }, 20);
  }
  daysinweek: any = [];
  adddisabledaycount: any;

  async changecalmode(event) {
    this.selecteddates;
    let item = new Date(event.time);
    this.autoSetToDate(this.tr_session, item);

    this.daysinweek = [];
    let weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

    this.disableDay.forEach((item) => {
      this.daysinweek.push(weekdays[item]);
    });

    this.optionsMulti = {
      pickMode: 'single',
      // weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      weekdays: [
        this.addCall.title411,
        this.addCall.title412,
        this.addCall.title413,
        this.addCall.title414,
        this.addCall.title415,
        this.addCall.title416,
        this.addCall.title417,
      ],
      disableWeeks: this.disableDay,
    };

    setTimeout(() => {
      let date1 = new Date(event.time);
      let duration = this.tr_session;
      for (let i = 0; i < Number(duration); i++) {
        let day = String(date1).substring(0, 3);

        if (this.daysinweek.includes(day)) {
          duration++;
        }
        date1.setDate(date1.getDate() + 1);
      }

      this.storeToDate = new Date(
        new Date(event.time).setDate(
          new Date(event.time).getDate() + duration - 1
        )
      );
      this.dateRange = {
        from: new Date(event.time),
        to: this.storeToDate,
      };
      this.dateInfo = event;
      let item = this.dateInfo.time;
      let convertstr = new Date(item).toDateString();
      let dateArray = convertstr.split(' ');
      const options: Intl.DateTimeFormatOptions = {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      };
      this.year = dateArray[3];
      this.month = dateArray[1];
      this.day = new Intl.DateTimeFormat('en-GB', options)
        .format(item)
        .split(',')[0];
      this.storeFromDate = this.dateRange.from;
      this.storeToDate = this.dateRange.to;
      this.showformated_date =
        this.storeFromDate.toString().split(' ')[0] +
        ', ' +
        this.storeFromDate.toString().split(' ')[1] +
        ' ' +
        this.storeFromDate.toString().split(' ')[2];

      for (
        let storedate = new Date(this.storeFromDate);
        storedate <= new Date(this.storeToDate);
        storedate.setDate(storedate.getDate() + 1)
      ) {
        let curday = new Date(storedate).toLocaleString('default', {
          weekday: 'short',
        });
        if (this.daysinweek.includes(curday) == false) {
          this.storesltdate.push(this.getFormattedDateTime(storedate, 'Date1'));
        }
      }
    }, 20);
  }
  selectedPackageArray: any = [];
  toChange: any = [];
  async selectService() {
    this.storeTimeSlots = null;
    this.showcal = true;
    let popover = await this.modalCtrl.create({
      component: TrainerPackageDetPage,
      cssClass: 'service-model1',
      componentProps: {
        storeOfferCards: this.particularTrainerDetails,
        isHomeMode: this.isHomeTr_mode,
        isOnlineMode: this.isOnlineTr_mode,
        isCenterMode: this.isCenterTr_mode,
      },
    });
    popover.onDidDismiss().then((data: any) => {
      if (data != null && data.data != undefined) {
        if (
          data.data.packdet == 'NotSelected' &&
          this.selectedPackageArray.length > 0
        ) {
          this.avail_book = true;
        } else {
          this.toChange = [];
          this.selectedPackageArray = [];
          this.toChange = data.data.packdet;
          if (this.toChange != null && this.toChange != undefined) {
            this.toChange.forEach((item) => {
              this.selectedPackageArray.push(item);
            });
          }
          this.filterWeeks = [];
          this.indexofWeek = '';
          this.clearValues();
          this.packdet = data.data.packdet[0];
          this.cho = data.data.coh;
          this.package_detail(this.packdet, this.cho, '');
          this.LoadCalenar('Manual');
        }
      }
    });
    return await popover.present();
  }

  package_detail(packdet: any, cho: any, dataOf: any) {
    setTimeout(() => {
      this.content.scrollToBottom();
    }, 500);
    let dayId = [];
    let storeday = [];
    let storedaysname = [];
    let storedaysnameextra = [];
    if (packdet?.programDays) {
      for (let item of JSON.parse(packdet?.programDays)) {
        dayId.push(item.tr_day_id);
      }
      for (let item1 of dayId.sort()) {
        let store = this.days[item1 - 1];
        storeday.push(store);
      }

      let lastDay = storeday.length - 1;
      for (let session = 0; session < storeday.length; session++) {
        if (storeday.length <= 4) {
          if (lastDay == session) {
            storedaysname.push(storeday[session]);
          } else {
            storedaysname.push(storeday[session] + ',');
          }
        } else if (storeday.length > 4) {
          if (session > 3) {
            if (lastDay == session) {
              storedaysnameextra.push(storeday[session]);
            } else {
              storedaysnameextra.push(storeday[session] + ',');
            }
          } else {
            storedaysname.push(storeday[session] + ',');
          }
        } else {
          storedaysname.push(storeday[session] + ',');
        }
      }
    }
    if (packdet != null) {
      this.chon = cho;
      this.tr_pack_det = packdet;
      this.pack_det = true;
      this.presentView = 'trainerdetailpart';
      this.packName = this.tr_pack_det.tr_package_name;
      this.packNameCopy = this.tr_pack_det.tr_package_name;
      if (this.packNameCopy.length > 10) {
        this.packNameCopy = this.packNameCopy.substring(0, 10) + ' ...';
      }
      this.storeTimeSlots = this.tr_pack_det.slot;
      if (dataOf == 'repeat') {
        this.showSelectDate1(
          this.tr_pack_det.programDays,
          'repeat',
          this.tr_pack_det
        );
      } else {
        this.showSelectDate1(
          this.tr_pack_det.programDays,
          'newBkg',
          this.tr_pack_det
        );
      }
      if (this.reppack) {
        this.ScheduleId = packdet.appointment_id;
      }
      if (this.reppack) {
        this.ScheduleId = packdet.appointmentScheduleId;
      }
    }
  }

  finalArray: any = [];
  showBookgConfrPage() {
    let bookStatusCheck = this.selectedPackageArray.filter((x) => x.checked == true);
    if (bookStatusCheck.length == 0) {
      // this.presentToasts('Please select atleast one session');
      this.presentToasts(this.addCall.title728);
      return;
    }else if (bookStatusCheck.length > this.selectedPackageArray[0].tr_session) {
      this.presentToasts(
        `Please select ${this.selectedPackageArray[0].tr_session} sessions`
      );
      return;
    }else if(bookStatusCheck.length != this.derivedates.length){
      // this.presentToasts('Please select the remaining sessions');
      this.presentToasts(this.addCall.title727);
      return;
    }

    this.getHeight = '';
    this.getWeight = '';
    this.showWeightCalc = false;

    this.backValue = 'goTrainerdet';
    this.presentView = 'bookingConfirmPage1';
    this.headerValue = this.addCall.title40;
    this.getAnyMadication = null;
    this.getAnyDisease = null;
    this.getAnySurgery = null;
    this.getAnyHabits = null;
    this.getGoalWeight = null;
    this.shwsltdates = [];
    this.showsltdate = [];
    this.isShowHeaderValue = true;
    this.selectedPackageArray.forEach((item) => {
      if (item.checked == true) {
        this.showsltdate.push(item.dates);
      }
    });
    this.shwsltdates = this.showsltdate.slice(0, 3).join(', ');
    if (this.shwsltdates.length > 10) {
      this.shwsltdates = this.shwsltdates.substring(0, 10) + ', ...';
    }
    this.getPatientBasicDetails(0);
  }

  getPatientBasicDetails(value) {
    if (value == 1) {
      this.presentView = 'bookingConfirmPage';
    }
    let apiData = JSON.stringify({
      patientId: localStorage.getItem('patient_id'),
      currentDate: new Date().toISOString().split('T')[0],
      currentTime: new Date().toTimeString().split(' ')[0],
    });

    this.services.postRequest('getPatientProfile', apiData).subscribe((res) => {
      if (res.msg == 'Success') {
        this.patientBasicDetails = res.data[0];
        this.patientmemberDetails = this.patientBasicDetails.patientmemberDetails;
        this.slctmemname = this.patientBasicDetails.name;
        this.patientAddress = this.patientBasicDetails.address;
        this.slctdMemVal = this.patientBasicDetails.patientId;
        this.BkgConPatientName = this.patientBasicDetails.name;
        this.getHeight = this.patientBasicDetails.height;
        this.getWeight = this.patientBasicDetails.weight;
        this.Age = this.patientBasicDetails.age;
        this.Email = this.patientBasicDetails.email;
        this.Phoneno = this.patientBasicDetails.phone_no;
        this.currentMemberId = localStorage.getItem('patient_id');
      }
    });
  }

  gopay() {
    if ((this.memberAddress == undefined || this.memberAddress == null || this.memberAddress == "")
      && this.selectedPackageArray[0].tr_training_mode == '1') {
      // this.presentToasts('Please choose the location');
      this.presentToasts(this.addCall.title729);
      return;
    } else if ((this.trLatitude == undefined || this.trLatitude == null || this.trLatitude == "")
      && (this.memberAddress == undefined || this.memberAddress == null || this.memberAddress == "")
      && this.selectedPackageArray[0].tr_training_mode == '1') {
      // this.presentToasts('Please choose the location');
      this.presentToasts(this.addCall.title729);
      return;
    }

    localStorage.setItem('payBack', 'trainer');
    if (
      this.getHeight != '' &&
      this.getHeight != null &&
      this.getWeight != '' &&
      this.getWeight != null
    ) {
      this.confirmBooking();
    } else {
      // this.presentToasts('Please fill the all fields');
      this.presentToasts(this.addCall.title730);
    }
  }
  async presentToasts(res: any) {
    const toast = await this.toastController.create({
      message: res,
      duration: 2000,
    });
    toast.present();
  }
  showAddMemberPage1() {
    this.presentView = 'addMemberPage';
    this.backValue = 'goBkgConPage';
    this.headerValue = 'Add Member';
    this.getPatientReletion();
    this.getMemName = null;
    this.getMemGender = null;
    this.getMemReletion = null;
    this.getMemHeight = null;
    this.getMemWeight = null;
    this.getMemMobileNo = null;
    this.membDOB = null;
    this.getMemDob = null;
  }
  async showAddMemberPage() {
    const modal = await this.modalCtrl.create({
      component: AddmemPage,
      cssClass: 'Add-Member-Page',
      componentProps: {
        getMemName: '',
        getMemGender: '',
        getMemReletion: '',
        getMemHeight: '',
        getMemWeight: '',
        getMemMobileNo: '',
        membDOB: '',
        getMemDob: '',
        memProImg: '',
      },
    });
    modal.onDidDismiss().then((data) => {
      const res = data;

      if (res.data.from == 2) {
        this.getPatientBasicDetails(2);
      }
    });
    return await modal.present();
  }
  async confirmBooking() {
    this.trainerbookingId = '';
    let trainerId;
    let packageId;
    let appointmentScheduleId;
    let trainingMode;
    let amount;
    let isMember;
    let deal;
    let billing_amount;
    let dealoption;

    if (this.selectDatePageFlow != 'repeat') {
      trainerId = this.basicDetils.trainerId;
      packageId = this.basicDetils.packageId;
      appointmentScheduleId = this.basicDetils.appointmentScheduleId;
      trainingMode = this.basicDetils.trainingMode;
      amount = this.basicDetils.amount;
      deal = this.basicDetils.dealValue;
      dealoption = this.basicDetils.dealOption;
      if (dealoption == 'Amount') {
        billing_amount = amount - deal;
      } else if (dealoption == 'Percentage') {
        billing_amount = amount - (amount * deal) / 100;
      } else {
        billing_amount = amount;
      }
    } else if (this.selectDatePageFlow == 'repeat') {
      trainerId = this.basicDetils.trainerId;
      packageId = this.basicDetils.packageId;
      appointmentScheduleId = this.basicDetils.appointmentScheduleId;
      trainingMode = this.basicDetils.trainingMode;
      this.currentMemberId = this.repeatBkgData.patient_id;
      amount = this.basicDetils.amount;
      deal = this.basicDetils.dealValue;
      dealoption = this.basicDetils.dealOption;
      if (dealoption == 'Amount') {
        billing_amount = amount - deal;
      } else if (dealoption == 'Percentage') {
        billing_amount = amount - (amount * deal) / 100;
      } else {
        billing_amount = amount;
        dealoption = 'null';
      }
    }
    if (String(this.currentMemberId) == localStorage.getItem('patient_id')) {
      isMember = 1;
    } else {
      isMember = 0;
    }

    await this.presentModal1(
      this.slctdMemVal,
      this.Email,
      this.Phoneno,
      billing_amount,
      packageId,
      appointmentScheduleId,
      amount,
      deal,
      dealoption,
      trainingMode,
      isMember
    );

    // const loading = await this.loadingController.create({
    //   cssClass: 'my-custom-class',
    //   message: 'Please wait we are redirecting you to the payment gateway',

    // });
    // await loading.present();
    // this.payment.getsessionid(this.slctdMemVal, this.Email, this.Phoneno, billing_amount).then(async (res: any) => {
    // await loading.dismiss();

    // let apiData = JSON.stringify({
    //   "patientId": this.currentMemberId,//localStorage.getItem("patient_id"),
    //   // "trainerId": Number(this.tr_pack_det.tr_trainer_id),
    //   "trainerId": this.trainerids,
    //   "packageId": packageId,
    //   "appointmentScheduleId": appointmentScheduleId,
    //   "fromDate": this.storeFromDate,
    //   "toDate": this.storeToDate,
    //   "bookedDate": new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate(),
    //   "amount": amount,
    //   "billing_amount": billing_amount,
    //   "deal": deal,
    //   "dealoption": dealoption,
    //   "fromTime": null,
    //   "toTime": null,
    //   "isVIP": "0",
    //   "trainingMode": trainingMode,
    //   "paymentStatus": "1",
    //   "isMember": isMember,
    //   "tempMemberName": this.slctmemname,

    //   "name": this.patientBasicDetails.name,
    //   "dob": this.patientBasicDetails.dob.split("T")[0],
    //   "gender": this.patientBasicDetails.gender,
    //   "height": this.getHeight,
    //   "heightUnit": this.height,
    //   "weight": this.getWeight,
    //   "weightUnit": this.weight,
    //   "bmi": this.BMIvalue,
    //   "anyMedication": "No",//this.getAnyMadication,
    //   "anyDisease": "No",//this.getAnyDisease,
    //   "anySurgery": "No",//this.getAnySurgery,
    //   "anyGoals": "No",//null,
    //   "goalWeight": 0,//this.getGoalWeight,
    //   "goalWeightUnit": this.weight,
    //   // "intakeCal": this.inTakeClsPerDay,
    //   "intakeCal": 0,
    //   // "durationDays": this.durationDays,
    //   "durationDays": 0,
    //   "parrentPatientId": localStorage.getItem("patient_id"),
    //   "oldBookingId": 0,
    //   "paymentid": "tom5tzsdju51wtessd",//res.resultid,//res.payment_id,"paymentid":"d67cc06b7f0542e3","referenceid":"b00753ea09",
    //   "referenceid": "tom5tzsdju51wtessd",//res.sessionid,//res.refnumber,
    //   "mamber_Approval": 'P',
    //   "trainer_Approval": 'P',
    //   "Selected_dates": null,
    //   "order_id": "tom5tzsdju51wtessd"
    // });

    // //patientTrainerBooking

    // this.services.postRequest1("patientTrainerBookingNew", apiData).subscribe(res => {
    //
    //   if (res.status == 1) {
    //     this.trainerbookingId = res.data[0].response.trainerBookingId
    //     this.insertDatesTimetoDB();
    //     setTimeout(() => {
    //       this.loadingController.dismiss();
    //     }, 500);
    //     setTimeout(() => {
    //       this.playSound();
    //     }, 1000);

    //     this.router.navigate(['/payment', { paymentstatus: 1 }]);
    //   }
    //   else {
    //     setTimeout(() => {
    //       this.loadingController.dismiss();
    //     }, 500);
    //     this.toastMessage = res.msg;
    //     this.presentToast();
    //   }

    // })
    // }

    // else if (res.status == '2') {
    //   this.AlertInfo("Payment Cancelled", 0)
    // }
    // else {
    //   // this.AlertInfo("Payment Failed", 0)
    //   this.AlertInfo(this.addCall.title144, 0)
    // }
    // });
  }

  playSound() {
    let audio = new Audio();
    audio.src = '../assets/audio/tick.mp3';
    audio.load();
    audio.play();
  }

  gatewayFunction(res: any, packageId: any, appointmentScheduleId: any, amount: any, billing_amount: any,
    deal: any, dealoption: any, trainingMode: any, isMember: any, paymentGateway: any) {
    if (res.status == '1') {
    let memLatLong = this.trLatitude == null || this.trLatitude == "" ||
      this.trLatitude == undefined ? this.memberLatLan : this.trLatitude + "," + this.trLongtitude;

    let patientAddress = this.memberAddress == null || this.memberAddress == "" ||
      this.memberAddress == undefined ? null : this.memberAddress

    let apiData = JSON.stringify({
      patientId: this.currentMemberId, //localStorage.getItem("patient_id"),
      // "trainerId": Number(this.tr_pack_det.tr_trainer_id),
      trainerId: this.isRepeatOf == 'repeatOf' ? this.repeatBkgData.tr_vendor_id : this.trainerids,
      packageId: packageId,
      appointmentScheduleId: appointmentScheduleId,
      fromDate: this.storeFromDate,
      toDate: this.storeToDate,
      bookedDate: new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate(),
      amount: amount,
      billing_amount: billing_amount,
      deal: deal,
      dealoption: dealoption,
      fromTime: null, //this.storeSelectedSlot.fromTime,
      toTime: null, //this.storeSelectedSlot.toTime,
      isVIP: '0',
      trainingMode: trainingMode,
      paymentStatus: '1',
      isMember: isMember,
      tempMemberName: this.slctmemname,
      name: this.patientBasicDetails.name,
      dob: this.patientBasicDetails.dob.split('T')[0],
      gender: this.patientBasicDetails.gender,
      height: this.getHeight,
      heightUnit: this.height,
      weight: this.getWeight,
      weightUnit: this.weight,
      bmi: this.BMIvalue,
      anyMedication: 'No', //this.getAnyMadication,
      anyDisease: 'No', //this.getAnyDisease,
      anySurgery: 'No', //this.getAnySurgery,
      anyGoals: 'No', //null,
      goalWeight: 0, //this.getGoalWeight,
      goalWeightUnit: this.weight,
      // "intakeCal": this.inTakeClsPerDay,
      intakeCal: 0,
      // "durationDays": this.durationDays,
      durationDays: 0,
      parrentPatientId: localStorage.getItem('patient_id'),
      oldBookingId: 0,
      paymentid: res.resultid, //res.resultid,//res.payment_id,"paymentid":"d67cc06b7f0542e3","referenceid":"b00753ea09",
      referenceid: res.sessionid, //res.sessionid,//res.refnumber,
      mamber_Approval: 'P',
      trainer_Approval: 'P',
      Selected_dates: '', //this.selecteddates,
      order_id: res.orderId,
      paymentGatewayName: res.paymentGatewayName,
      memberLocation: memLatLong,
      isAndroid: this.platform.is("ios") ? false : true,
      patientAddress: patientAddress
    });

    this.services
      .postRequest1('patientTrainerBookingNew', apiData)
      .subscribe((response) => {
        if (response.status == 1) {
          this.trainerbookingId = response.data[0].response.trainerBookingId;
          this.insertDatesTimetoDB();
          this.isRepeatOf = '';
          setTimeout(() => {
            this.loadingController.dismiss();
          }, 500);
          setTimeout(() => {
            this.playSound();
          }, 1000);
          if (localStorage.getItem('cardType') == 'Knet') {
            this.showKnetPaymentDetals(res, this.addCall.title620);
          } else if (localStorage.getItem('cardType') == 'MasterCard') {
            this.router.navigate(['/payment', { paymentstatus: 1 }]);
          }
        } else {
          setTimeout(() => {
            this.loadingController.dismiss();
          }, 500);
          this.toastMessage = res.msg;
          this.presentToast();
        }
      });
    } else if (res.status == '2') {
      this.AlertInfo(this.addCall.title144, 0);
    } else {
      if (paymentGateway == "KNET") {
        this.showKnetPaymentDetals(res, 'Payment Failure Details');
      } else {
        this.AlertInfo(this.addCall.title144, 0);
      }
    }
  }

  repeatConfirmBooking() {
    let apiData = JSON.stringify({
      oldBookingId: '23',
      patientId: '1',
      trainerId: '6',
      packageId: '79',
      appointmentScheduleId: '53',
      fromDate: '2020-07-20',
      toDate: '2020-07-28',
      bookedDate: '2020-07-09',
      amount: '100',
      fromTime: '11:00:00',
      toTime: '12:00:00',
      isVIP: '0',
      trainingMode: '2',
      paymentStatus: '1',
      isMember: 1,
      tempMemberName: 'Edwin',
      name: 'Edwin',
      dob: '1997-07-02',
      gender: 'M',
      height: '175',
      heightUnit: 'CM',
      weight: '60',
      weightUnit: 'Kg',
      bmi: '120',
      intakeCal: '10',
      durationDays: '10',
      anyMedication: 'any medication',
      anyDisease: '',
      anySurgery: '',
      anyGoals: '',
      goalWeight: '70',
      goalWeightUnit: 'Kg',
      parrentPatientId: '1',
    });

    this.services
      .postRequest('patientTrainerBookingReschedule', apiData)
      .subscribe((res) => { });
  }

  wayOfBookingListpages(page) {
    this.StoreWayBookingPageFlow = page;
    this.pageNo = 1;
    if (page == 'bookingList') {
      this.storeBookingList = [];
      this.EmptyData = 0;
      this.showBookinkList();
    } else if (page == 'bookingHisList') {
      this.pageNo = 1;
      this.historyList = [];
      this.showBookingHisList();
    }
  }


  async showBookinkList() {
    this.presentView = 'bookingListPage';
    this.backValue = 'goTrainersPage';
    this.headerValue = this.addCall.title143;

    this.nextcount1 = 0;
    if (this.pageNo == 1) {
      this.EmptyData = 0;
      this.length = null;
    }
    if (this.trainerSubscribe) {
      this.trainerSubscribe.unsubscribe();
    }
    let apiData = JSON.stringify({
      pageno: this.pageNo,
      limit: 10,
      patientId: localStorage.getItem('patient_id'),
      currentdate: new Date().toISOString().split('T')[0],
      current_time: new Date().toTimeString().split(' ')[0],
    });

    this.trainerSubscribe =  this.services.postRequest1('getPatientTrainerBookingDetails', apiData).subscribe((res) => {
        if (this.pageNo == 1) {
          this.EmptyData = res.status;
          this.length = res.status;
        }
        this.ChangeEventTrainer.emit('isTrainerBack');
        this.isShowHeaderValue = false;
        if (res.msg == 'Success') {
          res.data[0].details.forEach((item) => {
            let jsonParse = JSON.parse(item.selecteddates);
            let sort = jsonParse.sort(({ date: a }, { date: b }) => a - b);
            let sortSelectedDates = jsonParse.sort(
              ({ date: a }, { date: b }) => a - b
            );
            sort = sort.filter((obj) => this.isFutureDate(obj.date));
            item.from_time = sort.length > 0 ? sort[0].fromTime : '';
            item.to_time = sort.length > 0 ? sort[0].toTime : '';
            item.Vc_startTime = sort.length > 0 ? sort[0].startTime : '';
            item.Vc_endTime = sort.length > 0 ? sort[0].endTime : '';
            item.selecteddates = sortSelectedDates
              .map((obj) => obj.date)
              .join(', ');
            item.workingHours = sortSelectedDates;
          });
          this.nextcount1 = res.data[0].nextCount;
          this.EmptyData = 1;
          this.length = 1;
          if (this.pageNo != 1) {
            for (let item of res.data[0].details) {
              this.storeBookingList.push(item);
            }
            this.checkingtimevalidation();
          } else {
            this.storeBookingList = res.data[0].details;
            this.checkingtimevalidation();
          }
        }
      });
  }

  checkingtimevalidation() {
    let getDate = new Date();
    let currentDate =
      getDate.getFullYear() +
      '-' +
      ('0' + (getDate.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + getDate.getDate()).slice(-2);

    this.storeBookingList.forEach((date, index) => {
      if (date.training_mode == '2') {
        for (let i = 0; i <= date.workingHours.length; i++) {
          if (date.workingHours[i] != undefined) {
            if (date.workingHours[i].date == currentDate) {
              this.showtimer(
                date.workingHours[i].date,
                date.workingHours[i].fromTime,
                index
              );
            }
          }
        }
      }
    });
  }

  //=========>>>>>>>>> backup don't delete <<<<<<<<<<<=====================

  // showtimer(date, time, i) {
  //   this.time = setInterval(() => {

  //       minutes = parseInt(String(timer / 60), 10);
  //       seconds = parseInt(String(timer % 60), 10);
  //       minutes = minutes < 10 ? "0" + minutes : minutes;
  //       seconds = seconds < 10 ? "0" + seconds : seconds;
  //       // document.getElementById("vc_" + i).innerHTML = minutes + ":" + seconds;
  //       this.jksdjdsfsd = minutes + ":" + seconds;
  //       if (--timer < 0) {
  //         //timer = duration;
  //         // obj.showTimer = false;
  //         //  clearInterval(time);
  //       }
  //     } else {
  //       clearInterval(this.time);
  //       // document.getElementById("vc_" + i).innerHTML = '';
  //     }
  //   }, 1000);
  // }

  showtimmer: any;
  showtimer(date, time, i) {
    let timeof = setInterval(() => {
      let difference = this.common.getTimeDiffernce1(time, date);

      if (difference >= -300000 && difference <= 0) {
        let getDate = new Date();
        let currentDate =
          getDate.getFullYear() +
          '-' +
          ('0' + (getDate.getMonth() + 1)).slice(-2) +
          '-' +
          ('0' + getDate.getDate()).slice(-2);

        this.storeBookingList.forEach((date, index) => {
          if (date.training_mode == '2') {
            for (let i = 0; i <= date.workingHours.length; i++) {
              if (date.workingHours[i] != undefined) {
                if (
                  date.workingHours[i].date == currentDate &&
                  date.workingHours[i].fromTime == time
                ) {
                  date.showtimer = 1;
                }
              }
            }
          }
        });

        let duration = Math.floor(
          Math.abs(
            (new Date().getTime() - new Date(date + 'T' + time).getTime()) /
            1000
          )
        );
        let timer = duration,
          minutes,
          seconds;

        minutes = parseInt(String(timer / 60), 10);
        seconds = parseInt(String(timer % 60), 10);
        minutes = minutes < 10 ? '0' + minutes : minutes;
        seconds = seconds < 10 ? '0' + seconds : seconds;
        this.showtimmer = minutes + ':' + seconds;
      } else {
        clearInterval(timeof);
        this.showtimmer = '';
      }
    }, 1000);
  }

  async cancelBkng(bookingId, bookingAmnt) {
    this.storeBookingId = bookingId;
    this.storeBookingAmnt = bookingAmnt;
    const modal = await this.modalCtrl.create({
      component: CancelbookingPage,
      cssClass: 'ModelConCSSCancelPopUp',
      componentProps: {
        bookingId: bookingId,
        bookingAmnt: bookingAmnt,
      },
    });
    modal.onDidDismiss().then((data) => {
      const res = data;
      if (res.data != null) {
        this.presentLoading();
        this.cancelBooking();
      }
    });
    return await modal.present();
  }

  bookingsltdate: any = [];
  showbookingdate: any = [];
  viewBookingDetail(index, datas) {
    this.showsltdate = [];
    this.showbookingdate = [];
    this.bookingListIndex = index;

    this.presentView = 'viewBookingInfoPage';
    this.backValue = 'goBkgList';
    this.headerValue = this.addCall.title133;
    this.particularBkgDetails = this.storeBookingList[index];
    this.clupWorkingHr(this.particularBkgDetails.pacckageDays);
    let fromDate = this.particularBkgDetails.from_date.split('T')[0];
    let toDate = this.particularBkgDetails.to_date.split('T')[0];
    let dates = this.getBtwDays(new Date(fromDate), new Date(toDate));
    this.remaingDates = this.particularBkgDetails.remaining_days;
    this.compdates = this.particularBkgDetails.completed_days;

    let selecteddates = this.particularBkgDetails.selecteddates.split(',');
    selecteddates.forEach((date) => {
      this.showsltdate.push(this.getFormattedDateTime(date, 'Date1'));
    });
    this.showbookingdate = this.showsltdate.slice(0, 3).join(',');
    if (this.showbookingdate.length > 20) {
      this.showbookingdate = this.showbookingdate.substring(0, 20) + ' ...';
    }
    this.headerValueCopy = this.particularBkgDetails.tr_package_name;
    this.viewBookingLatLan = this.particularBkgDetails.vendor_latlong;
    if (this.headerValueCopy.length > 10) {
      this.headerValueCopy = this.headerValueCopy.substring(0, 10) + ' ...';
    }
    this.addressValueCopy = this.particularBkgDetails.vendor_address;
    if (this.addressValueCopy.length > 10) {
      this.addressValueCopy = this.addressValueCopy.substring(0, 10) + ' ...';
    }
    this.ChangeEventTrainer.emit('profile');
    if (this.trainerSubscribe) {
      this.trainerSubscribe.unsubscribe();
    }
    this.isShowHeaderValue = true;
    if (datas != "" && datas != undefined && datas != null) {
      this.MyScheduleDates(datas);
    }

  }


  async showMySchadule() {
    const loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: 'Please wait ...',
    });
    await loading.present();
    setTimeout(async () => {
      await loading.dismiss();
      this.presentView = 'viewMyShcedulePage';
    }, 2001);

    this.backValue = 'goBkgInfo';
    this.headerValue = this.particularBkgDetails.tr_package_name;

    if (this.particularBkgDetails.specificDateResheduleList != null) {
      let p_reschedule = JSON.parse(
        this.particularBkgDetails.specificDateResheduleList
      );
      let toresch = p_reschedule[0].rescheduled_date;
      let tobesch = p_reschedule[0].to_be_reschedule;
      this.rescheduledatefrm = String(new Date(toresch)).substring(0, 15);
      this.rescheduledateto = String(new Date(tobesch)).substring(0, 15);
      p_reschedule.forEach((item) => {
        this.storereschtodate.push(
          String(new Date(item.rescheduled_date)).substring(0, 15)
        );
        this.storereschfromdate.push(
          String(new Date(item.to_be_reschedule)).substring(0, 15)
        );
      });
      this.ChangeEventTrainer.emit('profile');
    }
    this.clupWorkingHr(this.particularBkgDetails.pacckageDays);
    const chooseDate = this.particularBkgDetails.selecteddates.split(',')
    const nowDates = chooseDate.map(date => date.trim()).sort((a, b) => {
      return new Date(a).getTime() - new Date(b).getTime();
    });
    // let fromDate = this.particularBkgDetails.from_date.split('T')[0];
    let fromDate = nowDates[0];
    let toDate = this.particularBkgDetails.to_date.split('T')[0];
    this.myFromDate = new Date(
      fromDate.split('-')[0],
      fromDate.split('-')[1] - 1,
      fromDate.split('-')[2]
    );
    this.myToDate = new Date(
      toDate.split('-')[0],
      toDate.split('-')[1] - 1,
      toDate.split('-')[2]
    );
    this.showsheduledate =
      this.myFromDate.toString().split(' ')[0] +
      ', ' +
      this.myFromDate.toString().split(' ')[1] +
      ' ' +
      this.myFromDate.toString().split(' ')[2];

    this.chkCrnDate = new Date(new Date().setHours(0, 0, 0, 0));
    this.crnDate = new Date().getDate();
    this.crnYear = new Date().getFullYear();
    this.crnMonth = new Date().getMonth() + 1;
    this.representMonth = new Date(fromDate).getMonth() + 1;
    this.viewMonth = new Date(fromDate);
    this.getBkgDateCaleForResch(new Date(fromDate), new Date(toDate));
    let dates = this.getBtwDays(new Date(fromDate), new Date(toDate));
    // if (dates.reminingDays < 10) {
    //   this.remaingDates = '0' + dates.reminingDays;
    // } else {
    //   this.remaingDates = dates.reminingDays;
    // }
    this.option.percent =
      (dates.reminingDays / this.particularBkgDetails.tr_session) * 100;

    // if (dates.completeddate < 10) {
    //   this.compdates = '0' + dates.completeddate;
    // } else {
    //   this.compdates = dates.completeddate;
    // }
    this.option1.percent =
      (this.compdates / this.particularBkgDetails.tr_session) * 100;
    this.bindMyschedulesDates();
  }

  //---------------\/-------create calender related function------------\/---------

  // getBtwDays(start, end) {
  //
  //   let remDate = [];
  //   let completeddays = [];
  //   for (var arr = [], dt = new Date(start); dt <= end; dt.setDate(dt.getDate() + 1)) {
  //     arr.push(new Date(dt));
  //     let date1 = new Date(dt);
  //     let date2 = new Date();
  //     date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
  //     if (date1 >= date2 && !this.disableDay.includes(date1.getDay())) {
  //       remDate.push(new Date(dt));
  //     }
  //     else if (date1 <= date2 && !this.disableDay.includes(date1.getDay())) {
  //       completeddays.push(new Date(dt))
  //     }
  //   }
  //   this.getBtwDayslist = {
  //     totalDays: arr.length,
  //     reminingDays: remDate.length,
  //     completeddate: completeddays.length
  //   };
  //   return this.getBtwDayslist;
  // }
  getBtwDays(start, end) {
    let remDate = [];
    let completeddays = [];

    // Create a copy of the start date and a reference to the current date
    let currentDate = new Date();
    let startDate = new Date(start);

    for (let dt = startDate; dt <= end; dt.setDate(dt.getDate() + 1)) {
      let date1 = new Date(dt);

      // Check if the date is in the past or future
      if (date1 < currentDate) {
        if (!this.disableDay.includes(date1.getDay())) {
          completeddays.push(new Date(dt));
        }
      } else {
        if (!this.disableDay.includes(date1.getDay())) {
          remDate.push(new Date(dt));
        }
      }
    }
    this.getBtwDayslist = {
      totalDays: remDate.length + completeddays.length,
      reminingDays: remDate.length,
      completeddate: completeddays.length,
    };
    return this.getBtwDayslist;
  }
  frmcalendardate: any;
  getBkgDateCaleForResch(fromDate, toDate) {
    this.storeDates = [];
    this.cur_date = new Date();

    this.frmcalendardate = new Date(fromDate);
    const FromDate = new Date(fromDate);

    let dateArray = String(fromDate).split(' ');
    this.year = dateArray[3];
    this.month = dateArray[1];
    let prevDate = new Date(
      FromDate.getFullYear(),
      FromDate.getMonth(),
      0
    ).getDay();
    if (prevDate < 6) {
      for (let i = prevDate; i >= 0; i--) {
        this.storeDates.push({
          fullDate: ' ',
          year: ' ',
          month: ' ',
          date: ' ',
          dayId: ' ',
          dateStrg: '',
        });
      }
    }

    let monthEnd = new Date(
      FromDate.getFullYear(),
      FromDate.getMonth() + 1,
      0
    ).getDate();
    for (let i = 1; i <= monthEnd; i++) {
      if (i == 1) {
        this.displayMonth = new Date(
          FromDate.getFullYear(),
          FromDate.getMonth(),
          i
        );
      }
      this.storeDates.push({
        fullDate: new Date(FromDate.getFullYear(), FromDate.getMonth(), i),
        year: FromDate.getFullYear(),
        month: FromDate.getMonth() + 1,
        date: i,
        dayId: new Date(
          FromDate.getFullYear(),
          FromDate.getMonth(),
          i
        ).getDay(),
        dateStrg: new Date(
          FromDate.getFullYear(),
          FromDate.getMonth(),
          i
        ).toDateString(),
      });
    }

    let difftime;
    if (this.myFromDate <= this.chkCrnDate) {
      difftime = this.myToDate.getTime() - this.chkCrnDate.getTime();
    } else {
      difftime = this.myToDate.getTime() - this.myFromDate.getTime();
    }
    this.diffDays = Math.ceil(difftime / (1000 * 3600 * 24)) + 1;
  }

  reNextMonth() {
    let nextMonth = new Date(this.displayMonth.getFullYear(),this.displayMonth.getMonth() + 1, 1);
    const chooseDate = this.allSelectedDate1;
    let getMon = []
    chooseDate.forEach((item)=>{
      getMon.push(new Date(item))
    })
    let getMon2 = [];
    const getMonthYearKey = (date) => `${date.getFullYear()}-${date.getMonth()}`;
    const seen = new Set();
    const uniqueDates = getMon.filter(date => {
    const key = getMonthYearKey(date);
    if (seen.has(key)) {
      return false;
    } else {
      seen.add(key);
      return true;
    }
  });

    getMon2 =  uniqueDates.filter(element => new Date (element) > new Date (this.viewMonth));
    if(getMon2.length > 0){
    this.representMonth = getMon2[0].getMonth() + 1;
    this.viewMonth = getMon2[0];
    let dateArray = String(nextMonth).split(' ');
    this.year = dateArray[3];
    this.month = dateArray[1];
    this.representYear = getMon2[0].getFullYear();
    this.getBkgDateCaleForResch(getMon2[0], new Date(this.myToDate));
    this.reschedulecalculateOfWeeks('', 'changeofMonth');
    }
  }
  rePrevMonth() {
    let prevMonth = new Date(this.displayMonth.getFullYear(), this.displayMonth.getMonth() - 1, 1);
    const chooseDate = this.allSelectedDate1;
    let getMon = []
    chooseDate.forEach((item)=>{
      getMon.push(new Date(item))
    })
    let getMon2 = [];
    const getMonthYearKey = (date) => `${date.getFullYear()}-${date.getMonth()}`;
    const seen = new Set();
    const uniqueDates = getMon.filter(date => {
    const key = getMonthYearKey(date);
    if (seen.has(key)) {
      return false;
    } else {
      seen.add(key);
      return true;
    }
  });
    getMon2 =  uniqueDates.filter(element => new Date (element) < new Date (this.viewMonth));
    if(getMon2.length > 0){
    getMon2 = getMon2.reverse()
    this.representMonth = getMon2[0].getMonth() + 1;
    this.viewMonth = getMon2[0];
    let dateArray = String(prevMonth).split(' ');
    this.year = dateArray[3];
    this.month = dateArray[1];
    this.representYear = getMon2[0].getFullYear();
    this.getBkgDateCaleForResch(getMon2[0], new Date(this.myToDate));
    this.reschedulecalculateOfWeeks('', 'changeofMonth');
    }
  }


  nextMonth() {
    let nextMonth = new Date(this.displayMonth.getFullYear(),this.displayMonth.getMonth() + 1, 1);
    const chooseDate = this.particularBkgDetails.selecteddates.split(',');
    let getMon = [];
    let twoMonthArray = []
    if(this.remainSaveSessions != 0 && this.remainSaveSessions != null && this.saveAvailable == 1){
      chooseDate.forEach((item)=>{
        twoMonthArray.push(new Date(item))
      })
      this.myScheduleAllDates.forEach((item)=>{
        twoMonthArray.push(new Date(item))
      });
      getMon = [...new Set(twoMonthArray)];
    }else{
      chooseDate.forEach((item)=>{
      getMon.push(new Date(item))
    });
    }

    let getMon2 = [];
    const getMonthYearKey = (date) => `${date.getFullYear()}-${date.getMonth()}`;
    const seen = new Set();
    const uniqueDates = getMon.filter(date => {
    const key = getMonthYearKey(date);
    if (seen.has(key)) {
      return false;
    } else {
      seen.add(key);
      return true;
    }
  });
    getMon2 =  uniqueDates.filter(element => new Date (element) > new Date (this.viewMonth));
    if(getMon2.length > 0){
    this.representMonth = getMon2[0].getMonth() + 1;
    this.viewMonth = getMon2[0];
    let dateArray = String(nextMonth).split(' ');
    this.year = dateArray[3];
    this.month = dateArray[1];
    // this.representMonth = nextMonth.getMonth() + 1;
    // this.representYear = this.displayMonth.getFullYear();
    this.representYear = getMon2[0].getFullYear();
    this.getBkgDateCaleForResch(getMon2[0], new Date(this.myToDate));
    this.reschedulecalculateOfWeeks('', 'changeofMonth');
    }
  }

  prevMonth() {
    let prevMonth = new Date(this.displayMonth.getFullYear(), this.displayMonth.getMonth() - 1, 1);
    const chooseDate = this.particularBkgDetails.selecteddates.split(',');
    let getMon = [];
    let twoMonthArray = []
    // chooseDate.forEach((item)=>{
    //   getMon.push(new Date(item))
    // })
    if(this.remainSaveSessions != 0 && this.remainSaveSessions != null && this.saveAvailable == 1){
      chooseDate.forEach((item)=>{
        twoMonthArray.push(new Date(item))
      })
      this.myScheduleAllDates.forEach((item)=>{
        twoMonthArray.push(new Date(item))
      });
      getMon = [...new Set(twoMonthArray)];
    }else{
      chooseDate.forEach((item)=>{
      getMon.push(new Date(item))
    })
    }
    let getMon2 = [];
    const getMonthYearKey = (date) => `${date.getFullYear()}-${date.getMonth()}`;
    const seen = new Set();
    const uniqueDates = getMon.filter(date => {
    const key = getMonthYearKey(date);
    if (seen.has(key)) {
      return false;
    } else {
      seen.add(key);
      return true;
    }
  });
    getMon2 =  uniqueDates.filter(element => new Date (element) < new Date (this.viewMonth));
    if(getMon2.length > 0){
    let sortedDates = getMon2.sort(function(a, b){return a.getTime() - b.getTime()})
    getMon2 = sortedDates.reverse()
    this.representMonth = getMon2[0].getMonth() + 1;
    this.viewMonth = getMon2[0];
    let dateArray = String(prevMonth).split(' ');
    this.year = dateArray[3];
    this.month = dateArray[1];
     this.representYear = getMon2[0].getFullYear();
      this.getBkgDateCaleForResch(getMon2[0], new Date(this.myToDate));
      this.reschedulecalculateOfWeeks('', 'changeofMonth');
    }
  }

  showdateday: any = [];
  clupWorkingHr(data) {
    let storeWorkingDayIndex = [];
    let daysIndex = [0, 1, 2, 3, 4, 5, 6];
    this.disableDay = [];
    if (data != null) {
      for (let item of JSON.parse(data)) {
        storeWorkingDayIndex.push(item.tr_day_id - 1);
      }
      for (let item of daysIndex) {
        if (storeWorkingDayIndex.includes(item) == false) {
          this.disableDay.push(item);
          this.showdateday.push(item);
        }
      }
    } else {
      this.disableDay = [];
    }
  }

  //---------------/\-------create calender related function------------/\------------

  reSchedulePage(item) {
    if(item.tr_package_name){
      this.rescheduleHeaderValue = true
    }
    this.isAndroid = null;
    this.isIos = null;
    if (this.platform.is('ios')) {
      this.isIos = 1;
    } else if (this.platform.is('android')) {
      this.isAndroid = 1;
    }
    this.storeRescheduleDate = { fullDate: null, formatedDate: null };
    this.storeRescheduleAltDate = { fullDate: null, formatedDate: null };
    this.presentView = 'changeMyShcedulePage';
    this.isShowHeaderValue = true;
    this.ChangeEventTrainer.emit('profile');
    this.backValue = 'goBkgList';
    this.ReSchBtnValue = '';
    this.SlotId = null;
    this.storeTimeSlots = null;
    this.storeSelectedSlot = null;
    this.finalArrayforResche = [];
    this.particularBkgDetails = item;
    this.headerValue = this.particularBkgDetails.tr_package_name;

    if (this.particularBkgDetails.specificDateResheduleList != null) {
      let p_reschedule = JSON.parse(
        this.particularBkgDetails.specificDateResheduleList
      );
      let toresch = p_reschedule[0].rescheduled_date;
      let tobesch = p_reschedule[0].to_be_reschedule;
      this.rescheduledatefrm = String(new Date(toresch)).substring(0, 15);
      this.rescheduledateto = String(new Date(tobesch)).substring(0, 15);

      p_reschedule.forEach((item) => {
        this.storereschtodate.push(
          String(new Date(item.rescheduled_date)).substring(0, 15)
        );
        this.storereschfromdate.push(
          String(new Date(item.to_be_reschedule)).substring(0, 15)
        );
      });
    }

    this.clupWorkingHr(this.particularBkgDetails.pacckageDays);
    let fromDate = this.particularBkgDetails.from_date.split('T')[0];
    let toDate = this.particularBkgDetails.to_date.split('T')[0];
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    this.representMonth = currentMonth;
    this.representYear = currentDate.getFullYear();

    this.myFromDate = new Date(
      fromDate.split('-')[0],
      fromDate.split('-')[1] - 1,
      fromDate.split('-')[2]
    );
    this.myToDate = new Date(
      toDate.split('-')[0],
      toDate.split('-')[1] - 1,
      toDate.split('-')[2]
    );
    this.showsheduledate =
      this.myFromDate.toString().split(' ')[0] +
      ', ' +
      this.myFromDate.toString().split(' ')[1] +
      ' ' +
      this.myFromDate.toString().split(' ')[2];
    this.chkCrnDate = new Date(new Date().setHours(0, 0, 0, 0));
    this.crnDate = new Date().getDate();
    this.crnYear = new Date().getFullYear();
    this.crnMonth = new Date().getMonth() + 1;
    // this.getBkgDateCaleForResch(new Date(fromDate), new Date(toDate));
    this.toreschedule(item);
  }

  storeReDates: any = [];
  storeSelectedDates: any = [];
  forCalendarFunc: any = [];
  rescheduled: any;
  finalArrayforResche: any = [];
  rescheduleIt(data) {
    this.rescheduled = null;
    let d = new Date(data.dateStrg);
    let frmtedDate = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2);
    const deriDATES = this.reCalendarDates.find((element) => element === data.dateStrg);
    const deriRemainDates = this.remainCalendarDates.find((element) => element === data.dateStrg);
    if ((deriDATES != '' && deriDATES != undefined && deriRemainDates == '') ||
      deriRemainDates == undefined) {
      let e = new Date(deriDATES);
      let refrmtedDate = e.getFullYear() + '-' +
        ('0' + (e.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + e.getDate()).slice(-2);
      this.storeReDates = {
        fullDate: deriDATES,
        formatedDate: refrmtedDate,
      };
      this.storeSelectedDates = [];
      this.storeRescheduleAltDate = { fullDate: null, formatedDate: null };
      this.rescheduled = 1;
    } else if (deriRemainDates != '' && deriRemainDates != undefined) {
      let e = new Date(deriRemainDates);
      let refrmtedDate =
        e.getFullYear() +
        '-' +
        ('0' + (e.getMonth() + 1)).slice(-2) +
        '-' +
        ('0' + e.getDate()).slice(-2);
      this.storeSelectedDates = {
        fullDate: deriRemainDates,
        formatedDate: refrmtedDate,
      };
      this.rescheduled = 2;
    }

    for (let i = 0; i <= this.selDatesforReschedule.length; i++) {
      let temDates;
      if (this.selDatesforReschedule[i] != undefined) {
        if (
          (temDates = this.dateFormater(this.storeReDates.formatedDate)) ==
          this.selDatesforReschedule[i].dates &&
          this.selDatesforReschedule[i].bookingId != null &&
          this.selDatesforReschedule[i].isReSchedule == 0
        ) {
          this.finalArrayforResche = [];
          this.finalArrayforResche.push({
            dates: this.selDatesforReschedule[i].dates,
            days: this.selDatesforReschedule[i].days,
            WeekDay: this.selDatesforReschedule[i].WeekDay,
            month: this.selDatesforReschedule[i].month,
            monthName: this.selDatesforReschedule[i].monthName,
            year: this.selDatesforReschedule[i].year,
            tr_from_time: this.selDatesforReschedule[i].tr_from_time,
            tr_to_time: this.selDatesforReschedule[i].tr_to_time,
            bookingId: this.selDatesforReschedule[i].bookingId,
            id: this.selDatesforReschedule[i].id,
            checked: false,
          });
        }
      }
    }
    this.forCalendarFunc = [];
    if (this.storeReDates.length != 0 && this.rescheduled == 1) {
      this.forCalendarFunc.push(
        this.reverseDateFormat(this.storeReDates.formatedDate)
      );
    } else if (this.storeSelectedDates.length != 0 && this.rescheduled == 2) {
      this.forCalendarFunc.push(
        this.reverseDateFormat(this.storeSelectedDates.formatedDate)
      );
    }

    this.reschedulecalculateOfWeeks('', '');

    if (data.fullDate <= this.myToDate && this.storereschfromdate.includes(data.dateStrg) != true &&
      data.fullDate > this.chkCrnDate && data.fullDate >= this.myFromDate &&
      this.showdateday.includes(data.dayId) != true) {
      this.storeRescheduleDate = {
        fullDate: data.dateStrg,
        formatedDate: frmtedDate,
      };
    }
    if (
      data.fullDate > this.myToDate &&
      this.showdateday.includes(data.dayId) != true &&
      this.storereschtodate.includes(data.dateStrg) != true
    ) {
      this.storeRescheduleAltDate = {
        fullDate: data.dateStrg,
        formatedDate: frmtedDate,
      };
    }
    this.ReSchBtnValue = this.addCall.title50;
  }

  //2024-02-02 to 02-02-24 format
  reverseDateFormat(values) {
    let dateString = values;
    let parts = dateString.split('-');
    let year = parseInt(parts[0].substring(2), 10);
    let month = parseInt(parts[1], 10);
    let day = parseInt(parts[2], 10);
    let formattedDaterr =
      (day < 10 ? '0' : '') +
      day +
      '-' +
      (month < 10 ? '0' : '') +
      month +
      '-' +
      year;
    return formattedDaterr;
  }
  //2024-02-02 to 02-02-2924 format
  dateFormater(dateString) {
    let date = new Date(dateString);
    let day = String(date.getDate());
    let month = String(date.getMonth() + 1);
    let year = String(date.getFullYear());
    day = day.length === 1 ? '0' + day : day;
    month = month.length === 1 ? '0' + month : month;
    return day + '-' + month + '-' + year;
  }

  changeMySchedule() {
    // Insert ReSchedules Records
    let insertObj = {};
    if (this.selDatesforReschedule.length > 0) {
      this.selDatesforReschedule.forEach((item: any, index: any) => {
        if (item.checked) {
          insertObj = JSON.stringify({
            bookingId: this.finalArrayforResche[0].bookingId,
            idToBe: this.finalArrayforResche[0].id,
            id: item.id ? item.id : 0,
            rescheduledateToBe: this.finalArrayforResche[0].dates,
            rescdateToBeFromTime: this.finalArrayforResche[0].tr_from_time,
            patientId: localStorage.getItem('patient_id'),
            trainerId: item.tr_vendor_id,
            packageId: item.tr_package_id,
            dates: item.dates,
            fromtime: item.tr_from_time,
            totime: item.tr_to_time,
            days: item.days,
            months: item.month,
            year: item.year,
          });
        }
      });
      if (Object.keys(insertObj).length != 0) {
        this.services.postRequest1('patientTrainerRescheduleInsert', insertObj).subscribe((res) => {
          if (res.status != 0) {
            this.AlertInfo(this.addCall.title446, res.status);
            setTimeout(() => {
              this.loadingController.dismiss();
            }, 300);

            this.pageNo = 1;
            this.storeBookingList = [];
            this.showBookinkList();
          }
        });
      } else {
        console.log('No data inserted');
      }
    }
  }

  showBookingHisList() {
    this.presentView = 'historyPage';
    this.backValue = 'goBkgList';
    this.headerValue = this.addCall.title134;

    this.nextcount2 = 0;
    if (this.pageNo == 1) {
      this.length = null;
    }

    let apiData = JSON.stringify({
      patientId: localStorage.getItem('patient_id'),
      pageno: this.pageNo,
      limit: 10,
    });
    this.services
      .postRequest('getPatientTrainerBookingHistoryDetails', apiData)
      .subscribe((res) => {
        if (this.pageNo == 1) {
          this.length = res.status;
        }

        if (res.status == 1) {
          res.data[0].details.forEach((item) => {
            if (item.selecteddates != '' && item.selecteddates != null) {
              let jsonParse = JSON.parse(item.selecteddates);
              let sort = jsonParse.sort(({ date: a }, { date: b }) => a - b);
              item.selecteddates = sort.map((obj) => obj.date).join(', ');
              item.workingHours = sort;
            }
          });

          this.nextcount2 = res.data[0].nextCount;
          this.length = 1;
          if (this.pageNo != 1) {
            for (let item of res.data[0].details) {
              this.historyList.push(item);
            }
          } else {
            this.historyList = res.data[0].details;
          }
        }
      });
  }

  isFutureDate(date: Date): boolean {
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    let givenDate = new Date(date);
    givenDate.setHours(0, 0, 0, 0);
    return givenDate >= currentDate;
  }
  viewBookingHisInfo(index) {
    this.showbookingdate = [];
    this.showsltdate = [];
    this.presentView = 'viewBookingHisInfoPage';
    this.backValue = 'goBkgHisList';
    this.ChangeEventTrainer.emit('profile');
    this.isShowHeaderValue = true;
    this.headerValue = this.addCall.title135;
    this.historyDetails = this.historyList[index];

    let selecteddates = this.historyDetails.selecteddates.split(',');
    selecteddates.forEach((date) => {
      this.showsltdate.push(this.getFormattedDateTime(date, 'Date1'));
    });
    this.showbookingdate = this.showsltdate.slice(0, 3);
  }

  repeatBooking(index) {
    this.isAndroid = null;
    this.isIos = null;
    if (this.platform.is('ios')) {
      this.isIos = 1;
    } else if (this.platform.is('android')) {
      this.isAndroid = 1;
    }
    this.isRepeatOf = 'repeatOf';
    this.ChangeEventTrainer.emit('profile');
    this.showpro = false;
    this.showcal = false;
    this.avail_book = false;
    this.repeatBkgData = this.historyList[index];
    this.trainr_id = this.repeatBkgData.tr_vendor_id;
    this.traing_id = this.repid;
    this.presentView = 'trainerdetailpart';
    this.trainerName = this.repeatBkgData.trainerName;
    this.headerValue = this.repeatBkgData.trainerName;
    this.heiweiType = 'cmsKgs';
    this.height = 'Cms';
    this.weight = 'kgs';
    this.getoff('repeat');
    this.clearValues();
    if (this.repeatBkgData.training_mode == '1') {
      this.HOC = 'homeList';
      this.chsOffHiglight(this.HOC);
    } else if (this.repeatBkgData.training_mode == '2') {
      this.HOC = 'onlineList';
      this.chsOffHiglight(this.HOC);
    } else if (this.repeatBkgData.training_mode == '3') {
      this.HOC = 'centerList';
      this.chsOffHiglight(this.HOC);
    }

    this.backValue = 'goBkgHisList';
  }

  reFundOption(bookingId) {
    this.storeBookingId = bookingId;
    this.showRefundPopUp = !this.showRefundPopUp;
  }

  cancelBooking() {
    let apiData = JSON.stringify({
      trainerBookingId: this.storeBookingId,
      patientId: localStorage.getItem('patient_id'),
    });
    this.services
      .postRequest('patientTrainerCancelBooking', apiData)
      .subscribe((res) => {
        if (res.status == 1) {
          setTimeout(() => {
            this.loadingController.dismiss();
          }, 500);
          this.pageNo = 1;
          this.storeBookingList = [];

          if (res.data[0].msgcode == 2) {
            this.AlertInfo(this.addCall.title449, res.status);
          } else if (res.data[0].msgcode == 1) {
            this.AlertInfo(this.addCall.title450, res.status);
          } else if (res.data[0].msgcode == 3) {
            this.AlertInfo(this.addCall.title451, 0);
          }
          this.showBookinkList();
        } else {
          setTimeout(() => {
            this.loadingController.dismiss();
          }, 500);
          this.AlertInfo(res.msg, res.status);
        }
      });
  }

  openChat() {
    this.router.navigate(['/tabs/chat']);
  }
  gocalendarpage() {
    this.presentView = 'calenderPage';
  }

  // -------------------\/-------------BACK FLOW ONLY------------------\/----------------//
  back(value) {
    switch (value) {
      case 'goHome': {
        this.router.navigate(['../tabs/home']);
        this.searchContent = null;
        this.searchContent = ' ';
        break;
      }
    }
  }
  isShowHeaderValue: any;
  // isCheckedList:any;
  goBack(value) {
    switch (value) {
      case 'goHome': {
        this.router.navigate(['../tabs/home']);
        this.searchContent = null;
        this.currentPlaying.pause();
        this.currentPlaying = null;
        break;
      }
      case 'goTrainersPage': {
        this.presentView = 'listTrainerPage';
        this.storeTrainerList = [];
        this.ionViewWillEnter();
        this.fristinlist_page();
        this.isShowHeaderValue = false;
        this.backValue = 'goHome';
        this.headerValue = 'Trainer';
        this.searchContent = null;
        this.storesltdate = [];
        this.dateMultil = [];
        this.activeMonday = null;
        this.activeTuesday = null;
        this.activeWednesday = null;
        this.activeThursday = null;
        this.activeFriday = null;
        this.activeSaturday = null;
        this.activeSunday = null;

        this.mondayInputArray = [];
        this.tuesdayInputArray = [];
        this.wednesdayInputArray = [];
        this.thursdayInputArray = [];
        this.fridayInputArray = [];
        this.saturdayInputArray = [];
        this.sundayInputArray = [];

        this.forArray = [];
        this.selectedPackageArray = [];
        this.indexofWeek = '';
        this.totaldaysWeek = [];
        this.storeNrOfWeek = [];
        this.commonheadervalue = 'trainerheader';
        break;
      }
      case 'goOffers': {
        this.presentView = 'trainerProPage';
        this.viewOffersSlidsCrds = true;
        this.viewOfferInfo = false;
        this.selectDate = false;
        this.backValue = 'goTrainersPage';
        this.isShow = true;
        break;
      }
      case 'goOfferInfo': {
        this.openOffInfo(this.storeOfferCardIndex);
        break;
      }
      case 'goSelectDatePage': {
        this.presentView = 'trainerProPage';
        this.viewOffersSlidsCrds = false;
        this.viewOfferInfo = false;
        this.selectDate = true;
        if (this.selectDatePageFlow != 'repeat') {
          this.headerValue = this.particulrOfferDetails.tr_package_name;
          this.backValue = 'goOfferInfo';
        } else if (this.selectDatePageFlow == 'repeat') {
          this.headerValue = this.repeatBkgData.tr_package_name;
          this.backValue = 'goBkgHisList';
        }
        break;
      }
      case 'goBkgConPage': {
        this.showBookgConfrPage();
        break;
      }
      case 'goBkgList': {
        this.pageNo = 1;
        this.storeBookingList = [];
        this.StoreWayBookingPageFlow = 'bookingList';
        this.showBookinkList();
        this.showdateday = [];
        this.storereschtodate = [];
        this.storereschfromdate = [];
        this.ChangeEventTrainer.emit('isTrainerBackBooking');

        this.isShowHeaderValue = false;
        break;
      }
      case 'goBkgInfo': {
        this.viewBookingDetail(this.bookingListIndex, '');
        this.rescheduledatefrm = null;
        this.rescheduledateto = null;
        this.showdateday = [];
        this.storereschtodate = [];
        this.storereschfromdate = [];
        break;
      }
      case 'goBkgHisList': {
        this.pageNo = 1;
        this.historyList = [];
        this.ChangeEventTrainer.emit('isTrainerBackHistory');
        this.isShowHeaderValue = false;
        this.showBookingHisList();
        break;
      }
      case 'goTrainerdet': {
        this.presentView = 'trainerdetailpart';
        if (this.selectDatePageFlow == 'repeat') {
          this.headerValue = this.repeatBkgData.trainerName;
          this.backValue = 'goBkgHisList';
        } else {
          this.headerValue = this.storePatclrTnrSomeInfo.vendor_name; //this.tr_pack_det.tr_package_name;
          this.backValue = 'goTrainersPage';
        }
        break;
      }
      default: {
        this.resetListTnrVarls();
        this.showListTrainerPage('');
        break;
      }
    }

    this.isConfirmed = false

  }

  async openDatePicker2() {
    const datePickerModal = await this.modalCtrl.create({
      component: DatePikerPage,
      cssClass: 'datePicker',
      componentProps: {
        selectedDate: this.selectedDate,
        calenderType: 'dob', //normal/dob
      },
    });
    await datePickerModal.present();

    datePickerModal.onDidDismiss().then((data) => {
      if (data.data) {
        this.Date = data.data;
        this.membDOB = this.getFormattedDateTime(this.Date, 'Date');
        this.getMemDob =
          this.Date.getFullYear() +
          '-' +
          (this.Date.getMonth() + 1) +
          '-' +
          this.Date.getDate();
      }
    });
  }

  uploadPhoto() {
    this.fileupload.getFiles('2').then(async (data) => {
      if (data[0] == '0') {
        const toast = await this.toastController.create({
          message: data[1],
          duration: 2000,
        });
        toast.present();
      }
    });
  }

  insertMemberDetails() {
    if (
      this.getMemName != null &&
      this.getMemGender != null &&
      this.getMemReletion != null &&
      this.getMemHeight != null &&
      this.getMemWeight != null &&
      this.getMemMobileNo != null &&
      this.getMemDob != null
    ) {
      this.insertMember();
    } else {
      let value = [
        {
          f_Name: 'Enter Name',
          f_value: this.getMemName,
        },
        {
          f_Name: 'Choose Gender',
          f_value: this.getMemGender,
        },
        {
          f_Name: 'Select Date Of Birth',
          f_value: this.getMemDob,
        },
        {
          f_Name: 'Choose Reletion',
          f_value: this.getMemReletion,
        },
        {
          f_Name: 'Enter Height',
          f_value: this.getMemHeight,
        },
        {
          f_Name: 'Enter Weight',
          f_value: this.getMemWeight,
        },
        {
          f_Name: 'Enter Mobile No',
          f_value: this.getMemMobileNo,
        },
      ];
      for (let item of value) {
        if (item.f_value == null) {
          this.toastMessage = 'please ' + item.f_Name;
          this.presentToast();
          break;
        }
      }
    }
  }

  insertMember() {
    this.presentLoading();
    let apiData = JSON.stringify({
      parentpatientId: localStorage.getItem('patient_id'),
      patientId: 0,
      name: this.getMemName,
      gender: this.getMemGender,
      dob: this.getMemDob, //"11/11/97"
      relationId: this.getMemReletion,
      heightcm: this.getMemHeight,
      weightkg: this.getMemWeight,
      phoneno: this.getMemMobileNo,
      modifiedby: localStorage.getItem('patient_id'),
    });
    console.log('send Member Data=>10', JSON.parse(apiData));
    this.services
      .postRequest('addPatientmemberDetails', apiData)
      .subscribe((res) => {
        if (res.status == 1) {
          setTimeout(() => {
            this.loadingController.dismiss();
          }, 500);

          this.AlertInfo(this.addCall.title280, res.status);
          this.getPatientBasicDetails(1);
        } else {
          setTimeout(() => {
            this.loadingController.dismiss();
          }, 500);
          this.AlertInfo(this.addCall.title280, res.status);
        }
      });
  }

  getPatientReletion() {
    this.services.getRequest('getpatientrelation').subscribe((res) => {
      this.reletionList = res.data;
    });
  }
  async Alertpopup_VC(msg, status) {
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert_vc1',
      backdropDismiss: false,
      componentProps: {
        msg: msg,
        sts: status,
      },
    });
    alert.onDidDismiss().then((data) => {
      console.log(data);
    });
    await alert.present();
  }

  getVdoConf1(data) {
    const fromTime = data.from_time; //"02:00:00";
    const toTime = data.to_time; //"04:56:00";
    const duration = '01:00:00';

    // Function to convert time string to total seconds
    function timeStringToSeconds(timeString) {
      const [hours, minutes, seconds] = timeString.split(':').map(Number);
      return hours * 3600 + minutes * 60 + seconds;
    }

    // Function to convert total seconds to time string
    function secondsToTimeString(totalSeconds) {
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
        2,
        '0'
      )}:${String(seconds).padStart(2, '0')}`;
    }

    // Convert time strings to total seconds
    const fromTimeSeconds = timeStringToSeconds(fromTime);
    const toTimeSeconds = timeStringToSeconds(toTime);
    const durationSeconds = timeStringToSeconds(duration);

    // Subtract 'a' from 'fromTime' and 'toTime'
    const startTimeSeconds = fromTimeSeconds - durationSeconds;
    const endTimeSeconds = toTimeSeconds + durationSeconds;

    // Format the results back into time strings
    const startTime = secondsToTimeString(startTimeSeconds);
    const endTime = secondsToTimeString(endTimeSeconds);
    // Get current time in a 24-hour format
    const currentTime = new Date().toLocaleTimeString('en-US', {
      hour12: false,
    });

    // Compare a1 with current time
    // a1 <= currentTime && currentTime >= a2
    // this.endtime > currentTimeString && start_number <= currentTimeString
    if (startTime > currentTime) {
      console.log(currentTime, 'a1 is less than the current time.');
      // this.toastMessage = 'You cannot join the meeting now. Please wait.';
      this.toastMessage = this.addCall.title731;
      this.presentToast();
    } else if (endTime < currentTime) {
      console.log(
        currentTime,
        'a1 is greater than or equal to the current time.'
      );
      // this.toastMessage ='You cannot join the meeting now. Meeting already ended.';
      this.toastMessage = this.addCall.title724;
      this.presentToast();
    } else if (startTime <= currentTime && currentTime <= endTime) {
      this.router.navigate(['/videocall'], { queryParams: { roomName: data.tr_vc_room.split("/")[3], endTime: endTime } });
      // this.toastMessage = 'Meeting has started. You can join the meeting.';
      this.toastMessage = this.addCall.title725;
      this.presentToast();
    }
  }
  getVdoConf(data) {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // January is 0!
    const day = String(today.getDate()).padStart(2, '0');
    const currentDate = `${year}-${month}-${day}`;

    const startTime = data.Vc_startTime; //"02:00:00";
    const endTime = data.Vc_endTime; //"04:56:00";
    const currentTime = new Date().toLocaleTimeString('en-US', {
      hour12: false,
    });

    let todayWorking = [];
    todayWorking = data.workingHours.filter(element => element.date == currentDate);
    if (todayWorking.length != 0) {
      if (startTime > currentTime) {
        this.Alertpopup_VC(this.addCall.title625, 73);
      } else if (endTime < currentTime) {
        // this.Alertpopup_VC('Meeting has ended. You cannot join the meeting.', 73);
        this.Alertpopup_VC(this.addCall.title706, 73);
      } else if (startTime <= currentTime && currentTime <= endTime) {
        this.router.navigate(['/videocall'], { queryParams: { roomName: data.tr_vc_room.split("/")[3], endTime: endTime } });
        // this.toastMessage = 'Meeting has started. You can join the meeting.';
        this.toastMessage = this.addCall.title725;
        this.presentToast();
      }
    } else {
      // this.Alertpopup_VC('Cannot join the meeting for this day.', 73);
      this.Alertpopup_VC(this.addCall.title707, 73);
    }
  }

  async reviewPopup(id, proImg, name, reviewcount, trainer_bookingid) {
    if (reviewcount == 0) {
      const alert = await this.modalCtrl.create({
        component: ReviewPage,
        cssClass: 'review-class',
        componentProps: {
          Id: id,
          Img: proImg,
          Name: name,
          From: 'Trainer',
          bookingId: trainer_bookingid,
        },
      });
      alert.onDidDismiss().then((data) => {
        if (data.data == 'dismiss') {
          this.wayOfBookingListpages('bookingHisList');
        }
      });
      await alert.present();
    }
  }

  async playMedia() {
    try {
      await this.currentPlaying?.play();
    } catch (err) {
      await this.currentPlaying?.pause();
      this.didScrollEvent(event);
    }
  }

  isElementInViewPort(el) {
    const rect = el.getBoundingClientRect();
    const top = Math.round(rect.top);
    const left = Math.round(rect.left);
    const bottom = Math.round(rect.bottom);
    const right = Math.round(rect.right);
    return (
      top >= 0 &&
      left >= 0 &&
      bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
      right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  pausePlay(id, mid) {
    const uniqueVideoId = `VideoLab${id}${mid}`;
    if (this.currentPlaying?.id !== uniqueVideoId) {
      if (this.currentPlaying) this.currentPlaying.pause();
      this.currentPlaying = document.getElementById(uniqueVideoId);
    }
    if (this.currentPlaying) {
      this.currentPlaying.paused
        ? this.currentPlaying.play()
        : this.currentPlaying.pause();
    }
  }


  didScrollEvent(event) {
    try {
      if (this.Addcheckvarible) return;
      const inViewPort = this.vdoPlayer.find((player) =>
        this.isElementInViewPort(player.nativeElement)
      );
      if (inViewPort && this.currentPlaying !== inViewPort.nativeElement) {
        if (this.currentPlaying) this.currentPlaying.pause();
        this.currentPlaying = inViewPort.nativeElement;
        this.currentPlaying.paused
          ? this.currentPlaying.play()
          : this.currentPlaying.pause();
      } else if (!inViewPort && this.currentPlaying) {
        this.currentPlaying.pause();
        this.currentPlaying = null;
      }
    } catch (err) {
      console.error(err);
    }
  }

  lastTapTime: number = 0;
  delay: number = 300;
  doubleClick(count, index, trainId, isLiked) {

    const currentTime = new Date().getTime();
    const elapsedTime = currentTime - this.lastTapTime;
    if (elapsedTime < this.delay) {
      let _obj = this;
      this.makeLikes(index, trainId, 1, 2, isLiked == 1 ? "true" : "false");
      this.count += Number(count);
      this.dblClikedIndex = index;
      this.likedPopUpStatus = true;
      setTimeout(() => {
        _obj.likedPopUpStatus = false;
      }, 1000);
    }
    this.lastTapTime = currentTime;
  }
  doubleClick1(count, index, trainId) {
    let _obj = this;

    this.count += Number(count);

    if (this.count == 1) {
      setTimeout(() => {
        _obj.count = 0;
      }, 300);
    }
    if (this.count == 2) {
      this.makeLike1(index, trainId, 1, 2, '');
      this.count = 0;
      this.dblClikedIndex = index;
      this.likedPopUpStatus = true;
      setTimeout(() => {
        _obj.likedPopUpStatus = false;
      }, 1000);
    }
  }
  makeLikes(i, trainId, isLyk, from, isLiked) {
    try {
      let data = JSON.stringify({
        vendor_id: trainId,
        like: isLyk,
        user_id: localStorage.getItem('patient_id'),
        module_name: 'Trainer',
        isLiked: isLiked
      });
      const UpdateVendorLikes = this.services
        .postRequestDoc('UpdateVendorLikes', data)
        .subscribe(
          (res) => {
            console.log(res);
            if (this.storeTrainerList[i].isLiked != 1) {
              this.storeTrainerList[i].likes_count =
                Number(this.storeTrainerList[i].likes_count) + 1;
            }
            this.storeTrainerList[i].isLiked = 1;
          },
          (err) => {
            console.log(err);
          }
        );
    } catch (err) {
      console.log(err);
    }
  }
  makeLike(i, trainId, isLyk, from, isLiked) {
    try {
      if (this.storeTrainerList[i].isLiked == null) {
        this.storeTrainerList[i].isLiked = 1;
        this.storeTrainerList[i].likes_count =
          Number(this.storeTrainerList[i].likes_count) + 1;
      }
      if (from == 2) {
        if (this.storeTrainerList[i].isLiked == 0) {
          this.storeTrainerList[i].isLiked = 1;
          this.storeTrainerList[i].likes_count =
            Number(this.storeTrainerList[i].likes_count) + 1;
        }
      } else if (from == 1) {
        if (this.storeTrainerList[i].isLiked == 0) {
          this.storeTrainerList[i].isLiked = 1;
          this.storeTrainerList[i].likes_count =
            Number(this.storeTrainerList[i].likes_count) + 1;
        } else if (this.storeTrainerList[i].isLiked == 1) {
          this.storeTrainerList[i].isLiked = 0;
          this.storeTrainerList[i].likes_count =
            Number(this.storeTrainerList[i].likes_count) - 1;
        }
      }
      let data = JSON.stringify({
        vendor_id: trainId,
        like: isLyk,
        user_id: localStorage.getItem('patient_id'),
        module_name: 'Trainer',
        isLiked: (isLiked == 1) ? "true" : "false"
      });
      this.services.postRequestDoc('UpdateVendorLikes', data).subscribe(
        (res) => { },
        (err) => {
          console.log(err);
        }
      );
    } catch (err) {
      console.log(err);
    }
  }

  makeLike1(i, trainId, isLyk, from, isLiked) {
    try {
      if (this.storeTrainerList[i].isLiked == null) {
        this.storeTrainerList[i].isLiked = 1;
        this.storeTrainerList[i].likes_count =
          Number(this.storeTrainerList[i].likes_count) + 1;
      }
      if (from == 2) {
        if (this.storeTrainerList[i].isLiked == 0) {
          this.storeTrainerList[i].isLiked = 1;
          this.storeTrainerList[i].likes_count =
            Number(this.storeTrainerList[i].likes_count) + 1;
        }
      } else if (from == 1) {
        if (this.storeTrainerList[i].isLiked == 0) {
          this.particularTrainerDetails.isLiked = 1;
          this.particularTrainerDetails.likes_count =
            Number(this.storeTrainerList[i].likes_count) + 1;
          this.storeTrainerList[i].isLiked = 1;
          this.storeTrainerList[i].likes_count =
            Number(this.storeTrainerList[i].likes_count) + 1;
        } else if (this.storeTrainerList[i].isLiked == 1) {
          this.particularTrainerDetails.isLiked = 0;
          this.storeTrainerList[i].isLiked = 0;
          this.particularTrainerDetails.likes_count =
            Number(this.storeTrainerList[i].likes_count) - 1;
          this.storeTrainerList[i].likes_count =
            Number(this.storeTrainerList[i].likes_count) - 1;
        }
      }
      let data = JSON.stringify({
        vendor_id: trainId,
        like: isLyk,
        user_id: localStorage.getItem('patient_id'),
        module_name: 'Trainer',
        isLiked: isLiked
      });
      this.services.postRequestDoc('UpdateVendorLikes', data).subscribe(
        (res) => {
          console.log(res);
        },
        (err) => {
          console.log(err);
        }
      );
    } catch (err) {
      console.log(err);
    }
  }

  getMedia(tr_id) {
    let tempArr = [];
    if (this.mediaReq) {
      this.mediaReq.unsubscribe();
    }
    this.profileMediaDetails = [];
    let apiData2 = JSON.stringify({
      doctorId: tr_id,
      limit: 1000,
      pageno: 1,
    });
    this.mediaReq = this.services.postRequest('getMediaDetailsByDoctor', apiData2).subscribe((res) => {
        for (let item of res.data[0].details) {
          tempArr.push(item);
          if (tempArr.length == 3) {
            this.profileMediaDetails.push(JSON.parse(JSON.stringify(tempArr)));
            tempArr = [];
          }
        }
        if (tempArr.length > 0) {
          this.profileMediaDetails.push(JSON.parse(JSON.stringify(tempArr)));
        }
      });
  }

  async openNdPlay(type: any, path: any, mode: any, thumbnail: any) {
    if (this.storedPath === path) {
      this.showPopover(type, path, thumbnail);
    } else {
      this.storedPath = path;
      this.showPopover(type, path, thumbnail);
    }
  }

  private async showPopover(type: any, path: any, thumbnail: any) {
    const popover = await this.modalCtrl.create({
      component: MediapopupPage,
      componentProps: {
        Type: type,
        Path: path,
        ThumNail: thumbnail,
      },
      cssClass: 'media-popup',
    });
    await popover.present();
  }
  // async openNdPlay(type, path, mode, thumnail) {
  //   let popover = await this.modalCtrl.create({
  //     component: MediapopupPage,
  //     componentProps: {
  //       Type: type,
  //       Path: path,
  //       ThumNail: thumnail,
  //     },
  //     cssClass: 'media-popup',
  //   });
  //   return await popover.present();
  // }

  async showaddress(address, myEvent) {
    let popover = await this.popoverCtrl.create({
      component: ModpricetagPage,
      event: myEvent,
      componentProps: {
        address: address,
        from: 'doctorBKFC',
      },
      translucent: true,
      cssClass: 'offrMod1',
    });
    popover.onDidDismiss();
    //
    return await popover.present();
  }
  async viewMore(frm: any, cname: any) {
    debugger;
    if (frm == 'showdates') {
      let sortArray = this.showsltdate.sort((a, b) => {
        const dateA = new Date(a.split('-').reverse().join('-')).getTime();
        const dateB = new Date(b.split('-').reverse().join('-')).getTime();
        return dateA - dateB;
    });
      let popover = await this.modalCtrl.create({
        component: ViewmodelPage,
        componentProps: {
          From: frm,
          showselectdate: sortArray, //this.storesltdate,
          vendor: 'trainer',
        },
        cssClass: cname,
      });
      return await popover.present();
    } else if (frm == 'showTimeBookingDetails') {
      let sortArray = this.particularBkgDetails.workingHours.sort((a, b) => {
        const dateA = new Date(a.date).getTime();
        const dateB = new Date(b.date).getTime();
        return dateA - dateB;
    });
      let popover = await this.modalCtrl.create({
        component: ViewmodelPage,
        componentProps: {
          From: frm,
          // workingHours: this.particularBkgDetails.workingHours, //this.storesltdate,
          workingHours: sortArray,
        },
        cssClass: cname,
      });
      return await popover.present();
    } else if (frm == 'showTimeBookingHistoryDetails') {
      let sortArray = this.historyDetails.workingHours.sort((a, b) => {
        const dateA = new Date(a.date).getTime();
        const dateB = new Date(b.date).getTime();
        return dateA - dateB;
    });
      let popover = await this.modalCtrl.create({
        component: ViewmodelPage,
        componentProps: {
          From: frm,
          workingHoursHistory: sortArray, //this.storesltdate,
        },
        cssClass: cname,
      });
      return await popover.present();
    }
  }

  async viewMoredata(frm: any, cname: any) {
    let popover = await this.modalCtrl.create({
      component: ViewmodelPage,
      componentProps: {
        From: frm,
        showselectdate: this.packName, //this.storesltdate,
      },
      cssClass: cname,
    });
    return await popover.present();
  }

  async viewMoredatas(frm: any, cname: any) {
    let popover = await this.modalCtrl.create({
      component: ViewmodelPage,
      componentProps: {
        From: frm,
        showselectdate: this.particularBkgDetails.tr_package_name,
      },
      cssClass: cname,
    });
    return await popover.present();
  }
  async viewMoreAddressdata(frm: any, cname: any, fromAdd) {
    let popover = await this.modalCtrl.create({
      component: ViewmodelPage,
      componentProps: {
        From: frm,
        showadress: fromAdd == 'patientAdd' ? this.particularBkgDetails.memberAddress :
          fromAdd == 'patienthistoryAdd' ? this.historyDetails.memberAddress :
            fromAdd == 'trainerhistoryAdd' ? this.historyDetails.vendor_address :
              this.particularBkgDetails.vendor_address,
      },
      cssClass: cname,
    });
    return await popover.present();
  }

  async viewMoreAddress(frm: any, cname: any, trMode) {
    let popover = await this.modalCtrl.create({
      component: ViewmodelPage,
      componentProps: {
        From: frm,
        showadress: trMode == 'fromHome' ? this.memberAddress :
          this.particularTrainerDetails.vendor_address,
      },
      cssClass: cname,
    });
    return await popover.present();
  }

  Male: any;
  Female: any;
  genderStatus: any;
  genderValue: any;
  selctDctGndr(value) {
    switch (value) {
      case 'Male': {
        this.Male = true;
        this.Female = false;
        if (this.Male) {
          this.genderStatus = true;
          this.genderValue = this.addCall.title96;
        } else {
          this.genderStatus = false;
        }
        break;
      }
      case 'Female': {
        this.Female = true;
        this.Male = false;
        if (this.Female) {
          this.genderStatus = true;
          this.genderValue = this.addCall.title97;
        } else {
          this.genderStatus = false;
        }
        break;
      }
    }
  }

  userapprove_Status: any = 0;
  Doctorapprove_Status: any = 0;
  //playVidVC: any;
  id: any = 'vdo';
  Type: any;
  Path: any;
  ThumNail: any;

  vc_permission(bookingid, memberapproval, trainerapproval) {
    console.log(bookingid, memberapproval, trainerapproval);
  }
  deal_serviceid: any;
  async offrDtils(myEvent, dealDet, i, trainerId) {
    let popover = await this.popoverCtrl.create({
      component: ModpricetagPage,
      event: myEvent,
      componentProps: {
        from: 'traineronly',
        dealdetails: dealDet,
      },
      translucent: true,
      cssClass: 'offrMod',
    });
    popover.onDidDismiss().then((data) => {
      if (data.data) {
        this.deal_serviceid = data.data.packdet[0].tr_package_id;
        this.showTrainerProfile(i, trainerId);
        this.selectedDealdata(data);
      }
    });
    return await popover.present();
  }

  allDates: any = [];
  allDate: any = [];
  generateDatesForMonth(month: number, year: number) {
    this.allDates = [];
    this.allDates = [];
    let allDatesMonths = [];
    const isLeapYear = this.isLeapYear(year);
    const daysInMonth = this.getDaysInMonth(month, isLeapYear);
    const startDate = new Date(year, month - 1, 1); // Month is zero-based
    const endDate = new Date(year, month - 1, daysInMonth);
    for (
      let date = startDate;
      date <= endDate;
      date.setDate(date.getDate() + 1)
    ) {
      const formattedDate = this.formatDate(date);
      allDatesMonths.push(formattedDate);
    }
    // remove
    this.allDates = allDatesMonths.map((dateString) => {
      const dateParts = dateString.split('-');
      const year: number =
        parseInt(dateParts[2], 10) +
        (parseInt(dateParts[2], 10) < 50 ? 2000 : 1900);
      const currentDate: Date = new Date(
        year,
        parseInt(dateParts[1], 10) - 1,
        parseInt(dateParts[0], 10)
      );
      const dayOfWeek: string = currentDate
        .getDate()
        .toString()
        .padStart(2, '0');
      const month: string = (currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0');
      const formattedDate: string = `${dayOfWeek}-${month}-${year}`;
      const formatDate: string = `${year}-${month}-${dayOfWeek}`;
      return {
        dates: formattedDate,
        formatdate: formatDate,
        month: currentDate.getMonth() + 1,
        year: currentDate.getFullYear(),
      };
    });
    this.allDate.push(...this.allDates);
  }

  // Function to check if a year is a leap year
  isLeapYear(year: number): boolean {
    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
  }

  // Function to get the number of days in a month
  getDaysInMonth(month: number, isLeapYear: boolean): number {
    const daysInMonthMap = [
      31,
      isLeapYear ? 29 : 28,
      31,
      30,
      31,
      30,
      31,
      31,
      30,
      31,
      30,
      31,
    ];
    return daysInMonthMap[month - 1];
  }

  // Function to format a date as "01-02-04"
  formatDate(date: Date): string {
    const day = this.padZero(date.getDate());
    const month = this.padZero(date.getMonth() + 1); // Months are zero-based
    const year = this.padZero(date.getFullYear() % 100);

    return `${day}-${month}-${year}`;
  }
  getMonthYear(data: any): any {
    let result = [];
    for (let i = 0; i < data.length; i++) {
      // Need to Change After DB Changes
      let formatDate = data[i].dates.split('-').reverse().join('-');
      let dates = new Date(formatDate);
      let month = dates.getMonth() + 1;
      let year = dates.getFullYear();
      result.push({ month: month, year: year, formatDate: formatDate });
    }
    result = Array.from(new Set(result));
    const uniqueObje = result.reduce((acc, item) => {
      if (
        !acc.some((obj) => obj.month === item.month && obj.year === item.year)
      ) {
        acc.push(item);
      }
      return acc;
    }, []);
    return uniqueObje;
  }

  trainingMode: any;
  config: any[] = [];
  basicDetils: any = {};
  calendarPresentMonth: any;
  LoadCalenar(mode: any) {
    this.clearValues();
    this.disbaleCheck = false;
    this.selectedPackageArray.forEach((item, index) => {
      if (index == 0) {
        this.basicDetils.trainerId = item.tr_training_id;
        this.basicDetils.packageId = item.tr_package_id;
        this.basicDetils.appointmentScheduleId = item.appointmentScheduleId;
        this.basicDetils.trainingMode = item.tr_training_mode;
        this.basicDetils.amount = item.tr_cost;
        this.basicDetils.dealValue = item.dealValue;
        this.basicDetils.dealOption = item.dealOption;
      }
    });
    let getMonthYear = this.getMonthYear(this.selectedPackageArray);
    if (getMonthYear.length == 1) {
      getMonthYear.push({
        month: this.presentMonth + 1,
        year: new Date().getFullYear(),
        formatDate: '',
      });
    }
    if (mode == 'Manual') {
      this.trainingMode = 'Manual';
      for (let i = 0; i <= getMonthYear.length; i++) {
        if (getMonthYear[i] != undefined) {
          this.generateDatesForMonth(
            getMonthYear[i].month,
            getMonthYear[i].year
          );
          this.generateDatesForMonth(this.presentMonth, getMonthYear[i].year);
        }
      }
      let current_Month = this.selectedPackageArray.filter(
        (x) => x.month == this.presentMonth
      );
      if (current_Month == 0) {
        this.selectedPackageArray.forEach((item) => {
          item.formateDate = item.dates.split('-').reverse().join('-');
        });
      }
      // var selectedDates = this.selectedPackageArray.filter(({ dates: id1 }) => !this.allDate.some(({ date: id2 }) => id2 == id1));
      // this.dateMultil = this.selectedDate; for the automatically load the dates selected
      let selectedPackage = this.selectedPackageArray.filter(
        (x) => x.month == this.presentMonth
      );
      let disabledDates = this.allDate.filter(
        ({ dates: id1 }) =>
          !selectedPackage.some(({ dates: id2 }) => id2 == id1)
      );
      disabledDates.forEach((item) => {
        let value = this.getDetailfromDate(item.formatdate);
        let config = {
          date: new Date(),
          disable: false,
        };
        config.date = new Date(value.year, value.month, value.day);
        config.disable = true;
        this.config.push(config);
      });
      this.optionsMultil = {
        pickMode: 'multi',
        weekdays: [
          this.addCall.title411,
          this.addCall.title412,
          this.addCall.title413,
          this.addCall.title414,
          this.addCall.title415,
          this.addCall.title416,
          this.addCall.title417,
        ],
        daysConfig: this.config,
        showMonthPicker: false,
      };
      this.showcal = true;
    }
  }

  getMinimumDate(dateArray, datePropertyName) {
    if (dateArray.length === 0) {
      return null; // Return null or handle empty array case as needed
    }
    return dateArray.reduce((minDate, currentDate) => {
      const currentDateTime = new Date(currentDate[datePropertyName]);
      return !minDate || currentDateTime < minDate ? currentDateTime : minDate;
    }, null);
  }

  getPreviousDates(numDays) {
    const currentDate = new Date();
    const previousDates = [];

    for (let i = 1; i <= numDays; i++) {
      const previousDate = new Date(currentDate);
      previousDate.setDate(currentDate.getDate() - i);
      previousDates.push(previousDate);
    }

    return previousDates;
  }

  getNextDateInCurrentMonth() {
    // Get the current date
    const currentDate = new Date();

    // Get the current day of the month
    const currentDay = currentDate.getDate();

    // Calculate the next day
    const nextDay = currentDay + 1;

    // Set the date to the next day
    currentDate.setDate(nextDay);

    // Format the result as a string
    const resultDate = currentDate.toISOString().split('T')[0]; // Get YYYY-MM-DD format

    return resultDate;
  }

  clearValues() {
    this.allDate = [];
    this.config = [];
    this.dateMultil = [];
    this.derivedates = [];
    this.filteredVar = [];
    this.removeChecked = [];
    this.totaldaysWeek = [];
    this.mondayInputArray = [];
    this.tuesdayInputArray = [];
    this.wednesdayInputArray = [];
    this.thursdayInputArray = [];
    this.fridayInputArray = [];
    this.saturdayInputArray = [];
    this.sundayInputArray = [];
    this.activeMonday = false;
    this.activeTuesday = false;
    this.activeWednesday = false;
    this.activeThursday = false;
    this.activeFriday = false;
    this.activeSaturday = false;
    this.activeSunday = false;
    this.storeNrOfWeek = [];
    this.forArray = [];
    this.removeCount = 0;
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    this.presentMonth = currentMonth;
    this.presentYear = currentDate.getFullYear();
    this.calendarPresentMonth = currentMonth;
    this.representMonth = currentMonth;
    this.presentWeek = '';
    this.CommonDates = [];
  }

  resetCalendar() {
    this.dateMultil = null;
  }

  derivedates: any = [];
  filteredVar: any = [];
  removeChecked: any = [];
  removeCount = 0;
  removeType: any;
  changeof(data) {
    let dateString = data;
    let date = new Date(dateString);
    let year = date.getFullYear();
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let day = date.getDate().toString().padStart(2, '0');
    let formattedDate = year + "-" + month + "-" + day;
    return formattedDate;
  }

  GetValues(date, $event) {
    if (date.length == this.selectedPackageArray[0].tr_session) {
      let dummy = [];
      for (let i = 0; i < date.length; i++) {
        dummy.push(this.changeof(date[i]._d))
      }
      this.config = [];
      let disabledDates = this.allDate.filter(objA => !dummy.includes(objA.formatdate));
      disabledDates.forEach((item) => {
        let value = this.getDetailfromDate(item.formatdate);
        let config = {
          date: new Date(),
          disable: false,
        };
        config.date = new Date(value.year, value.month, value.day);
        config.disable = true;
        this.config.push(config);
      });

      this.optionsMultil = {
        pickMode: 'multi',
        weekdays: [this.addCall.title411, this.addCall.title412, this.addCall.title413, this.addCall.title414,
        this.addCall.title415, this.addCall.title416, this.addCall.title417],
        daysConfig: this.config,
      };

      if (this.trainingMode == 'Manual' && this.dateMultil.length >= 1) {
        this.avail_book = true;
      } else {
        this.avail_book = false;
      }

      if (this.dateMultil.length <= this.removeCount) {
        this.removeCount--;
        this.removeType = 'Remove';
      } else {
        this.removeCount += 1;
        this.removeType = 'Add';
      }

      date.forEach((item) => {
        this.filteredVar.push(this.anDateforter(item._d));
        let dates = this.dateformatter(item._d);
        this.removeChecked.push(dates);
      });
      this.derivedates = [];
      this.derivedates = [...new Set(this.filteredVar)];
      if (this.theMonthChanged == 'monthChanged') {
        this.calculateOfWeeks('Noraml', 'changeofMonth');
      } else {
        this.calculateOfWeeks(this.removeType, '');
      }
      this.theMonthChanged = '';
    } else if (date.length <= this.selectedPackageArray[0].tr_session) {
      this.presentWeek = '';
      this.indexofWeek = '';
      this.removeChecked = [];
      this.derivedates = [];
      this.filteredVar = [];

      let selectedPackage = this.selectedPackageArray.filter((x) => x.month == this.presentMonth);

      let disabledDatesof = this.allDate.filter(
        ({ dates: id1 }) => !selectedPackage.some(({ dates: id2 }) => id2 == id1)
      );
      this.config = [];
      disabledDatesof.forEach((item) => {
        let value = this.getDetailfromDate(item.formatdate);
        let config = {
          date: new Date(),
          disable: false,
        };
        config.date = new Date(value.year, value.month, value.day);
        config.disable = true;
        this.config.push(config);
      });
      this.optionsMultil = {
        pickMode: 'multi',
        weekdays: [this.addCall.title411, this.addCall.title412, this.addCall.title413, this.addCall.title414,
        this.addCall.title415, this.addCall.title416, this.addCall.title417],
        daysConfig: this.config,
        showMonthPicker: false,
      };
      if (this.trainingMode == 'Manual' && this.dateMultil.length >= 1) {
        this.avail_book = true;
      } else {
        this.avail_book = false;
      }

      if (this.dateMultil.length <= this.removeCount) {
        this.removeCount--;
        this.removeType = 'Remove';
      } else {
        this.removeCount += 1;
        this.removeType = 'Add';
      }
      date.forEach((item) => {
        this.filteredVar.push(this.anDateforter(item._d));
        let dates = this.dateformatter(item._d);
        this.removeChecked.push(dates);
      });
      this.derivedates = [];
      this.derivedates = [...new Set(this.filteredVar)];
      if (this.theMonthChanged == 'monthChanged') {
        this.calculateOfWeeks('Noraml', 'changeofMonth');
      } else {
        this.calculateOfWeeks(this.removeType, '');
      }
      this.theMonthChanged = '';
    }

  }


  anDateforter(dated) {
    let inputDate = new Date(dated);
    let day = inputDate.getDate();
    let month = inputDate.getMonth() + 1; // Months are zero-based
    let year = inputDate.getFullYear() % 100; // Get the last two digits of the year
    let formattedDateof = `${day < 10 ? '0' : ''}${day}-${month < 10 ? '0' : ''
      }${month}-${year}`;
    return formattedDateof;
  }

  dateformatter(dateDetails) {
    const dateObject = new Date(dateDetails);

    const day = String(dateObject.getDate()).padStart(2, '0');
    const month = String(dateObject.getMonth() + 1).padStart(2, '0');
    const year = dateObject.getFullYear();

    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate;
  }

  dateformatyymmdd(dateDetails) {
    const dateObject = new Date(dateDetails);

    const day = String(dateObject.getDate()).padStart(2, '0');
    const month = String(dateObject.getMonth() + 1).padStart(2, '0');
    const year = dateObject.getFullYear();

    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }

  getStartDateOfMonth(start_date, end_date) {
    let all_dates = [];
    const startDate = new Date(start_date);
    const endDate = new Date(end_date);
    const startMonth = startDate.getMonth();
    const startYear = startDate.getFullYear();
    const startDay = 1;
    const startOfMonth = new Date(startYear, startMonth, startDay);

    let currentDate = startOfMonth;
    while (currentDate < endDate) {
      const nextMonth = currentDate.getMonth() + 1;
      const nextYear = currentDate.getFullYear();
      const nextMonthStart = new Date(nextYear, nextMonth, startDay);
      all_dates.push(nextMonthStart);
      currentDate = nextMonthStart;
    }
    return all_dates;
  }

  getDetailfromDate(dates: any): any {
    let format = new Date(dates);
    const year = format.getFullYear();
    const month = format.getMonth();
    const day = format.getDate();
    return { year, month, day };
  }

  getFormatDatesForDisabled(dates: any): any {
    let format = new Date(dates);
    const year = format.getFullYear();
    const month = format.getMonth() + 1;
    const day = format.getDate();
    return { year, month, day };
  }

  padZero(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

  // For Manual the Disabled Dates need to Be Push this.config

  // For Auto Matic Disabled dates and also selected Dates need to be pushed
  async presentModal1(
    slctdMemVal,
    Email,
    Phoneno,
    billing_amount,
    packageId,
    appointmentScheduleId,
    amount,
    deal,
    dealoption,
    trainingMode,
    isMember
  ) {
    const modal = await this.modalCtrl.create({
      component: SuccessPage,
      backdropDismiss: false,
      // enterAnimation: this.animations.enterAnimation,
      // leaveAnimation: this.animations.leaveAnimation,
      // cssClass: 'success-page',
      // cssClass: status == 1 ?  'custom-popupfordeals' :'custom-popup_faild',
      cssClass: 'custom-popupfordeals',
      componentProps: {
        titleContent: 'SUCCESS!',
        messageContent: 'pay',
      },
    });
    modal.onDidDismiss().then(async (data) => {
      this.gopayment = true;
      this.payType = data.data;

      const loading = await this.loadingController.create({
        cssClass: 'my-custom-class',
        message: 'Please wait we are redirecting you to the payment gateway',
      });

      if (data.data == '1') {
        // this.gatewayFunction("", packageId, appointmentScheduleId, amount, billing_amount, deal, dealoption, trainingMode, isMember, "MASTER")

        await loading.present();
        this.payment
          .getsessionid(slctdMemVal, Email, Phoneno, billing_amount)
          .then(async (res: any) => {
            await loading.dismiss();
            this.gatewayFunction(
              res,
              packageId,
              appointmentScheduleId,
              amount,
              billing_amount,
              deal,
              dealoption,
              trainingMode,
              isMember,
              "MASTER"
            );
          });
      } else if (data.data == '2') {
        await loading.present();
        this.payment
          .getKnetsessionid('', Email, Phoneno, billing_amount)
          .then(async (res: any) => {
            await loading.dismiss();
            this.gatewayFunction(
              res,
              packageId,
              appointmentScheduleId,
              amount,
              billing_amount,
              deal,
              dealoption,
              trainingMode,
              isMember,
              "KNET"
            );
          });
      }
      // else if (data.data == '3') {
      //   await loading.present();
      //   this.payment
      //     .getApplesessionid(this.slctmemname, Email, Phoneno, billing_amount)
      //     .then(async (res: any) => {
      //       await loading.dismiss();
      //       this.gatewayFunction(
      //         res,
      //         packageId,
      //         appointmentScheduleId,
      //         amount,
      //         billing_amount,
      //         deal,
      //         dealoption,
      //         trainingMode,
      //         isMember,
      //         "APPLE PAY"
      //       );
      //     });
      // }

      this.payType = '';
      this.gopayment = false;
    });
    return await modal.present();
  }


  async SelectFixedorAuto() {
    let mode = '';
    let popover = await this.modalCtrl.create({
      component: TrainerPopupPage,
      cssClass: 'service-model1',
      componentProps: {
        // ServiceList: this.ServiceList,
        storeOfferCards: this.particularTrainerDetails.programList[0],
      },
    });
    popover.onDidDismiss().then((data: any) => {
      mode = data.data.selectedMode;
      this.LoadCalenar(mode);
    });

    return await popover.present();
  }

  newPayload: any = [];
  upDatePayload: any = [];
  upDatePayloadOnlCen: any = [];
  insertDatesTimetoDB() {
    this.newPayload = [];
    this.upDatePayload = [];
    this.upDatePayloadOnlCen = [];
    let upDateArray = [];
    let isAllChecked = [];
    isAllChecked = this.selectedPackageArray.filter(element => element.checked)
    if (this.selectedPackageArray[0].tr_session == isAllChecked.length) {
      this.isSaveChecked = false;
    }
    upDateArray = this.selectedPackageArray.
      filter((x) => x.checked == true && x.isReschedule == 1 && x.tr_training_mode == '1');
    if (upDateArray.length > 0) {
      for (let i = 0; i < upDateArray.length; i++) {
        this.upDatePayload.push({
          fromTime: upDateArray[i].tr_from_time,
          toTime: upDateArray[i].tr_to_time,
          day: upDateArray[i].days,
          date: upDateArray[i].dates,
          month: upDateArray[i].month,
          year: upDateArray[i].year,
          TrainerId: upDateArray[i].tr_vendor_id,
          patientId: localStorage.getItem('patient_id'),
          packageId: upDateArray[i].tr_package_id,
          bookingId: this.trainerbookingId,
          totalSession: upDateArray[i].tr_session,
          bookSession: upDateArray.length,
          saveChecked: this.isSaveChecked == true ? 1 : 0
        });
      }
      this.services
        .postRequest1('UpdateAddMemTrainerDateTime', this.upDatePayload)
        .subscribe((response) => { });
    }

    let forOnlineCenter = [];
    forOnlineCenter = this.selectedPackageArray.filter(
      (x) => x.checked == true && x.tr_training_mode != '1' && x.remainMode_isReche == '1'
    );
    if (forOnlineCenter.length > 0) {
      for (let i = 0; i < forOnlineCenter.length; i++) {
        this.upDatePayloadOnlCen.push({
          fromTime: forOnlineCenter[i].tr_from_time,
          toTime: forOnlineCenter[i].tr_to_time,
          day: forOnlineCenter[i].days,
          date: forOnlineCenter[i].dates,
          month: forOnlineCenter[i].month,
          year: forOnlineCenter[i].year,
          TrainerId: forOnlineCenter[i].tr_vendor_id,
          patientId: localStorage.getItem('patient_id'),
          packageId: forOnlineCenter[i].tr_package_id,
          bookingId: this.trainerbookingId,
          totalSession: forOnlineCenter[i].tr_session,
          bookSession: forOnlineCenter.length,
          saveChecked: this.isSaveChecked == true ? 1 : 0
        });
      }
      this.services.postRequest1('UpdateOnlineCenter', this.upDatePayloadOnlCen)
        .subscribe((response) => { });
    }

    let payloadObj = [];
    payloadObj = this.selectedPackageArray.filter(
      (x) =>
        x.checked == true &&
        x.isReschedule != '1' &&
        x.remainMode_isReche != '1'
    );
    if (payloadObj.length > 0) {
      let OneArray = this.selectedPackageArray.filter(
        (obj, index, self) =>
          index === self.findIndex((t) => t.dates === obj.dates)
      );
      for (let i = 0; i < payloadObj.length; i++) {
        this.newPayload.push({
          fromTime: payloadObj[i].tr_from_time,
          toTime: payloadObj[i].tr_to_time,
          day: payloadObj[i].days,
          date: payloadObj[i].dates,
          month: payloadObj[i].month,
          year: payloadObj[i].year,
          TrainerId: payloadObj[i].tr_vendor_id,
          patientId: localStorage.getItem('patient_id'),
          packageId: payloadObj[i].tr_package_id,
          bookingId: this.trainerbookingId,
          totalSession: payloadObj[i].tr_session,
          bookSession: payloadObj.length,
          saveChecked: this.isSaveChecked == true ? 1 : 0
        });
      }

      this.services
        .postRequest1('addMemTrainerDateTime', this.newPayload)
        .subscribe((response) => {
          if (response.status == 1) {
            let apiData = {
              TrainerId: payloadObj[0].tr_vendor_id,
              patientId: localStorage.getItem('patient_id'),
              packageId: payloadObj[0].tr_package_id,
              trainingHourCount: OneArray.length,
              maxLimit: this.selectedPackageArray[0].tr_max_booking,
              bookedCount: payloadObj.length,
              tr_training_mode: this.selectedPackageArray[0].tr_training_mode,
            };
            this.services
              .postRequest1('addtoCheck', apiData)
              .subscribe((response) => { });
          }
        });
    }
  }


  calculateOfWeeks(removeType: any, isChanged) {
    const allDatesAndDaysAndWeeks = this.derivedates.map((dateString) => {
      const dateParts = dateString.split('-');
      const year: number =
        parseInt(dateParts[2], 10) +
        (parseInt(dateParts[2], 10) < 50 ? 2000 : 1900);
      const currentDate: Date = new Date(
        year,
        parseInt(dateParts[1], 10) - 1,
        parseInt(dateParts[0], 10)
      );

      const day: string = currentDate.getDate().toString().padStart(2, '0');
      const month: string = (currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0');
      const monthString: string = this.getMonthName(currentDate.getMonth());
      const formattedDate: string = `${day}-${month}-${year}`;
      const formatDate: string = `${year}-${month}-${day}`;
      const dayOfWeek: string = this.getDayOfWeeker(currentDate.getDay());
      const weekNumber: number = this.getISOWeekNumber(currentDate);

      return {
        date: formattedDate,
        formatDate: formatDate,
        dayOfWeek,
        weekNumber,
        month: currentDate.getMonth() + 1,
        year: currentDate.getFullYear(),
        monthString,
      };
    });
    this.totaldaysWeek = [];

    allDatesAndDaysAndWeeks.forEach((item) => {
      this.totaldaysWeek.push({
        days: item.dayOfWeek,
        week: item.weekNumber,
        weeks: 'Week' + ' ' + item.weekNumber,
        date: item.date,
        month: item.month,
        year: item.year,
        formatDate: item.formatDate,
        monthName: item.monthString,
      });
    });
    this.nowWeek = [];
    this.checkpresentWeek = [];

    this.changeMonthof = [];
    if (isChanged == 'changeofMonth') {
      const repeat = this.totaldaysWeek.filter(
        (element) =>
          element.month == this.presentMonth && element.year == this.presentYear
      );
      this.changeMonthof = repeat.sort((a, b) => b.week - a.week);
    }
    if (isChanged == 'changeofMonth' && this.changeMonthof.length != 0) {
      this.nowWeek = this.changeMonthof.slice(-1)[0];
      this.indexofWeek = null;
      this.indexofWeek = this.nowWeek.weeks;
      this.checkpresentWeek = {
        week: this.nowWeek.weeks,
      };
    }
    if (isChanged != 'weekChanged' && isChanged != 'changeofMonth' && this.totaldaysWeek.length != 0) {
      this.nowWeek = this.totaldaysWeek.slice(-1)[0];
      this.indexofWeek = null;
      this.indexofWeek = this.nowWeek.weeks;
      this.checkpresentWeek = {
        week: this.nowWeek.weeks,
      };
    }

    this.weekBasedOnMonth();

    this.activeMonday = null;
    this.activeTuesday = null;
    this.activeWednesday = null;
    this.activeThursday = null;
    this.activeFriday = null;
    this.activeSaturday = null;
    this.activeSunday = null;

    this.mondayInputArray = [];
    this.tuesdayInputArray = [];
    this.wednesdayInputArray = [];
    this.thursdayInputArray = [];
    this.fridayInputArray = [];
    this.saturdayInputArray = [];
    this.sundayInputArray = [];

    let dataChecker;
    dataChecker = '';
    for (let i = 0; i <= this.selectedPackageArray.length; i++) {
      if (this.selectedPackageArray[i] != undefined) {
        for (let j = 0; j <= this.derivedates.length; j++) {
          if ((dataChecker = this.convertToShortYearFormat(this.selectedPackageArray[i].dates)) == this.derivedates[j] &&
            this.selectedPackageArray[i].days == 'Monday' &&
            this.selectedPackageArray[i].WeekDay == this.indexofWeek &&
            this.selectedPackageArray[i].month == this.presentMonth &&
            this.selectedPackageArray[i].year == this.presentYear
          ) {
            this.activeMonday = 1;
            this.mondayInputArray.push({
              WeekDay: this.selectedPackageArray[i].WeekDay,
              dates: this.selectedPackageArray[i].dates,
              days: this.selectedPackageArray[i].days,
              tr_from_time: this.selectedPackageArray[i].tr_from_time,
              tr_to_time: this.selectedPackageArray[i].tr_to_time,
              month: this.selectedPackageArray[i].month,
              checked:
                this.selectedPackageArray[i].checked &&
                  this.selectedPackageArray[i].checked == true
                  ? true
                  : false,
            });
          } else if (
            (dataChecker = this.convertToShortYearFormat(
              this.selectedPackageArray[i].dates
            )) == this.derivedates[j] &&
            this.selectedPackageArray[i].days == 'Tuesday' &&
            this.selectedPackageArray[i].WeekDay == this.indexofWeek &&
            this.selectedPackageArray[i].month == this.presentMonth &&
            this.selectedPackageArray[i].year == this.presentYear
          ) {
            this.activeTuesday = 1;
            this.tuesdayInputArray.push({
              WeekDay: this.selectedPackageArray[i].WeekDay,
              dates: this.selectedPackageArray[i].dates,
              days: this.selectedPackageArray[i].days,
              tr_from_time: this.selectedPackageArray[i].tr_from_time,
              tr_to_time: this.selectedPackageArray[i].tr_to_time,
              month: this.selectedPackageArray[i].month,
              checked:
                this.selectedPackageArray[i].checked &&
                  this.selectedPackageArray[i].checked == true
                  ? true
                  : false,
            });
          } else if (
            (dataChecker = this.convertToShortYearFormat(
              this.selectedPackageArray[i].dates
            )) == this.derivedates[j] &&
            this.selectedPackageArray[i].days == 'Wednesday' &&
            this.selectedPackageArray[i].WeekDay == this.indexofWeek &&
            this.selectedPackageArray[i].month == this.presentMonth &&
            this.selectedPackageArray[i].year == this.presentYear
          ) {
            this.activeWednesday = 1;
            this.wednesdayInputArray.push({
              WeekDay: this.selectedPackageArray[i].WeekDay,
              dates: this.selectedPackageArray[i].dates,
              days: this.selectedPackageArray[i].days,
              tr_from_time: this.selectedPackageArray[i].tr_from_time,
              tr_to_time: this.selectedPackageArray[i].tr_to_time,
              month: this.selectedPackageArray[i].month,
              checked:
                this.selectedPackageArray[i].checked &&
                  this.selectedPackageArray[i].checked == true
                  ? true
                  : false,
            });
          } else if (
            (dataChecker = this.convertToShortYearFormat(
              this.selectedPackageArray[i].dates
            )) == this.derivedates[j] &&
            this.selectedPackageArray[i].days == 'Thursday' &&
            this.selectedPackageArray[i].WeekDay == this.indexofWeek &&
            this.selectedPackageArray[i].month == this.presentMonth &&
            this.selectedPackageArray[i].year == this.presentYear
          ) {
            this.activeThursday = 1;
            this.thursdayInputArray.push({
              WeekDay: this.selectedPackageArray[i].WeekDay,
              dates: this.selectedPackageArray[i].dates,
              days: this.selectedPackageArray[i].days,
              tr_from_time: this.selectedPackageArray[i].tr_from_time,
              tr_to_time: this.selectedPackageArray[i].tr_to_time,
              month: this.selectedPackageArray[i].month,
              checked:
                this.selectedPackageArray[i].checked &&
                  this.selectedPackageArray[i].checked == true
                  ? true
                  : false,
            });
          } else if (
            (dataChecker = this.convertToShortYearFormat(
              this.selectedPackageArray[i].dates
            )) == this.derivedates[j] &&
            this.selectedPackageArray[i].days == 'Friday' &&
            this.selectedPackageArray[i].WeekDay == this.indexofWeek &&
            this.selectedPackageArray[i].month == this.presentMonth &&
            this.selectedPackageArray[i].year == this.presentYear
          ) {
            this.activeFriday = 1;
            this.fridayInputArray.push({
              WeekDay: this.selectedPackageArray[i].WeekDay,
              dates: this.selectedPackageArray[i].dates,
              days: this.selectedPackageArray[i].days,
              tr_from_time: this.selectedPackageArray[i].tr_from_time,
              tr_to_time: this.selectedPackageArray[i].tr_to_time,
              month: this.selectedPackageArray[i].month,
              checked:
                this.selectedPackageArray[i].checked &&
                  this.selectedPackageArray[i].checked == true
                  ? true
                  : false,
            });
          } else if (
            (dataChecker = this.convertToShortYearFormat(
              this.selectedPackageArray[i].dates
            )) == this.derivedates[j] &&
            this.selectedPackageArray[i].days == 'Saturday' &&
            this.selectedPackageArray[i].WeekDay == this.indexofWeek &&
            this.selectedPackageArray[i].month == this.presentMonth &&
            this.selectedPackageArray[i].year == this.presentYear
          ) {
            this.activeSaturday = 1;
            this.saturdayInputArray.push({
              WeekDay: this.selectedPackageArray[i].WeekDay,
              dates: this.selectedPackageArray[i].dates,
              days: this.selectedPackageArray[i].days,
              tr_from_time: this.selectedPackageArray[i].tr_from_time,
              tr_to_time: this.selectedPackageArray[i].tr_to_time,
              month: this.selectedPackageArray[i].month,
              checked:
                this.selectedPackageArray[i].checked &&
                  this.selectedPackageArray[i].checked == true
                  ? true
                  : false,
            });
          } else if (
            (dataChecker = this.convertToShortYearFormat(
              this.selectedPackageArray[i].dates
            )) == this.derivedates[j] &&
            this.selectedPackageArray[i].days == 'Sunday' &&
            this.selectedPackageArray[i].WeekDay == this.indexofWeek &&
            this.selectedPackageArray[i].month == this.presentMonth &&
            this.selectedPackageArray[i].year == this.presentYear
          ) {
            this.activeSunday = 1;
            this.sundayInputArray.push({
              WeekDay: this.selectedPackageArray[i].WeekDay,
              dates: this.selectedPackageArray[i].dates,
              days: this.selectedPackageArray[i].days,
              tr_from_time: this.selectedPackageArray[i].tr_from_time,
              tr_to_time: this.selectedPackageArray[i].tr_to_time,
              month: this.selectedPackageArray[i].month,
              checked:
                this.selectedPackageArray[i].checked &&
                  this.selectedPackageArray[i].checked == true
                  ? true
                  : false,
            });
          }
        }
      }
    }

    this.isDateUnSelected(removeType);
    let selectedArray = this.selectedPackageArray.find((x) =>
      x.dates.includes(this.derivedates)
    );
    if (isChanged != 'weekChanged' && isChanged != 'changeofMonth') {
      this.clickWeek(this.checkpresentWeek, 0, '');
    } else if (isChanged == 'changeofMonth') {
      this.clickWeek(this.checkpresentWeek, 0, '');
    }
  }

  convertToShortYearFormat(dateString) {
    const dateParts = dateString.split('-');
    const day = dateParts[0];
    const month = dateParts[1];
    const shortYear = dateParts[2].substring(2);

    return `${day}-${month}-${shortYear}`;
  }

  getMonthName(monthIndex: number): string {
    const months: string[] = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    return months[monthIndex];
  }

  getISOWeekNumber(date: Date): number {
    const startOfYear = new Date(date.getFullYear(), date.getMonth(), 1);
    const days = Math.floor(
      (date.getTime() - startOfYear.getTime()) / (24 * 60 * 60 * 1000)
    );
    const weekNumber = Math.ceil((days + startOfYear.getDay() + 1) / 7);

    return weekNumber;
  }
  getDayOfWeeker(dayIndex: number): string {
    const daysOfWeek: string[] = [
      'Sunday',
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ];
    return daysOfWeek[dayIndex];
  }

  isDateUnSelected(type: any) {
    if (type == 'Remove') {
      let getActiveDates = this.selectedPackageArray.filter(
        (x) => x.checked == true
      );
      const diffArray1 = getActiveDates.filter(
        (item1) => !this.removeChecked.some((item2) => item1.dates === item2)
      );
      for (let i = 0; i < diffArray1.length; i++) {
        for (let k = 0; k < this.selectedPackageArray.length; k++) {
          if (
            diffArray1[i].dates == this.selectedPackageArray[k].dates &&
            diffArray1[i].checked == true
          ) {
            if (this.selectedPackageArray[k].days == 'Monday') {
              this.selectedPackageArray[k].checked = false;
              this.mondayInputArray = [];
              this.activeMonday = false;
            }
            if (this.selectedPackageArray[k].days == 'Tuesday') {
              this.selectedPackageArray[k].checked = false;
              this.tuesdayInputArray = [];
              this.activeTuesday = false;
            }
            if (this.selectedPackageArray[k].days == 'Wednesday') {
              this.selectedPackageArray[k].checked = false;
              this.wednesdayInputArray = [];
              this.activeWednesday = false;
            }
            if (this.selectedPackageArray[k].days == 'Thursday') {
              this.selectedPackageArray[k].checked = false;
              this.thursdayInputArray = [];
              this.activeThursday = false;
            }
            if (this.selectedPackageArray[k].days == 'Friday') {
              this.selectedPackageArray[k].checked = false;
              this.fridayInputArray = [];
              this.activeFriday = false;
            }
            if (this.selectedPackageArray[k].days == 'Saturday') {
              this.selectedPackageArray[k].checked = false;
              this.saturdayInputArray = [];
              this.activeSaturday = false;
            }
            if (this.selectedPackageArray[k].days == 'Sunday') {
              this.selectedPackageArray[k].checked = false;
              this.sundayInputArray = [];
              this.activeSunday = false;
            }
          }
        }
      }

      for (let l = 0; l < diffArray1.length; l++) {
        for (let f = 0; f < this.forArray.length; f++) {
          if (diffArray1[l].dates == this.forArray[f].dates) {
            this.forArray.splice(f, 1);
          }
        }
      }
    }
  }

  isCheckedOrNot() {
    for (let i = 0; i <= this.selectedPackageArray.length; i++) {
      if (this.selectedPackageArray[i] != undefined) {
        for (let j = 0; j <= this.forArray.length; j++) {
          if (this.forArray[j] != undefined) {
            if (
              this.selectedPackageArray[i].dates == this.forArray[j].dates &&
              this.selectedPackageArray[i].tr_from_time ==
              this.forArray[j].tr_from_time &&
              this.selectedPackageArray[i].tr_to_time ==
              this.forArray[j].tr_to_time &&
              this.forArray[j].checked != false
            ) {
              this.selectedPackageArray[i].checked = true;
            } else if (
              this.selectedPackageArray[i].dates == this.forArray[j].dates &&
              this.selectedPackageArray[i].tr_from_time !=
              this.forArray[j].tr_from_time &&
              this.forArray[j].dates != undefined &&
              this.forArray[j].tr_from_time != undefined
            ) {
              this.selectedPackageArray[i].checked = false;
            }
          }
        }
      }
    }
  }

  filterWeeks: any = [];
  storeNrOfWeek: any = [];
  presentMonth: any;
  presentYear: any;
  weekBasedOnMonth() {
    this.filterWeeks = [];
    this.storeNrOfWeek = [];
    for (let i = 0; i <= this.totaldaysWeek.length; i++) {
      if (this.totaldaysWeek[i] != undefined) {
        if (
          this.totaldaysWeek[i].month == this.presentMonth &&
          this.totaldaysWeek[i].year == this.presentYear
        ) {
          this.filterWeeks.push(this.totaldaysWeek[i].week);
          const uniqueArray = Array.from(new Set(this.filterWeeks));
          this.storeNrOfWeek = [];
          uniqueArray.forEach((item: any) => {
            this.storeNrOfWeek.push({
              week: 'Week' + ' ' + item,
              weeknum: item,
            });
          });
        }
      }
    }
    const sortedArray = this.storeNrOfWeek.sort(
      (a, b) => a.weeknum - b.weeknum
    );
    console.log("checking", sortedArray);

  }

  clickWeek(item, i, changeOrNot) {
    this.indexofWeek = item.week;
    this.presentWeek = '';
    this.presentWeek = item.week;
    if (changeOrNot == 'changeWeek') {
      this.calculateOfWeeks('Noraml', 'weekChanged');
    }
  }

  ChangeValuesWeeksforday(checked: boolean, datas: any, index, day) {
    if (checked && day == 'Monday') {
      // If the current checkbox is checked, uncheck other checkboxes
      this.mondayInputArray.forEach((data) => {
        if (data.tr_from_time !== datas.tr_from_time) {
          data.checked = false;
        }
        if (data.tr_from_time == datas.tr_from_time) {
          this.forArray = this.forArray.filter(
            (obj) => obj.dates !== datas.dates
          );
          this.forArray.push(data);
          this.isCheckedOrNot();
        }
      });
    } else if (checked && day == 'Tuesday') {
      this.tuesdayInputArray.forEach((data) => {
        if (data.tr_from_time !== datas.tr_from_time) {
          data.checked = false;
        }
        if (data.tr_from_time == datas.tr_from_time) {
          this.forArray = this.forArray.filter(
            (obj) => obj.dates !== datas.dates
          );
          this.forArray.push(data);
          this.isCheckedOrNot();
        }
      });
    } else if (checked && day == 'Wednesday') {
      this.wednesdayInputArray.forEach((data) => {
        if (data.tr_from_time !== datas.tr_from_time) {
          data.checked = false;
        }
        if (data.tr_from_time == datas.tr_from_time) {
          this.forArray = this.forArray.filter(
            (obj) => obj.dates !== datas.dates
          );
          this.forArray.push(data);
          this.isCheckedOrNot();
        }
      });
    } else if (checked && day == 'Thursday') {
      this.thursdayInputArray.forEach((data) => {
        if (data.tr_from_time !== datas.tr_from_time) {
          data.checked = false;
        }
        if (data.tr_from_time == datas.tr_from_time) {
          this.forArray = this.forArray.filter(
            (obj) => obj.dates !== datas.dates
          );
          this.forArray.push(data);
          this.isCheckedOrNot();
        }
      });
    } else if (checked && day == 'Friday') {
      this.fridayInputArray.forEach((data) => {
        if (data.tr_from_time !== datas.tr_from_time) {
          data.checked = false;
        }
        if (data.tr_from_time == datas.tr_from_time) {
          this.forArray = this.forArray.filter(
            (obj) => obj.dates !== datas.dates
          );
          this.forArray.push(data);
          this.isCheckedOrNot();
        }
      });
    } else if (checked && day == 'Saturday') {
      this.saturdayInputArray.forEach((data) => {
        if (data.tr_from_time !== datas.tr_from_time) {
          data.checked = false;
        }
        if (data.tr_from_time == datas.tr_from_time) {
          this.forArray = this.forArray.filter(
            (obj) => obj.dates !== datas.dates
          );
          this.forArray.push(data);
          this.isCheckedOrNot();
        }
      });
    } else if (checked && day == 'Sunday') {
      // If the current checkbox is checked, uncheck other checkboxes
      this.sundayInputArray.forEach((data) => {
        if (data.tr_from_time !== datas.tr_from_time) {
          data.checked = false;
        }
        if (data.tr_from_time == datas.tr_from_time) {
          this.forArray = this.forArray.filter(
            (obj) => obj.dates !== datas.dates
          );
          this.forArray.push(data);
          this.isCheckedOrNot();
        }
      });
    }

    if (!checked) {
      let getDatas = this.selectedPackageArray.find(
        (x) =>
          x.dates == datas.dates &&
          x.tr_from_time == datas.tr_from_time &&
          x.tr_to_time == datas.tr_to_time
      );
      this.selectedPackageArray.find(
        (data) => data.dates == getDatas.dates
      ).checked = false;
    }
    let isAllChecked = [];
    isAllChecked = this.selectedPackageArray.filter(element => element.checked)
    if (this.selectedPackageArray[0].tr_session == isAllChecked.length) {
      this.isSaveChecked = false;
      this.disbaleCheck = true;
    }else if(this.selectedPackageArray[0].tr_session > isAllChecked.length){
      this.isSaveChecked = true;
      this.disbaleCheck = false;
    }
  }


  theMonthChanged: any;
  onMonthChanged($event) {
    this.presentYear = $event.newMonth.years;
    this.allDate = [];
    this.presentMonth = $event.newMonth.months;
    let newMonth = $event.newMonth.months;
    let newYear;
    if ($event.newMonth.string > $event.oldMonth.string) {
      if (newMonth == 12) {
        newMonth = 1;
        newYear = $event.newMonth.years + 1;
      } else {
        newMonth = newMonth + 1;
        newYear = $event.newMonth.years;
      }
    } else if ($event.newMonth.string < $event.oldMonth.string) {
      if (newMonth == 1) {
        newMonth = 12;
        newYear = $event.newMonth.years - 1;
      } else {
        newMonth = newMonth - 1;
        newYear = $event.newMonth.years;
      }
    }
    this.theMonthChanged = 'monthChanged';

    // For Current Month Get Dates & Years
    this.generateDatesForMonth($event.newMonth.months, $event.newMonth.years);
    // For Future Month Get Dates & Years
    this.generateDatesForMonth(newMonth, newYear);
    // For Old Month Get Dates & Years
    this.generateDatesForMonth($event.oldMonth.months, $event.oldMonth.years);

    let selectedPackage = this.selectedPackageArray.filter(
      (x) => x.month == this.presentMonth
    );
    let available_dates = selectedPackage.filter(
      (x) => x.month == this.presentMonth && x.year == $event.newMonth.years
    );
    if (available_dates.length == 0) {
      this.config = [];
      this.allDate.forEach((item) => {
        let value = this.getDetailfromDate(item.formatdate);
        let config = {
          date: new Date(),
          disable: false,
        };
        config.date = new Date(value.year, value.month, value.day);
        config.disable = true;
        this.config.push(config);
      });

      this.optionsMultil = {
        pickMode: 'multi',
        // from:new Date(new Date().getFullYear(), this.presentMonth -1, 1),
        // to: new Date(new Date().getFullYear(), this.presentMonth, 0),
        weekdays: [
          this.addCall.title411,
          this.addCall.title412,
          this.addCall.title413,
          this.addCall.title414,
          this.addCall.title415,
          this.addCall.title416,
          this.addCall.title417,
        ],
        daysConfig: this.config,
        showMonthPicker: false,
      };
    } else {
      this.config = [];
      let selectedPackage = this.selectedPackageArray.filter(
        (x) => x.month == this.presentMonth
      );
      let disabledDates = this.allDate.filter(
        ({ dates: id1 }) =>
          !selectedPackage.some(({ dates: id2 }) => id2 == id1)
      );
      disabledDates.forEach((item) => {
        let value = this.getDetailfromDate(item.formatdate);
        let config = {
          date: new Date(),
          disable: false,
        };
        config.date = new Date(value.year, value.month, value.day);
        config.disable = true;
        this.config.push(config);
      });

      this.optionsMultil = {
        pickMode: 'multi',
        weekdays: [
          this.addCall.title411,
          this.addCall.title412,
          this.addCall.title413,
          this.addCall.title414,
          this.addCall.title415,
          this.addCall.title416,
          this.addCall.title417,
        ],
        daysConfig: this.config,
      };
    }
  }

  // Get All Dates Of a Month
  getAllDatesOfMonth(year, month): any {
    let dates = [];
    let startDate = new Date(year, month - 1, 1);
    let endDate = new Date(year, month, 0);
    for (
      let date = startDate;
      date <= endDate;
      date.setDate(date.getDate() + 1)
    ) {
      dates.push({
        dates: new Date(date),
        date: this.formatDateddmmYYYY(date),
      });
    }
    return dates;
  }

  formatDateddmmYYYY(date) {
    // Extract day, month, and year
    let day = date.getDate().toString().padStart(2, '0');
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let year = date.getFullYear();
    return `${day}-${month}-${year}`;
  }

  // ==============================================Reschedule=====================================================

  redates: any = [];
  selDatesforReschedule: any;
  reCalendarDates: any = [];
  remainingDates: any = [];
  remainCalendarDates: any = [];
  temarr: any = [];
  allSelectedDates: any = [];
  allSelectedDate1: any = [];
  arrayforHome: any = [];

  justData: any = [];
  toreschedule(data) {
    this.clearDatas();
    this.clearCalendarData();
    if (data.training_mode == '1') {
      let homeDate = JSON.stringify({
        patientId: localStorage.getItem('patient_id'),
        trainerId: data.trainer_id,
        packageId: data.package_id,
        memBookingId: data.trainerBookingId,
      });
      this.services.postRequest1('getHomeRescheduleDates', homeDate).subscribe((res) => {
          res.data[0].details.forEach((item) => {
            this.selDatesforReschedule.push(item);
            if (
              item.bookingId == null ||
              item.bookingId == data.trainerBookingId
            ) {
              this.justData.push(this.convertToShortYearFormat(item.dates));
              this.allSelectedDates.push(
                this.convertToShortYearFormat(item.dates)
              );
            }

            if (
              item.bookingId == null ||
              (item.bookingId != null && item.isReSchedule != 0)
            ) {
              this.temarr.push(this.convertToShortYearFormat(item.dates));
            } else if (
              item.bookingId != null &&
              item.isReSchedule == 0 &&
              data.trainerBookingId == item.bookingId
            ) {
              this.redates.push(this.convertToShortYearFormat(item.dates));
            }
            if (item.bookingId != null && item.isReSchedule == 0) {
              this.arrayforHome.push(this.convertToShortYearFormat(item.dates));
            }
          });
          this.remainingDates = this.temarr.filter(
            (word) => !this.arrayforHome.includes(word)
          );
          if (this.datesNotSelected('')) {
          } else {
            this.allSelectedDates.forEach((item) => {
              this.allSelectedDate1.push(this.dateChange(item));
            });
          }
          if (this.isDateSelected('')) {
          } else {
            this.redates.forEach((item) => {
              this.reCalendarDates.push(this.dateChange(item));
            });
          }

          if (this.isDateSelectedofRemain('')) {
          } else {
            this.remainingDates.forEach((item) => {
              this.remainCalendarDates.push(this.dateChange(item));
            });
          }
        });
    } else {
      let apiData = JSON.stringify({
        patientId: localStorage.getItem('patient_id'),
        trainerId: data.trainer_id,
        packageId: data.package_id,
        memBookingId: data.trainerBookingId,
      });

      this.services.postRequest1('getRescheduleDates', apiData).subscribe((res) => {
          // const splitDate = res.data[0].details[0].dates.split("-");
          // const fromDate = splitDate[2] + "-" + splitDate[1] + "-" + splitDate[0];
          const fromDate = this.splitDates(res.data[0].details[0].dates);
          this.viewMonth = new Date(fromDate);
          this.getBkgDateCaleForResch(new Date(fromDate), new Date(fromDate));
          res.data[0].details.forEach((item) => {
            this.selDatesforReschedule.push(item);

            this.allSelectedDates.push(this.convertToShortYearFormat(item.dates));
            if (item.bookingId == null || (item.bookingId != null && item.isReSchedule != 0)) {
              this.temarr.push(this.convertToShortYearFormat(item.dates));
            } else if (item.bookingId != null && item.isReSchedule == 0) {
              this.redates.push(this.convertToShortYearFormat(item.dates));
            }
          });

          this.remainingDates = this.temarr.filter((word) => !this.redates.includes(word));

          if (this.datesNotSelected('')) {
          } else {
            this.allSelectedDates.forEach((item) => {
              this.allSelectedDate1.push(this.dateChange(item));
            });
          }
          if (this.isDateSelected('')) {
          } else {
            this.redates.forEach((item) => {
              this.reCalendarDates.push(this.dateChange(item));
            });
          }

          if (this.isDateSelectedofRemain('')) {
          } else {
            this.remainingDates.forEach((item) => {
              this.remainCalendarDates.push(this.dateChange(item));
            });
          }
        });
    }
  }

  clearDatas() {
    this.storeSelectedDates = [];
    this.storeReDates = [];
    this.redates = [];
    this.remainingDates = [];
    this.remainCalendarDates = [];
    this.selDatesforReschedule = [];
    this.reCalendarDates = [];
    this.temarr = [];
    this.allSelectedDates = [];
    this.allSelectedDate1 = [];
    this.forCalendarFunc = [];
    this.retotaldaysWeek = [];
    this.reactiveMonday = null;
    this.reactiveTuesday = null;
    this.reactiveWednesday = null;
    this.reactiveThursday = null;
    this.reactiveFriday = null;
    this.reactiveSaturday = null;
    this.reactiveSunday = null;
    this.remondayInputArray = [];
    this.retuesdayInputArray = [];
    this.rewednesdayInputArray = [];
    this.rethursdayInputArray = [];
    this.refridayInputArray = [];
    this.resaturdayInputArray = [];
    this.resundayInputArray = [];
    this.restoreNrOfWeek = [];
    this.refilterWeeks = [];
    this.remainSaveSessions = null;
    this.saveAvailable = null;
    this.ReSchBtnValue = "";
    this.saveSeletDates = [];
    this.isAvailableDatefor = 0;
    this.isUpdateButton = 0;
    this.myScheduleAllDates = [];
  }
  datesNotSelected(dateOf: any): boolean {
    let notSelected;
    notSelected = this.allSelectedDate1.find((element) => element === dateOf);
    if (notSelected == undefined || notSelected == '' || notSelected == null) {
      return dateOf;
    }
  }
  isDateSelected(dateOf: any): boolean {
    let foundValue;
    foundValue = this.reCalendarDates.find((element) => element === dateOf);
    return foundValue;
  }
  isDateSelectedofRemain(dateOf: any): boolean {
    let foundValueofRemain;
    foundValueofRemain = this.remainCalendarDates.find(
      (element) => element === dateOf
    );
    return foundValueofRemain;
  }
  // ==================04-02-2024 to Mon Feb 05 2024 00:00:00 GMT+0530 (India Standard Time)===============
  dateChange(dates) {
    let dateString = dates;
    let parts = dateString.split('-');
    let day = parseInt(parts[0], 10);
    let month = parseInt(parts[1], 10);
    let year = parseInt(parts[2], 10) + 2000;
    let date = new Date(year, month - 1, day);
    let monthNames = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    let dayOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][
      date.getDay()
    ];
    let formattedDate =
      dayOfWeek +
      ' ' +
      monthNames[month - 1] +
      ' ' +
      (day < 10 ? '0' : '') +
      day +
      ' ' +
      year;
    return formattedDate;
  }


  reschedulecalculateOfWeeks(removeType: any, isChanged) {
    const allDatesAndDaysAndWeeks = this.forCalendarFunc.map((dateString) => {
      const dateParts = dateString.split('-');
      const year: number = parseInt(dateParts[2], 10) + (parseInt(dateParts[2], 10) < 50 ? 2000 : 1900);
      const currentDate: Date = new Date(year, parseInt(dateParts[1], 10) - 1, parseInt(dateParts[0], 10));

      const day: string = currentDate.getDate().toString().padStart(2, '0');
      const month: string = (currentDate.getMonth() + 1).toString().padStart(2, '0');

      const monthString: string = this.getMonthName(currentDate.getMonth());
      const formattedDate: string = `${day}-${month}-${year}`;
      const formatDate: string = `${year}-${month}-${day}`;
      const dayOfWeek: string = this.getDayOfWeeker(currentDate.getDay());
      const weekNumber: number = this.getISOWeekNumber(currentDate);

      return {
        date: formattedDate,
        formatDate: formatDate,
        dayOfWeek,
        weekNumber,
        month: currentDate.getMonth() + 1,
        year: currentDate.getFullYear(),
        monthString,
      };
    });

    this.retotaldaysWeek = [];

    allDatesAndDaysAndWeeks.forEach((item) => {
      this.retotaldaysWeek.push({
        days: item.dayOfWeek,
        week: item.weekNumber,
        weeks: 'Week' + ' ' + item.weekNumber,
        date: item.date,
        month: item.month,
        year: item.year,
        formatDate: item.formatDate,
        monthName: item.monthString,
      });
    });

    this.rescheduleweekBasedOnMonth();

    if (isChanged != 'weekChanged' && isChanged != 'changeofMonth' && this.retotaldaysWeek.length != 0) {
      this.renowWeek = this.retotaldaysWeek.slice(-1)[0];
      this.representWeek = null;
      this.representWeek = this.renowWeek?.weeks;
      this.recheckpresentWeek = {
        week: this.renowWeek.weeks,
      };
    }
    if (isChanged == 'changeofMonth' && this.retotaldaysWeek.length != 0) {
      this.renowWeek = this.retotaldaysWeek.filter(element => element.month == this.representMonth)[0];
      this.representWeek = null;
      this.representWeek = this.renowWeek?.weeks;
      this.recheckpresentWeek = {
        week: this.renowWeek?.weeks,
      };
    }
    this.reactiveMonday = null;
    this.reactiveTuesday = null;
    this.reactiveWednesday = null;
    this.reactiveThursday = null;
    this.reactiveFriday = null;
    this.reactiveSaturday = null;
    this.reactiveSunday = null;

    this.remondayInputArray = [];
    this.retuesdayInputArray = [];
    this.rewednesdayInputArray = [];
    this.rethursdayInputArray = [];
    this.refridayInputArray = [];
    this.resaturdayInputArray = [];
    this.resundayInputArray = [];

    let dataChecker;
    dataChecker = '';

    for (let i = 0; i <= this.selDatesforReschedule.length; i++) {
      if (this.selDatesforReschedule[i] != undefined) {
        for (let j = 0; j <= this.forCalendarFunc.length; j++) {
          if (
            (dataChecker = this.convertToShortYearFormat(
              this.selDatesforReschedule[i].dates
            )) == this.forCalendarFunc[j] &&
            this.selDatesforReschedule[i].days == 'Monday' &&
            this.selDatesforReschedule[i].month == this.representMonth &&
            this.selDatesforReschedule[i].WeekDay == this.representWeek &&
            this.selDatesforReschedule[i].year == this.representYear
          ) {
            this.reactiveMonday = 1;
            this.remondayInputArray.push({
              dates: this.selDatesforReschedule[i].dates,
              days: this.selDatesforReschedule[i].days,
              re_from_time: this.selDatesforReschedule[i].tr_from_time,
              re_to_time: this.selDatesforReschedule[i].tr_to_time,
              month: this.selDatesforReschedule[i].month,
              // checked: this.selDatesforReschedule[i].bookingId &&
              //     this.selDatesforReschedule[i].bookingId != null &&
              //     this.selDatesforReschedule[i].isReSchedule == 0
              //     ? true
              //     : false,
              checked: this.selDatesforReschedule[i].bookingId && this.selDatesforReschedule[i].bookingId != null &&
                this.selDatesforReschedule[i].isReSchedule == 0 ? true :
                this.isSave_slect == 1 && this.selDatesforReschedule[i].checked ? true
                  : false,
              bookingId:
                this.selDatesforReschedule[i].bookingId &&
                  this.selDatesforReschedule[i].bookingId != null
                  ? this.selDatesforReschedule[i].bookingId
                  : null,
            });
            this.initialForArrayPush('Monday');
          } else if (
            (dataChecker = this.convertToShortYearFormat(
              this.selDatesforReschedule[i].dates
            )) == this.forCalendarFunc[j] &&
            this.selDatesforReschedule[i].days == 'Tuesday' &&
            this.selDatesforReschedule[i].month == this.representMonth &&
            this.selDatesforReschedule[i].WeekDay == this.representWeek &&
            this.selDatesforReschedule[i].year == this.representYear
          ) {
            this.reactiveTuesday = 1;
            this.retuesdayInputArray.push({
              dates: this.selDatesforReschedule[i].dates,
              days: this.selDatesforReschedule[i].days,
              re_from_time: this.selDatesforReschedule[i].tr_from_time,
              re_to_time: this.selDatesforReschedule[i].tr_to_time,
              month: this.selDatesforReschedule[i].month,
              checked:
                this.selDatesforReschedule[i].bookingId &&
                  this.selDatesforReschedule[i].bookingId != null &&
                  this.selDatesforReschedule[i].isReSchedule == 0
                  ? true :
                  this.isSave_slect == 1 && this.selDatesforReschedule[i].checked ? true
                    : false,
              bookingId:
                this.selDatesforReschedule[i].bookingId &&
                  this.selDatesforReschedule[i].bookingId != null
                  ? this.selDatesforReschedule[i].bookingId
                  : null,
            });
            this.initialForArrayPush('Tuesday');
          } else if (
            (dataChecker = this.convertToShortYearFormat(
              this.selDatesforReschedule[i].dates
            )) == this.forCalendarFunc[j] &&
            this.selDatesforReschedule[i].days == 'Wednesday' &&
            this.selDatesforReschedule[i].month == this.representMonth &&
            this.selDatesforReschedule[i].WeekDay == this.representWeek &&
            this.selDatesforReschedule[i].year == this.representYear
          ) {
            this.reactiveWednesday = 1;
            this.rewednesdayInputArray.push({
              dates: this.selDatesforReschedule[i].dates,
              days: this.selDatesforReschedule[i].days,
              re_from_time: this.selDatesforReschedule[i].tr_from_time,
              re_to_time: this.selDatesforReschedule[i].tr_to_time,
              month: this.selDatesforReschedule[i].month,
              checked:
                this.selDatesforReschedule[i].bookingId &&
                  this.selDatesforReschedule[i].bookingId != null &&
                  this.selDatesforReschedule[i].isReSchedule == 0
                  ? true :
                  this.isSave_slect == 1 && this.selDatesforReschedule[i].checked ? true
                    : false,
              bookingId:
                this.selDatesforReschedule[i].bookingId &&
                  this.selDatesforReschedule[i].bookingId != null
                  ? this.selDatesforReschedule[i].bookingId
                  : null,
            });
            this.initialForArrayPush('Wednesday');
          } else if (
            (dataChecker = this.convertToShortYearFormat(
              this.selDatesforReschedule[i].dates
            )) == this.forCalendarFunc[j] &&
            this.selDatesforReschedule[i].days == 'Thursday' &&
            this.selDatesforReschedule[i].month == this.representMonth &&
            this.selDatesforReschedule[i].WeekDay == this.representWeek &&
            this.selDatesforReschedule[i].year == this.representYear
          ) {
            this.reactiveThursday = 1;
            this.rethursdayInputArray.push({
              dates: this.selDatesforReschedule[i].dates,
              days: this.selDatesforReschedule[i].days,
              re_from_time: this.selDatesforReschedule[i].tr_from_time,
              re_to_time: this.selDatesforReschedule[i].tr_to_time,
              month: this.selDatesforReschedule[i].month,
              checked:
                this.selDatesforReschedule[i].bookingId &&
                  this.selDatesforReschedule[i].bookingId != null &&
                  this.selDatesforReschedule[i].isReSchedule == 0
                  ? true :
                  this.isSave_slect == 1 && this.selDatesforReschedule[i].checked ? true
                    : false,
              bookingId:
                this.selDatesforReschedule[i].bookingId &&
                  this.selDatesforReschedule[i].bookingId != null
                  ? this.selDatesforReschedule[i].bookingId
                  : null,
            });
            this.initialForArrayPush('Thursday');
          } else if (
            (dataChecker = this.convertToShortYearFormat(
              this.selDatesforReschedule[i].dates
            )) == this.forCalendarFunc[j] &&
            this.selDatesforReschedule[i].days == 'Friday' &&
            this.selDatesforReschedule[i].month == this.representMonth &&
            this.selDatesforReschedule[i].WeekDay == this.representWeek &&
            this.selDatesforReschedule[i].year == this.representYear
          ) {
            this.reactiveFriday = 1;
            this.refridayInputArray.push({
              dates: this.selDatesforReschedule[i].dates,
              days: this.selDatesforReschedule[i].days,
              re_from_time: this.selDatesforReschedule[i].tr_from_time,
              re_to_time: this.selDatesforReschedule[i].tr_to_time,
              month: this.selDatesforReschedule[i].month,
              checked:
                this.selDatesforReschedule[i].bookingId &&
                  this.selDatesforReschedule[i].bookingId != null &&
                  this.selDatesforReschedule[i].isReSchedule == 0
                  ? true :
                  this.isSave_slect == 1 && this.selDatesforReschedule[i].checked ? true
                    : false,
              bookingId:
                this.selDatesforReschedule[i].bookingId &&
                  this.selDatesforReschedule[i].bookingId != null
                  ? this.selDatesforReschedule[i].bookingId
                  : null,
            });
            this.initialForArrayPush('Friday');
          } else if (
            (dataChecker = this.convertToShortYearFormat(
              this.selDatesforReschedule[i].dates
            )) == this.forCalendarFunc[j] &&
            this.selDatesforReschedule[i].days == 'Saturday' &&
            this.selDatesforReschedule[i].month == this.representMonth &&
            this.selDatesforReschedule[i].WeekDay == this.representWeek &&
            this.selDatesforReschedule[i].year == this.representYear
          ) {
            this.reactiveSaturday = 1;
            this.resaturdayInputArray.push({
              dates: this.selDatesforReschedule[i].dates,
              days: this.selDatesforReschedule[i].days,
              re_from_time: this.selDatesforReschedule[i].tr_from_time,
              re_to_time: this.selDatesforReschedule[i].tr_to_time,
              month: this.selDatesforReschedule[i].month,
              checked:
                this.selDatesforReschedule[i].bookingId &&
                  this.selDatesforReschedule[i].bookingId != null &&
                  this.selDatesforReschedule[i].isReSchedule == 0
                  ? true :
                  this.isSave_slect == 1 && this.selDatesforReschedule[i].checked ? true
                    : false,
              bookingId:
                this.selDatesforReschedule[i].bookingId &&
                  this.selDatesforReschedule[i].bookingId != null
                  ? this.selDatesforReschedule[i].bookingId
                  : null,
            });

            this.initialForArrayPush('Saturday');
          } else if (
            (dataChecker = this.convertToShortYearFormat(
              this.selDatesforReschedule[i].dates
            )) == this.forCalendarFunc[j] &&
            this.selDatesforReschedule[i].days == 'Sunday' &&
            this.selDatesforReschedule[i].month == this.representMonth &&
            this.selDatesforReschedule[i].WeekDay == this.representWeek &&
            this.selDatesforReschedule[i].year == this.representYear
          ) {
            this.reactiveSunday = 1;
            this.resundayInputArray.push({
              dates: this.selDatesforReschedule[i].dates,
              days: this.selDatesforReschedule[i].days,
              re_from_time: this.selDatesforReschedule[i].tr_from_time,
              re_to_time: this.selDatesforReschedule[i].tr_to_time,
              month: this.selDatesforReschedule[i].month,
              checked:
                this.selDatesforReschedule[i].bookingId &&
                  this.selDatesforReschedule[i].bookingId != null &&
                  this.selDatesforReschedule[i].isReSchedule == 0
                  ? true :
                  this.isSave_slect == 1 && this.selDatesforReschedule[i].checked ? true
                    : false,
              bookingId:
                this.selDatesforReschedule[i].bookingId &&
                  this.selDatesforReschedule[i].bookingId != null
                  ? this.selDatesforReschedule[i].bookingId
                  : null,
            });
            this.initialForArrayPush('Sunday');
          }
        }
      }
    }

    if (isChanged != 'weekChanged') {
      this.rescheduleclickWeek(this.renowWeek, 0, 'nowChangeWeek');
    }
  }

  initialForArrayPush(day) {
    this.forArray = [];
    if (day == 'Monday') {
      this.remondayInputArray.forEach((data) => {
        if (data.checked && data.bookingId != null) {
          this.forArray.push(data);
        }
      });
    }
    if (day == 'Tuesday') {
      this.retuesdayInputArray.forEach((data) => {
        if (data.checked && data.bookingId != null) {
          this.forArray.push(data);
        }
      });
    }
    if (day == 'Wednesday') {
      this.rewednesdayInputArray.forEach((data) => {
        if (data.checked && data.bookingId != null) {
          this.forArray.push(data);
        }
      });
    }
    if (day == 'Thursday') {
      this.rethursdayInputArray.forEach((data) => {
        if (data.checked && data.bookingId != null) {
          this.forArray.push(data);
        }
      });
    }
    if (day == 'Friday') {
      this.refridayInputArray.forEach((data) => {
        if (data.checked && data.bookingId != null) {
          this.forArray.push(data);
        }
      });
    }
    if (day == 'Saturday') {
      this.resaturdayInputArray.forEach((data) => {
        if (data.checked && data.bookingId != null) {
          this.forArray.push(data);
        }
      });
    }
    if (day == 'Sunday') {
      this.resundayInputArray.forEach((data) => {
        if (data.checked && data.bookingId != null) {
          this.forArray.push(data);
        }
      });
    }
  }

  refilterWeeks: any = [];
  restoreNrOfWeek: any = [];
  representMonth: any;
  rescheduleweekBasedOnMonth() {
    this.refilterWeeks = [];
    this.restoreNrOfWeek = [];
    for (let i = 0; i <= this.retotaldaysWeek.length; i++) {
      if (this.retotaldaysWeek[i] != undefined) {
        if (this.retotaldaysWeek[i].month == this.representMonth &&
          this.retotaldaysWeek[i].year == this.representYear) {
          this.refilterWeeks.push(this.retotaldaysWeek[i].week);
          const uniqueArray = Array.from(new Set(this.refilterWeeks));
          this.restoreNrOfWeek = [];
          uniqueArray.forEach((item: any) => {
            this.restoreNrOfWeek.push({
              week: 'Week' + ' ' + item,
              weeknum: item,
              month: item.month,
            });
          });
        }
      }
    }
    const sortedArray = this.restoreNrOfWeek.sort(
      (a, b) => a.weeknum - b.weeknum
    );
  }

  representWeek: any;
  representYear: any;
  rescheduleclickWeek(item, i, changeOrNot) {
    this.representWeek = '';
    if (changeOrNot == "nowChangeWeek") {
      this.representWeek = item?.weeks;
    } else {
      this.representWeek = item?.week;
    }

    if (changeOrNot == 'changeWeek') {
      this.reschedulecalculateOfWeeks('Noraml', 'weekChanged');
    }
  }

  isUpdateButton: any;

  reChangeValuesWeeksforday(checked: boolean, datas: any, index, day) {
    this.forArray = [];
    if (checked && day == 'Monday') {
      // If the current checkbox is checked, uncheck other checkboxes
      this.remondayInputArray.forEach((data) => {
        if (data.re_from_time !== datas.re_from_time) {
          data.checked = false;
        }
        if (data.re_from_time == datas.re_from_time) {
          this.forArray = this.forArray.filter(
            (obj) => obj.dates !== datas.dates
          );
          this.forArray.push(data);
          this.reisCheckedOrNot();
        }
      });
      for (let i = 0; i < this.finalArrayforResche.length; i++) {
        for (let k = 0; k < this.selDatesforReschedule.length; k++) {
          if (this.finalArrayforResche[i].dates ==
            this.selDatesforReschedule[k].dates &&
            this.finalArrayforResche[i].tr_from_time ==
            this.selDatesforReschedule[k].tr_from_time &&
            this.finalArrayforResche[i].tr_to_time ==
            this.selDatesforReschedule[k].tr_to_time
          ) {
            this.selDatesforReschedule[k].checked = false;
          }
        }
      }
    } else if (!checked && day == 'Monday') {
      this.remondayInputArray.forEach((data) => {
        if (data.re_from_time == datas.re_from_time) {
          this.forArray = this.forArray.filter(
            (obj) => obj.dates !== datas.dates
          );
          this.forArray.push(data);
          this.reisCheckedOrNotfalse();
        }
      });
    } else if (checked && day == 'Tuesday') {
      this.retuesdayInputArray.forEach((data) => {
        if (
          data.re_from_time !== datas.re_from_time ||
          data.re_to_time !== datas.re_to_time
        ) {
          data.checked = false;
        }
        if (
          data.re_from_time == datas.re_from_time ||
          data.re_to_time == datas.re_to_time
        ) {
          this.forArray = this.forArray.filter(
            (obj) => obj.dates !== datas.dates
          );
          this.forArray.push(data);
          this.reisCheckedOrNot();
        }
      });
      for (let i = 0; i < this.finalArrayforResche.length; i++) {
        for (let k = 0; k < this.selDatesforReschedule.length; k++) {
          if (
            this.finalArrayforResche[i].dates ==
            this.selDatesforReschedule[k].dates &&
            this.finalArrayforResche[i].tr_from_time ==
            this.selDatesforReschedule[k].tr_from_time &&
            this.finalArrayforResche[i].tr_to_time ==
            this.selDatesforReschedule[k].tr_to_time
          ) {
            this.selDatesforReschedule[k].checked = false;
          }
        }
      }
    } else if (!checked && day == 'Tuesday') {
      this.retuesdayInputArray.forEach((data) => {
        if (data.re_from_time == datas.re_from_time) {
          this.forArray = this.forArray.filter(
            (obj) => obj.dates !== datas.dates
          );
          this.forArray.push(data);
          this.reisCheckedOrNotfalse();
        }
      });
    } else if (checked && day == 'Wednesday') {
      this.rewednesdayInputArray.forEach((data) => {
        if (data.re_from_time !== datas.re_from_time) {
          data.checked = false;
        }
        if (data.re_from_time == datas.re_from_time) {
          this.forArray = this.forArray.filter(
            (obj) => obj.dates !== datas.dates
          );
          this.forArray.push(data);
          this.reisCheckedOrNot();
        }
      });
      for (let i = 0; i < this.finalArrayforResche.length; i++) {
        for (let k = 0; k < this.selDatesforReschedule.length; k++) {
          if (
            this.finalArrayforResche[i].dates ==
            this.selDatesforReschedule[k].dates &&
            this.finalArrayforResche[i].tr_from_time ==
            this.selDatesforReschedule[k].tr_from_time &&
            this.finalArrayforResche[i].tr_to_time ==
            this.selDatesforReschedule[k].tr_to_time
          ) {
            this.selDatesforReschedule[k].checked = false;
          }
        }
      }
    } else if (!checked && day == 'Wednesday') {
      this.rewednesdayInputArray.forEach((data) => {
        if (data.re_from_time == datas.re_from_time) {
          this.forArray = this.forArray.filter(
            (obj) => obj.dates !== datas.dates
          );
          this.forArray.push(data);
          this.reisCheckedOrNotfalse();
        }
      });
    } else if (checked && day == 'Thursday') {
      this.rethursdayInputArray.forEach((data) => {
        if (data.re_from_time !== datas.re_from_time) {
          data.checked = false;
        }
        if (data.re_from_time == datas.re_from_time) {
          this.forArray = this.forArray.filter(
            (obj) => obj.dates !== datas.dates
          );
          this.forArray.push(data);
          this.reisCheckedOrNot();
        }
      });

      for (let i = 0; i < this.finalArrayforResche.length; i++) {
        for (let k = 0; k < this.selDatesforReschedule.length; k++) {
          if (
            this.finalArrayforResche[i].dates ==
            this.selDatesforReschedule[k].dates &&
            this.finalArrayforResche[i].tr_from_time ==
            this.selDatesforReschedule[k].tr_from_time &&
            this.finalArrayforResche[i].tr_to_time ==
            this.selDatesforReschedule[k].tr_to_time
          ) {
            this.selDatesforReschedule[k].checked = false;
          }
        }
      }
    } else if (!checked && day == 'Thursday') {
      this.rethursdayInputArray.forEach((data) => {
        if (data.re_from_time == datas.re_from_time) {
          this.forArray = this.forArray.filter(
            (obj) => obj.dates !== datas.dates
          );
          this.forArray.push(data);
          this.reisCheckedOrNotfalse();
        }
      });
    } else if (checked && day == 'Friday') {
      this.refridayInputArray.forEach((data) => {
        if (data.re_from_time !== datas.re_from_time) {
          data.checked = false;
        }
        if (data.re_from_time == datas.re_from_time) {
          this.forArray = this.forArray.filter(
            (obj) => obj.dates !== datas.dates
          );
          this.forArray.push(data);
          this.reisCheckedOrNot();
        }
      });
      for (let i = 0; i < this.finalArrayforResche.length; i++) {
        for (let k = 0; k < this.selDatesforReschedule.length; k++) {
          if (
            this.finalArrayforResche[i].dates ==
            this.selDatesforReschedule[k].dates &&
            this.finalArrayforResche[i].tr_from_time ==
            this.selDatesforReschedule[k].tr_from_time &&
            this.finalArrayforResche[i].tr_to_time ==
            this.selDatesforReschedule[k].tr_to_time
          ) {
            this.selDatesforReschedule[k].checked = false;
          }
        }
      }
    } else if (!checked && day == 'Friday') {
      this.refridayInputArray.forEach((data) => {
        if (data.re_from_time == datas.re_from_time) {
          this.forArray = this.forArray.filter(
            (obj) => obj.dates !== datas.dates
          );
          this.forArray.push(data);
          this.reisCheckedOrNotfalse();
        }
      });
    } else if (checked && day == 'Saturday') {
      this.resaturdayInputArray.forEach((data) => {
        if (data.re_from_time !== datas.re_from_time) {
          data.checked = false;
        }
        if (data.re_from_time == datas.re_from_time) {
          this.forArray = this.forArray.filter(
            (obj) => obj.dates !== datas.dates
          );
          this.forArray.push(data);
          this.reisCheckedOrNot();
        }
      });

      for (let i = 0; i < this.finalArrayforResche.length; i++) {
        for (let k = 0; k < this.selDatesforReschedule.length; k++) {
          if (
            this.finalArrayforResche[i].dates ==
            this.selDatesforReschedule[k].dates &&
            this.finalArrayforResche[i].tr_from_time ==
            this.selDatesforReschedule[k].tr_from_time &&
            this.finalArrayforResche[i].tr_to_time ==
            this.selDatesforReschedule[k].tr_to_time
          ) {
            this.selDatesforReschedule[k].checked = false;
          }
        }
      }
    } else if (!checked && day == 'Saturday') {
      this.resaturdayInputArray.forEach((data) => {
        if (data.re_from_time == datas.re_from_time) {
          this.forArray = this.forArray.filter(
            (obj) => obj.dates !== datas.dates
          );
          this.forArray.push(data);
          this.reisCheckedOrNotfalse();
        }
      });
    } else if (checked && day == 'Sunday') {
      // If the current checkbox is checked, uncheck other checkboxes
      this.resundayInputArray.forEach((data) => {
        if (data.re_from_time !== datas.re_from_time) {
          data.checked = false;
        }
        if (data.re_from_time == datas.re_from_time) {
          this.forArray = this.forArray.filter(
            (obj) => obj.dates !== datas.dates
          );
          this.forArray.push(data);
          this.reisCheckedOrNot();
        }
      });

      for (let i = 0; i < this.finalArrayforResche.length; i++) {
        for (let k = 0; k < this.selDatesforReschedule.length; k++) {
          if (
            this.finalArrayforResche[i].dates ==
            this.selDatesforReschedule[k].dates &&
            this.finalArrayforResche[i].tr_from_time ==
            this.selDatesforReschedule[k].tr_from_time &&
            this.finalArrayforResche[i].tr_to_time ==
            this.selDatesforReschedule[k].tr_to_time
          ) {
            this.selDatesforReschedule[k].checked = false;
          }
        }
      }
    } else if (!checked && day == 'Sunday') {
      this.resundayInputArray.forEach((data) => {
        if (data.re_from_time == datas.re_from_time) {
          this.forArray = this.forArray.filter(
            (obj) => obj.dates !== datas.dates
          );
          this.forArray.push(data);
          this.reisCheckedOrNotfalse();
        }
      });
    }
    const filterCheck = this.selDatesforReschedule.filter(item => item.checked)
    if (filterCheck.length > 0) {
      this.isUpdateButton = 1;
    } else {
      this.isUpdateButton = 0;
    }

  }

  reisCheckedOrNot() {
    for (let i = 0; i <= this.selDatesforReschedule.length; i++) {
      if (this.selDatesforReschedule[i] != undefined) {
        for (let j = 0; j <= this.forArray.length; j++) {
          if (this.forArray[j] != undefined) {
            if (this.selDatesforReschedule[i].dates == this.forArray[j].dates &&
              this.selDatesforReschedule[i].tr_from_time ==
              this.forArray[j].re_from_time &&
              this.selDatesforReschedule[i].tr_to_time ==
              this.forArray[j].re_to_time &&
              this.forArray[j].checked != false) {
              this.selDatesforReschedule[i].checked = true;
            }
          }
        }
      }
    }
  }

  MyScheduleDates(datas) {
    this.remainSaveSessions = null;
    this.saveAvailable = null;
    this.clearDatas();
    this.clearCalendarData();
    this.isAndroid = null;
    this.isIos = null;
    if (this.platform.is('ios')) {
      this.isIos = 1;
    } else if (this.platform.is('android')) {
      this.isAndroid = 1;
    }
    this.myScheduleDates = [];
    let apiData = JSON.stringify({
      patientId: localStorage.getItem('patient_id'),
      trainerId: datas.trainer_id,
      packageId: datas.package_id,
      memBookingId: datas.trainerBookingId,
    });

    this.services.postRequest1('getMyscheduleDates', apiData).subscribe(async (res) => {

      this.myScheduleDates = res.data[0].details;
      const mycompletedDates = res.data[0].details[0].completed_days == null
        || res.data[0].details[0].completed_days == undefined ? "" :
        res.data[0].details[0].completed_days?.split(',');

      const myRemainDates = res.data[0].details[0].remaining_days == null ||
        res.data[0].details[0].remaining_days == undefined ? "" :
        res.data[0].details[0].remaining_days?.split(',');

      const mytobeReschedule = res.data[0].details[0].tobe_reschedule == null ||
        res.data[0].details[0].tobe_reschedule == undefined ? "" :
        res.data[0].details[0].tobe_reschedule?.split(',');

      const myRescheduled = res.data[0].details[0].rescheduled_date == null ||
        res.data[0].details[0].rescheduled_date == undefined ? "" :
        res.data[0].details[0].rescheduled_date?.split(',');

      let finalDate = res.data[0].details.filter(entry => !myRemainDates.includes(entry.dates));
      finalDate = finalDate.filter(entry => !mytobeReschedule.includes(entry.dates));
      finalDate = finalDate.filter(entry => !myRescheduled.includes(entry.dates));
      finalDate = finalDate.filter(entry => !mycompletedDates.includes(entry.dates));
      let HomeFiltered = [];
      HomeFiltered = finalDate.filter(element => element.tr_training_mode == "1" && element.home_rechedule != 0);
      if(finalDate[0]?.tr_training_mode == "1"){
        finalDate = HomeFiltered;
      }else{
        finalDate = finalDate;
      }


      this.selDatesforReschedule = [];
      this.selDatesforReschedule = finalDate;
      this.remainSaveSessions = res.data[0].details[0].remainSessions;
      this.saveAvailable = res.data[0].details[0].saveSelect;
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1;
      this.representMonth = currentMonth;
      this.representYear = currentDate.getFullYear();

      if (this.saveAvailable == 1) {
        this.isAvailableDatefor = this.remainSaveSessions;
      } else {
        this.isAvailableDatefor = 0;
      }
    });
  }


  bindMyschedulesDates() {
    this.clearCalendarData();
    this.myScheduleDates.forEach((item) => {
      this.mycompletedDates.push(item.completed_days);
      this.myRemainDates.push(item.remaining_days);
      this.mytobeReschedule.push(item.tobe_reschedule);
      this.myRescheduled.push(item.rescheduled_date);
    });
    //CompletedDates
    if (this.mycompletedDates[0] != null && this.mycompletedDates[0] != undefined ) {
      const complete = this.splitStringToArray(this.mycompletedDates[0]);
      const newDataArray = [];
      complete.forEach((innerArray) => {
        const [date] = innerArray;
        newDataArray.push(date);
      });
      this.totalcomplete = newDataArray;
      this.totalcomplete.forEach((item) => {
        this.mycompletedDatesfor.push(this.convertToShortYearFormat(item));
      });
      this.mycompletedDatesfor.forEach((item) => {
        this.finalmycompletedDates.push(this.dateChange(item));
      });
    }
    //Remainingdates
    if (this.myRemainDates[0] != null && this.myRemainDates[0] != undefined) {
      const remain = this.splitStringToArray(this.myRemainDates[0]);
      const newDataArray = [];
      remain.forEach((innerArray) => {
        const [date] = innerArray;
        newDataArray.push(date);
      });
      this.totalremain = newDataArray;
      this.totalremain.forEach((item) => {
        this.myRemainDatesfor.push(this.convertToShortYearFormat(item));
      });
      this.myRemainDatesfor.forEach((item) => {
        this.finalmyRemainDatesfor.push(this.dateChange(item));
      });

      const extractDates = [];
      this.selDatesforReschedule.forEach((item) => {
        extractDates.push(item.dates)
      });
      let uniqueArray = [...new Set(extractDates)];
      this.myScheduleAllDates = [];
      uniqueArray.forEach((item) => {
        this.myScheduleAllDates.push(this.splitDates(item));
      });
      const changedArr = [];
      uniqueArray.forEach((item) => {
        changedArr.push(this.convertToShortYearFormat(item));
      });
      this.saveDatesArray = [];
      changedArr.forEach((item) => {
        this.saveDatesArray.push(this.dateChange(item));
      });

    }
    //TobeRechedule
    if (this.mytobeReschedule[0] != null && this.mytobeReschedule[0] != undefined) {
      const remain = this.splitStringToArray(this.mytobeReschedule[0]);
      const newDataArray = [];
      remain.forEach((innerArray) => {
        const [date] = innerArray;
        newDataArray.push(date);
      });
      this.totalTobe = newDataArray;
      this.totalTobe.forEach((item) => {
        this.mytobeReschedulefor.push(this.convertToShortYearFormat(item));
      });
      this.mytobeReschedulefor.forEach((item) => {
        this.finalmytobeReschedulefor.push(this.dateChange(item));
      });
    }
    //Rescheduled
    if (this.myRescheduled[0] != null && this.myRescheduled[0] != undefined) {
      const remain = this.splitStringToArray(this.myRescheduled[0]);
      const newDataArray = [];
      remain.forEach((innerArray) => {
        const [date] = innerArray;
        newDataArray.push(date);
      });
      this.totalRescheduled = newDataArray;
      this.totalRescheduled.forEach((item) => {
        this.myRescheduledfor.push(this.convertToShortYearFormat(item));
      });

      this.myRescheduledfor.forEach((item) => {
        this.finalmyRescheduledfor.push(this.dateChange(item));
      });
    }

    this.DateForMyScheCalndar();
    this.isSave_slect = 1;
  }
  splitStringToArray(stringToSplit) {
    const datesArray = stringToSplit.split(',');
    return datesArray.map((dateString) =>
      dateString.split(',').map((date) => date)
    );
  }
  finalmycompletedDates1: any = [];
  finalmyRemainDatesfor1: any = [];
  finalmytobeReschedulefor1: any = [];
  finalmyRescheduledfor1: any = [];
  saveDatesArray1: any = [];
  DateForMyScheCalndar() {
    if (this.isSaveDates('')) {
    } else {
      this.saveDatesArray.forEach((item) => {
        this.saveDatesArray1.push(item);
      });
    }

    if (this.isCompletedDates('')) {
    } else {
      this.finalmycompletedDates.forEach((item) => {
        this.finalmycompletedDates1.push(item);
      });
    }

    if (this.isRemainDates('')) {
    } else {
      this.finalmyRemainDatesfor.forEach((item) => {
        this.finalmyRemainDatesfor1.push(item);
      });
    }

    if (this.isTobeRescheDates('')) {
    } else {
      this.finalmytobeReschedulefor.forEach((item) => {
        this.finalmytobeReschedulefor1.push(item);
      });
    }

    if (this.isRescheduleDates('')) {
    } else {
      this.finalmyRescheduledfor.forEach((item) => {
        this.finalmyRescheduledfor1.push(item);
      });
    }

  }

  isCompletedDates(dateOf: any): boolean {
    let foundValue;
    foundValue = this.finalmycompletedDates1.find(
      (element) => element === dateOf
    );
    return foundValue;
  }
  isRemainDates(dateOf: any): boolean {
    let foundValue;
    foundValue = this.finalmyRemainDatesfor1.find(
      (element) => element === dateOf
    );
    return foundValue;
  }
  isTobeRescheDates(dateOf: any): boolean {
    let foundValue;
    foundValue = this.finalmytobeReschedulefor1.find(
      (element) => element === dateOf
    );
    return foundValue;
  }
  isRescheduleDates(dateOf: any): boolean {
    let foundValue;
    foundValue = this.finalmyRescheduledfor1.find(
      (element) => element === dateOf
    );
    return foundValue;
  }
  isSaveDates(dateOf: any): boolean {
    let foundValue;
    foundValue = this.saveDatesArray1.find((element) => element === dateOf);
    return foundValue;
  }
  noSaveDates(dateOf: any): boolean {
    let foundValue;
    foundValue = this.saveDatesArray1.find((element) => element !== dateOf);
    return foundValue;
  }

  clearCalendarData() {
    this.mycompletedDates = [];
    this.myRemainDates = [];
    this.mytobeReschedule = [];
    this.myRescheduled = [];

    this.mycompletedDatesfor = [];
    this.myRemainDatesfor = [];
    this.mytobeReschedulefor = [];
    this.myRescheduledfor = [];

    this.finalmycompletedDates = [];
    this.finalmyRemainDatesfor = [];
    this.finalmytobeReschedulefor = [];
    this.finalmyRescheduledfor = [];

    this.totalremain = [];
    this.totalcomplete = [];
    this.totalTobe = [];
    this.totalRescheduled = [];

    this.finalmycompletedDates1 = [];
    this.finalmyRemainDatesfor1 = [];
    this.finalmytobeReschedulefor1 = [];
    this.finalmyRescheduledfor1 = [];

    this.arrayforHome = [];
    this.saveDatesArray = [];
    this.saveDatesArray1 = [];
  }

  convertToMonthString(dateString) {
    let parts = dateString.split('-');
    let monthAbbreviations;
    if (this.addCall.selectedLanguage == 'ea') {
      monthAbbreviations = {
        '01': 'يناير',
        '02': 'فبراير',
        '03': 'مارس',
        '04': 'أبريل',
        '05': 'مايو',
        '06': 'يونيو',
        '07': 'يوليو',
        '08': 'أغسطس',
        '09': 'سبتمبر',
        '10': 'أكتوبر',
        '11': 'نوفمبر',
        '12': 'ديسمبر',
      };

    } else {
      monthAbbreviations = {
        '01': 'Jan',
        '02': 'Feb',
        '03': 'Mar',
        '04': 'Apr',
        '05': 'May',
        '06': 'Jun',
        '07': 'Jul',
        '08': 'Aug',
        '09': 'Sep',
        '10': 'Oct',
        '11': 'Nov',
        '12': 'Dec',
      };
    }

    let monthAbbreviation = monthAbbreviations[parts[1]];
    let formattedDate =
      parts[0] + '-' + monthAbbreviation + '-' + parts[2].substring(2);
    return formattedDate;
  }

  async showKnetPaymentDetals(data: any, msg: string) {
    const modal = await this.modalCtrl.create({
      component: knetPaymentDetailsPage,
      backdropDismiss: false,
      cssClass: 'custom-popupfordeals',
      componentProps: {
        titleContent: msg,
        messageContent: data,
      },
    });

    modal.onDidDismiss().then(async (data) => {
      if (msg === this.addCall.title620) {
        this.router.navigate(['payment', { paymentstatus: 1 }]);
      }
    });
    return await modal.present();
  }

  selectedDealdata(data) {
    if (data != null && data.data != undefined) {
      if (
        data.data.packdet == 'NotSelected' &&
        this.selectedPackageArray.length > 0
      ) {
        this.avail_book = true;
      } else {
        this.toChange = [];
        this.selectedPackageArray = [];
        this.toChange = data.data.packdet;
        if (this.toChange != null && this.toChange != undefined) {
          this.toChange.forEach((item) => {
            this.selectedPackageArray.push(item);
          });
        }
        this.filterWeeks = [];
        this.indexofWeek = '';
        this.clearValues();
        this.packdet = data.data.packdet[0];
        this.cho = data.data.coh;
        this.package_detail(this.packdet, this.cho, '');
        this.LoadCalenar('Manual');
      }
    }
  }
  trainerOnline: any;
  CommonDates: any = [];
  OnlineApi(modeOf) {
    this.CommonDates = [];
    if (this.trainerOnline) {
      this.trainerOnline.unsubscribe();
    }
    let apiData = {
      patientId: localStorage.getItem('patient_id'),
      trainerId: this.repeatBkgData.tr_vendor_id,
      packageId: this.repeatBkgData.package_id,
    };

    this.trainerOnline = this.services
      .postRequest1('getOnlineDates', apiData)
      .subscribe(async (res: any) => {
        if (res.status != 0) {
          for (let i = 0; i <= res.data.length; i++) {
            if (res.data[i] != undefined) {
              this.CommonDates.push({
                tr_slot_duration: this.modeDetails[0].tr_slot_duration,
                tr_no_of_slots: this.modeDetails[0].tr_no_of_slots,
                tr_vendor_id: this.modeDetails[0].tr_vendor_id,
                tr_package_id: this.modeDetails[0].tr_package_id,
                tr_training_mode: this.modeDetails[0].tr_training_mode,
                is_vip: this.modeDetails[0].is_vip,
                tr_package_name: this.modeDetails[0].tr_package_name,
                tr_tainingcategory_id:
                  this.modeDetails[0].tr_tainingcategory_id,
                tr_training_id: this.modeDetails[0].tr_training_id,
                tr_session: this.modeDetails[0].tr_session,
                tr_cost: this.modeDetails[0].tr_cost,
                tr_max_booking: this.modeDetails[0].tr_max_booking,
                tr_package_details: this.modeDetails[0].tr_package_details,
                tr_package_profile_path:
                  this.modeDetails[0].tr_package_profile_path,
                tr_package_status: this.modeDetails[0].tr_package_status,
                tr_reschedule: this.modeDetails[0].tr_reschedule,
                dealId: this.modeDetails[0].dealId,
                dealName: this.modeDetails[0].dealName,
                dealOption: this.modeDetails[0].dealOption,
                dealValue: this.modeDetails[0].dealValue,
                programDays: this.modeDetails[0].programDays,
                featuresList: this.modeDetails[0].featuresList,
                dealserviceid: this.modeDetails[0].dealserviceid,
                defaultTrainingMode: this.modeDetails[0].defaultTrainingMode,
                ProgDays1: [], //this.totalPackagesArray[0].ProgDays1,
                ProgDays2: [], //this.totalPackagesArray[0].ProgDays2,
                appointmentScheduleId: res.data[i].appointmentScheduleId,
                tr_from_time: res.data[i].tr_from_time,
                tr_to_time: res.data[i].tr_to_time,
                days: res.data[i].days,
                dates: res.data[i].dates,
                WeekDay: res.data[i].WeekDay,
                month: res.data[i].month,
                monthName: res.data[i].monthName,
                year: res.data[i].year,
                remainMode_isReche: res.data[i].remainMode_isReche,
                isReschedule: res.data[i].isReschedule,
              });
            }
          }
        }
        this.selectedPackageArray = [];
        if (this.CommonDates.length != 0 && this.CommonDates != undefined) {
          this.CommonDates.forEach((item) => {
            this.selectedPackageArray.push(item);
          });
        }
        this.filterWeeks = [];
        this.indexofWeek = '';
        this.packdet = this.CommonDates[0];
        this.cho = modeOf;
        this.package_detail(this.packdet, this.cho, 'repeat');
        this.LoadCalenar('Manual');
      });
  }
  modeDetails: any = [];
  async chsOffHiglight(value) {
    let getDate = new Date();

    let currentDate =
      getDate.getFullYear() +
      '-' +
      ('0' + (getDate.getMonth() + 1)).slice(-2) +
      '-' +
      ('0' + getDate.getDate()).slice(-2);
    if (value == 'homeList') {
      this.modeDetails = [];
      const loading = await this.loadingController.create({
        cssClass: 'my-custom-class',
        message: 'Please wait...',
      });
      await loading.present();
      let reqestData = {
        trainerId: this.repeatBkgData.tr_vendor_id,
        trainingId: 1,
        currentDate: currentDate,
        patientId: localStorage.getItem('patient_id'),
        packageId: this.repeatBkgData.package_id,
      };

      this.services
        .postRequest1('getRepeatTrainerList', reqestData)
        .subscribe(async (res: any) => {
          await loading.dismiss();
          this.modeDetails = res.data.filter(
            (element) => element.packofId == this.repeatBkgData.package_id
          );
          this.homeApi(value);
        });
    } else if (value == 'onlineList') {
      this.modeDetails = [];
      const loading = await this.loadingController.create({
        cssClass: 'my-custom-class',
        message: 'Please wait...',
      });

      await loading.present();
      let reqestData = {
        trainerId: this.repeatBkgData.tr_vendor_id,
        trainingId: 1,
        currentDate: currentDate,
        patientId: localStorage.getItem('patient_id'),
        packageId: this.repeatBkgData.package_id,
      };
      this.services
        .postRequest1('getRepeatTrainerList', reqestData)
        .subscribe(async (res: any) => {
          await loading.dismiss();
          this.modeDetails = res.data.filter(
            (element) => element.packofId == this.repeatBkgData.package_id
          );
          this.OnlineApi(value);
        });
    } else if (value == 'centerList') {
      this.modeDetails = [];
      const loading = await this.loadingController.create({
        cssClass: 'my-custom-class',
        message: 'Please wait...',
      });
      await loading.present();
      let reqestData = {
        trainerId: this.repeatBkgData.tr_vendor_id,
        trainingId: 1,
        currentDate: currentDate,
        patientId: localStorage.getItem('patient_id'),
        packageId: this.repeatBkgData.package_id,
      };

      this.services
        .postRequest1('getRepeatTrainerList', reqestData)
        .subscribe(async (res: any) => {
          await loading.dismiss();
          this.modeDetails = res.data.filter(
            (element) => element.packofId == this.repeatBkgData.package_id
          );
          this.OnlineApi(value);
        });
    }
  }
  trainerHome: any;
  async homeApi(modeOf) {
    this.CommonDates = [];
    if (this.trainerHome) {
      this.trainerHome.unsubscribe();
    }

    let apiData = {
      patientId: localStorage.getItem('patient_id'),
      trainerId: this.repeatBkgData.tr_vendor_id,
      packageId: this.repeatBkgData.package_id,
    };

    this.trainerHome = this.services
      .postRequest1('getHomeDates', apiData)
      .subscribe(async (res: any) => {
        if (res.status != 0) {
          for (let i = 0; i <= res.data.length; i++) {
            if (res.data[i] != undefined) {
              this.CommonDates.push({
                tr_slot_duration: this.modeDetails[0].tr_slot_duration,
                tr_no_of_slots: this.modeDetails[0].tr_no_of_slots,
                tr_vendor_id: this.modeDetails[0].tr_vendor_id,
                tr_package_id: this.modeDetails[0].tr_package_id,
                tr_training_mode: this.modeDetails[0].tr_training_mode,
                is_vip: this.modeDetails[0].is_vip,
                tr_package_name: this.modeDetails[0].tr_package_name,
                tr_tainingcategory_id:
                  this.modeDetails[0].tr_tainingcategory_id,
                tr_training_id: this.modeDetails[0].tr_training_id,
                tr_session: this.modeDetails[0].tr_session,
                tr_cost: this.modeDetails[0].tr_cost,
                tr_max_booking: this.modeDetails[0].tr_max_booking,
                tr_package_details: this.modeDetails[0].tr_package_details,
                tr_package_profile_path:
                  this.modeDetails[0].tr_package_profile_path,
                tr_package_status: this.modeDetails[0].tr_package_status,
                tr_reschedule: this.modeDetails[0].tr_reschedule,
                dealId: this.modeDetails[0].dealId,
                dealName: this.modeDetails[0].dealName,
                dealOption: this.modeDetails[0].dealOption,
                dealValue: this.modeDetails[0].dealValue,
                programDays: this.modeDetails[0].programDays,
                featuresList: this.modeDetails[0].featuresList,
                dealserviceid: this.modeDetails[0].dealserviceid,
                defaultTrainingMode: this.modeDetails[0].defaultTrainingMode,
                ProgDays1: [], //this.totalPackagesArray[0].ProgDays1,
                ProgDays2: [], //this.totalPackagesArray[0].ProgDays2,
                appointmentScheduleId: res.data[i].appointmentScheduleId,
                tr_from_time: res.data[i].tr_from_time,
                tr_to_time: res.data[i].tr_to_time,
                days: res.data[i].days,
                dates: res.data[i].dates,
                WeekDay: res.data[i].WeekDay,
                month: res.data[i].month,
                monthName: res.data[i].monthName,
                year: res.data[i].year,
                remainMode_isReche: res.data[i].remainMode_isReche,
                isReschedule: res.data[i].isReschedule,
              });
            }
          }
        }
        this.selectedPackageArray = [];
        if (this.CommonDates.length != 0 && this.CommonDates != undefined) {
          this.CommonDates.forEach((item) => {
            this.selectedPackageArray.push(item);
          });
        }
        this.filterWeeks = [];
        this.indexofWeek = '';
        this.packdet = this.CommonDates[0];
        this.cho = modeOf;
        this.package_detail(this.packdet, this.cho, 'repeat');
        this.LoadCalenar('Manual');
      });
  }
  sanitizeInput(event: any) {
    const input = event.target.value;
    event.target.value = input.replace(/e/g, ''); // Remove occurrences of 'e'
    if (event.data == "e" || event.data == ".") {
      // this.toastMessage = 'Please type numbers only';
      this.toastMessage = this.addCall.title726;
      this.presentToast();
    }

  }

  reisCheckedOrNotfalse() {
    for (let i = 0; i <= this.forArray.length; i++) {
      if (this.forArray[i] != undefined) {
        for (let j = 0; j <= this.selDatesforReschedule.length; j++) {
          if (this.selDatesforReschedule[j] != undefined) {
            if (this.forArray[i].dates == this.selDatesforReschedule[j].dates &&
              this.forArray[i].re_from_time ==
              this.selDatesforReschedule[j].tr_from_time &&
              this.forArray[i].re_to_time ==
              this.selDatesforReschedule[j].tr_to_time &&
              this.selDatesforReschedule[j].checked == true
            ) {
              this.selDatesforReschedule[j].checked = false;
            }
          }
        }
      }
    }
  }

  formatAmount(number) {
    const num = Number(number)
    const options = {
      minimumFractionDigits: 3,
      maximumFractionDigits: 3
    };
    const formattedNumber = num.toLocaleString('en-US', options);
    const parts = formattedNumber.split('.');

    if (parts.length === 1) {
      return `${formattedNumber}.000`;
    } else {
      const decimalPart = parts[1].padEnd(3, '0');
      return `${parts[0]}.${decimalPart}`;
    }
  }

  saveSeletDates: any = [];
  addDate(item) {

    const dateON = this.dateFormatOf(item.dateStrg);
    const filterArray = this.forCalendarFunc.filter(element => element == dateON)
    if (filterArray.length > 0) {
      this.forCalendarFunc = this.forCalendarFunc.filter(element => element != dateON);
      const checkDate = this.formatdateOf(dateON)
      for (let i = 0; i <= this.selDatesforReschedule.length; i++) {
        if (this.selDatesforReschedule[i] != undefined) {
          if (this.selDatesforReschedule[i].dates == checkDate && this.selDatesforReschedule[i].checked) {
            this.selDatesforReschedule[i].checked = false
          }
        }
      }
    } else {
      this.forCalendarFunc.push(dateON);
    }
    const filterCheck = this.selDatesforReschedule.filter(item => item.checked)
    if (filterCheck.length > 0) {
      this.isUpdateButton = 1;
    } else {
      this.isUpdateButton = 0;
    }

    if (this.saveSelected('')) {
    } else if (this.saveSeletDates.includes(item.dateStrg)) {
      this.saveSeletDates = this.saveSeletDates.filter(element => element !== item.dateStrg);
    } else {
      this.saveSeletDates.push(item.dateStrg);
    }
    this.reschedulecalculateOfWeeks('', '');
  }

  disableSaveDates(dateOf: any): boolean {
    if (this.forCalendarFunc.length >= this.remainSaveSessions) {
      let foundValue;
      foundValue = this.saveSeletDates.find((element) => element !== dateOf
      );
      return foundValue;
    }
  }

  saveSelected(dateOf: any): boolean {
    let foundValue;
    foundValue = this.saveSeletDates.find(
      (element) => element === dateOf
    );
    return foundValue;
  }

  dateFormatOf(dates) {
    const dateString = dates;
    const dateObj = new Date(dateString);
    const day = ("0" + dateObj.getDate()).slice(-2); // Ensure two digits
    const month = ("0" + (dateObj.getMonth() + 1)).slice(-2); // Ensure two digits
    const year = dateObj.getFullYear().toString().slice(-2); // Get last two digits of the year
    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate;
  }
  formatdateOf(dates) {
    const dateString = dates;
    const [day, month, yearShort] = dateString.split('-');
    const year = `20${yearShort}`;
    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate;
  }
  updateMySchedule() {
    let insertObj = [];
    let checkData = [];
    checkData = this.selDatesforReschedule.filter(item => item.checked);
    if(this.forCalendarFunc.length == checkData.length){
    if (this.selDatesforReschedule.length > 0) {
      this.selDatesforReschedule.forEach((item: any, index: any) => {
        if (item.checked) {
          insertObj.push({
            bookingId: item.bookingId,
            patientId: localStorage.getItem('patient_id'),
            trainerId: item.trainerId,
            packageId: item.packageId,
            dates: item.dates,
            fromtime: item.tr_from_time,
            totime: item.tr_to_time,
            days: item.days,
            months: item.month,
            year: item.year,
            totalSession: item.totalSession,
            bookSession: checkData.length,
            changeSaveSelect: 0
          });
        }
      });
      if (checkData.length > 0) {
        this.services.postRequest1('addSaveSelect', insertObj).subscribe((response) => {
          if (response.status != 0) {
            // this.AlertInfo("Bookings updated successfully.", response.status);
            this.AlertInfo(this.addCall.title717, response.status);
            setTimeout(() => {
              this.loadingController.dismiss();
            }, 300);

            this.pageNo = 1;
            this.storeBookingList = [];
            this.showBookinkList();
            this.clearDatas();
          }
        })
      }

    }}else{
      // this.toastMessage = 'Please select the remaining sessions';
      this.toastMessage = this.addCall.title727;
      this.presentToast();
    }
  }
  saveCliked(checked) {
    this.isSaveChecked = checked;
  }


  async OpenMapMethod(clinicname: any, clinic_address: any, clinic_lat_long: any) {
    const modal = await this.modalCtrl.create({
      component: SuccessPage,
      cssClass: 'mapmodel',
      componentProps: {
        typeValue: 33,
        clinicname: clinicname,
        clinic_address: clinic_address,
        clinic_lat_long: clinic_lat_long,
      }
    });
    modal.onDidDismiss();
      // .then((data) => {
      //   if (data.data == "Map_Not_Show") {
      //     this.ionViewWillEnter();
      //   }
      // });
    return await modal.present();
  }

  trMapOpen() {
    this.presentView = "maptab";
    setTimeout(() => {
      this.loadmap();
    }, 1000);
  }

  loadmap() {
    let latLng = new google.maps.LatLng(this.latitude, this.longitude);
    let mapOptions = {
      center: latLng,
      zoom: 15,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      map: this.map,
    };
    this.map = new google.maps.Map(this.mapElement.nativeElement, mapOptions);

    // Create a marker and set its position.
    let marker = new google.maps.Marker({
      position: latLng,
      map: this.map,
      title: "Current Location",
      animation: google.maps.Animation.DROP
    });

    // Configure the click listener.
    this.map.addListener("click", (mapsMouseEvent) => {
      let map_position = JSON.stringify(mapsMouseEvent.latLng.toJSON());
      let map_current_Lat_Long = JSON.parse(map_position);
      this.trLatitude = map_current_Lat_Long.lat;
      this.trLongtitude = map_current_Lat_Long.lng;

      // Update marker position.
      marker.setPosition(mapsMouseEvent.latLng);

      let url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${this.trLatitude}&lon=${this.trLongtitude}&zoom=18&addressdetails=1`;
      this.http.get(url).subscribe((res: any) => {
        let address_form = res.display_name;
        this.memberAddress = address_form;
        this.cdr.detectChanges();
      },
        (error) => {
          console.log(error, "map_error");
        }
      );
    });
  }

  goToBooking() {
    this.presentView = 'bookingConfirmPage1';
    this.isConfirmed = false

  }

  backToBooking(val) {
    this.presentView = 'bookingConfirmPage1';
  }

  trimAddress(address) {
    if (address.length > 10) {
      return address.substring(0, 10) + ' ...';
    }
    return address;
  }
  trimAddress1(address) {
    if (address.length > 7) {
      return address.substring(0, 7) + ' ...';
    }
    return address;
  }

  async Addaddress() {
    const alert = await this.modalCtrl.create({
      component: PrescriptionpopupPage,
      cssClass: 'Address_add',
      componentProps: {
        Address: this.memberAddress
      },
    });
    await alert.present();
    alert.onDidDismiss().then((data) => {
      this.memberAddress = data.data.status
    });
  }


  arabicWeek(data) {
    let weeksOff = ""
    if (data == "Week 1") {
      weeksOff = "أسبوع 1";
      return weeksOff
    } else if (data == "Week 2") {
      weeksOff = "أسبوع 2";
      return weeksOff
    } else if (data == "Week 3") {
      weeksOff = "أسبوع 3";
      return weeksOff
    } else if (data == "Week 4") {
      weeksOff = "أسبوع 4";
      return weeksOff
    } else if (data == "Week 5") {
      weeksOff = "أسبوع 5";
      return weeksOff
    }
  }


decryptContent(encryptedContent: string): string {
  try {
    const decryptedBytes = CryptoJS.AES.decrypt(encryptedContent, this.fkey, {
      iv: this.fiv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    return decryptedBytes.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    return error.message;
  }
}
formatDate1(date: Date): string {
  const day = date.getDate().toString().padStart(2, '0');
  const monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear().toString().slice(-2);
  return `${day}-${month}-${year}`;
}

openTerms() {
  const url = this.services.apiURL() + 'admin/decryptedMemberContent_data';
  const params = new HttpParams().set('vendorcategory', 'Trainer');

  this.httpClient.get<DecryptedMemberContentResponse>(url, { params })
    .subscribe(
      response => {
        if (response && response.data && response.data.length > 0) {
          const lastIndex = response.data.length - 1;
          this.terms_and_condition_file = response.data[lastIndex].Terms_and_conditions;
          const decryptedData = this.decryptContent(this.terms_and_condition_file);
          console.log("Decrypted data:", decryptedData);

          if (!decryptedData) {
            throw new Error('Decryption failed');
          }

          const content = htmlToPdfmake(decryptedData);
          console.log("PDF content:", content);

          if (!content || !Array.isArray(content)) {
            throw new Error('Invalid content structure');
          }

          const documentDefinition = {
            content: content,
            styles: {
              header: {
                fontSize: 12,
                bold: true,
                margin: [40, 10, 40, 10],
              },
              footer: {
                fontSize: 10,
                margin: [40, 0, 40, 0],
              },
              footerText: {
                fontSize: 10,
              },
            },
            header: (currentPage, pageCount, pageSize) => {
              const modified_on =  new Date();
              return {
                  text: ``,
                alignment: 'left',
                style: 'header',
                color: '#510F30',
                margin: [30, 40, 0, 0],
              };
            },
            footer: (currentPage, pageCount, pageSize) => {

              const modified_on =  new Date();

              return {
                margin: [40, 40, 40, 40],
                columns: [
                  {
                    stack: [
                      {
                        text: `Page ${currentPage}/${pageCount}`,
                        alignment: "right",
                        color: "#510F30",
                        style: "footerText",
                      },
                    ],
                  },
                ],
              };
            },
            pageMargins: [40, 70, 40, 180],
          };
          pdfMake.createPdf(documentDefinition).getBlob(async (blob: Blob) => {
            console.log("PDF Blob:", blob);
            try {
              const localBlob = new Blob([blob], { type: 'application/pdf' });
              const fileName = `report_${new Date().getTime()}.pdf`;
              await this.file.writeFile(this.file.dataDirectory, fileName, localBlob, { replace: true })
                .then((fileEntry) => {
                  console.log("File entry:", fileEntry);
                  this.fileOpener.open(fileEntry.nativeURL, 'application/pdf')
                    .then(() => console.log('File is opened'))
                    .catch(e => console.log('Error opening file', e));
                })
                .catch(e => console.log('Error writing file', e));
            } catch (error) {
              console.error('Error uploading file', error);
            }
          });

        } else {
          console.error('Unexpected response format:', response);
        }
      },
      error => {
        console.error('Error:', error);
      }
    );
}

splitDates(value){
  const dates = value.split("-");
  const fromDate = dates[2] + "-" + dates[1] + "-" + dates[0];
  return fromDate
}

}


